<template>
  <v-container fluid>
    <template v-if="numeroAsistencia">
      <MiniBitacora
        :numero-asistencia="numeroAsistencia"
        :isShowing="isShowing"
        :noAgregar="showBitacoraLegal"
        @update:isShowing="isShowing = $event"
      />
    </template>

    <v-bottom-sheet v-model="mostrarLinkWhatsapp" persistent>
      <v-sheet class="text-center" height="auto">
        <p class="py-3 mb-0 title">Los datos a enviar al cliente son:</p>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12" md="1">
              <v-text-field
                label="CODIGO"
                hint="ejemplo: +503"
                persistent-hint
                v-model="codigoSMS"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="helperNumeroTelefono"
                label="TELEFONO"
                hint="Sin separadores"
                persistent-hint
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-textarea
                solo
                auto-grow
                rows="1"
                label="DATOS"
                v-model="mensajeLinkEncuesta"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn
                class="mt-6"
                color="success"
                target="_blanck"
                :href="getWhatsAppURL"
                @click="clicked"
              >
                Enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- CONFIRM DIALOG -->
    <v-dialog v-model="dialogConfirm" max-width="450">
      <v-card class="py-3">
        <v-card-title class="headline"> Confirmación </v-card-title>
        <v-card-text class="subtitle-1 text-justify">
          Por favor, confirma si realmente deseas continuar. Recuerda que esta
          acción no se puede deshacer.
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" outlined @click="cerrarConfirmacion">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="verificarDigitadorAutorizado">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      :headers="headers"
      :items="cabinas"
      item-key="idCabina"
      :search="search"
      class="elevation-1"
      v-if="verNuevo == 0"
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cabina</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                icon
                color="green"
                @click="verificarUsuario()"
                v-bind="attrs"
                v-on="on"
                ><v-icon class="fa fa-sync-alt"></v-icon
              ></v-btn>
            </template>
            <span>Recargar</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-text-field
            class="text-xs-center"
            v-model="search"
            outlined
            dense
            append-icon="search"
            label="Busqueda"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            v-if="verNuevo == 0 && $store.state.usuario.rol != 'Inspector'"
            @click="mostrarNuevo()"
            color="primary"
            dark
            class="mb-2"
            >Nuevo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:body="{ items }">
        <tr
          v-for="item in items"
          :key="item.numeroAsistencia"
          :class="checkHighLightRow(item)"
        >
          <td class="text-center">
            <v-icon
              color="gray"
              @click="verDetalles(item)"
              v-if="estatusAcciones('Editar')"
              class="mx-1"
            >
              tab
            </v-icon>
            <v-icon
              color="primary"
              @click="oneDrive(item)"
              v-if="estatusAcciones('One Drive')"
              class="mx-1"
            >
              fas fa-cloud
            </v-icon>
            <v-icon
              color="blue"
              @click="notificacionTelegram(item)"
              v-if="$store.state.usuario.rol != 'Inspector'"
              class="mx-1"
            >
              fab fa-telegram
            </v-icon>
            <v-tooltip
              top
              color="#6b705c"
              dark
              v-if="hasBoleta(item.tipoAsistencia)"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mx-1"
                  @click="openBoletaProveedor(item.numeroAsistencia)"
                  v-bind="attrs"
                  v-on="on"
                >
                  fas fa-receipt
                </v-icon>
              </template>
              <span>Ver Boleta</span>
            </v-tooltip>
            <v-tooltip
              top
              color="indigo"
              dark
              v-if="hasBoleta(item.tipoAsistencia)"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mx-1"
                  @click="generarBoletaElectronica(item.numeroAsistencia)"
                  v-bind="attrs"
                  v-on="on"
                  color="indigo"
                >
                  fas fa-sync
                </v-icon>
              </template>
              <span>Regenerar Boleta</span>
            </v-tooltip>
          </td>
          <td>{{ item.expediente }}</td>
          <td>{{ item.numeroAsistencia }}</td>
          <td>{{ item.cartera }}</td>
          <td>{{ item.estatusAsistencia }}</td>
          <td>{{ formatoFecha(item.fechaHoraActual) }}</td>
          <td>{{ item.proveedor }}</td>
          <td>{{ item.tipoAsistencia }}</td>
          <td>{{ item.tipoServicio }}</td>
          <td>{{ item.numeroTelefono }}</td>
          <td>{{ item.placa }}</td>
          <td>{{ item.poliza }}</td>
          <td>{{ item.marca }}</td>
          <td>{{ item.modelo }}</td>
          <td>{{ item.año }}</td>
          <td>{{ item.titularPoliza }}</td>
          <td>{{ item.operador }}</td>
        </tr>
      </template>
    </v-data-table>

    <!-- PreLoader -->
    <v-overlay v-model="overlay" z-index="0">
      <lottie-player
        autoplay
        loop
        mode="normal"
        src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
        style="width: 320px"
      >
      </lottie-player>
    </v-overlay>
    <v-overlay v-model="overlayArchivos" z-index="1">
      <lottie-player
        autoplay
        loop
        mode="normal"
        src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
        style="width: 320px"
      >
      </lottie-player>
    </v-overlay>

    <v-snackbar v-model="snackError" color="cyan darken-2" bottom left
      >LOS CAMPOS NO PUEDEN QUEDAR VACIOS.</v-snackbar
    >
    <v-snackbar v-model="snackErrorListar" color="cyan darken-2" top
      >SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A
      INTENTAR.</v-snackbar
    >
    <v-snackbar v-model="snackArchivoSubido" color="cyan darken-2" bottom left
      >LOS ARCHIVOS SE CARGARON CON EXITO.</v-snackbar
    >
    <v-snackbar
      v-model="snackArchivoEliminado"
      color="cyan darken-2"
      bottom
      left
      >ARCHIVOS ELIMINADO CON EXITO.</v-snackbar
    >
    <v-snackbar v-model="snackBarGlobal" color="cyan darken-2" bottom right>{{
      snackBarGlobalText
    }}</v-snackbar>

    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <!-- Formulario nueva asistencia-->
    <v-container class="pa-2 white" v-if="verNuevo" fluid>
      <v-form ref="form" v-model="valid">
        <!--Contenedor para cliente -->
        <v-form ref="fCliente">
          <v-container class="mt-1">
            <v-card
              outlined
              width="100%"
              class="pa-2"
              elevation="1"
              style="border: 1px solid black"
            >
              <v-toolbar flat>
                <v-row>
                  <v-col cols="auto" class="px-0">
                    <v-toolbar-title class="font-weight-bold"
                      >Datos del cliente</v-toolbar-title
                    >
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col
                    class="red--text"
                    v-if="
                      morosidad &&
                      dañosPropios &&
                      cartera == 'ASSA COMPAÑIA DE SEGUROS'
                    "
                    >Morosidad: <b>{{ morosidad }}</b
                    >; Daños Propios: <b>{{ dañosPropios }}</b></v-col
                  >
                  <v-spacer></v-spacer>
                  <v-col cols="2" align-self="center">
                    <v-text-field
                      v-model="expediente"
                      label="Expediente"
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-toolbar>
              <v-row justify="space-between">
                <v-col cols="12" md="1" align-self="center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        block
                        :disabled="btnSheetReincidencia"
                        @click="listarReincidencia()"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="blue" class="fas fa-tasks"> </v-icon>
                      </v-btn>
                    </template>
                    <span>Mostrar reincidencia</span>
                  </v-tooltip>
                </v-col>
                <template>
                  <v-col cols="12" md="3">
                    <v-text-field
                      @keyup.enter="buscarPlaca()"
                      v-model="placa"
                      label="Placa"
                      clearable
                      hint="PRESIONE ENTER"
                      persistent-hint
                      :rules="campoRequerido"
                      counter="25"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      @keyup.enter="buscarPoliza()"
                      v-model="poliza"
                      label="Poliza"
                      clearable
                      hint="PRESIONE ENTER"
                      persistent-hint
                      :rules="campoRequerido"
                      counter="35"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="marca"
                      label="Marca"
                      clearable
                      :rules="campoRequerido"
                      counter="35"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="modelo"
                      label="Modelo"
                      clearable
                      :rules="campoRequerido"
                      counter="35"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      type="number"
                      v-model="año"
                      label="Año"
                      clearable
                      :rules="campoRequerido"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="color"
                      label="Color"
                      :rules="campoRequerido"
                      counter="35"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="uso"
                      label="Uso"
                      clearable
                      :rules="campoRequerido"
                      counter="50"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="titularPoliza"
                      label="Titular Poliza"
                      clearable
                      :rules="campoRequerido"
                      counter="500"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="nombreConductor"
                      label="Nombre conductor"
                      :rules="campoRequerido"
                      counter
                      maxlength="500"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="relacionTitularId"
                      label="Relación con Titular"
                      item-text="nombre"
                      item-value="relacionTitularId"
                      :items="relacionTitular"
                      :rules="campoRequerido"
                      counter
                      clearable
                      maxlength="40"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="numeroTelefono"
                      label="Número de Teléfono"
                      :rules="campoRequerido"
                      counter
                      clearable
                      maxlength="40"
                    >
                      <template v-slot:prepend-inner>
                        <WhatsAppDialog
                          v-if="numeroTelefono && proveedor && numeroAsistencia"
                          :numeroCliente="numeroTelefono"
                          :proveedorId="proveedor"
                          :numeroAsistenciaComun="numeroAsistencia"
                        />
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      v-model="metodoSolicitudAsistencia"
                      label="Método de solicitud"
                      :items="list_metodoSolicitud"
                      counter
                      clearable
                      maxlength="40"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="numeroTelefono2"
                      label="Número de Teléfono (opcional)"
                      counter
                      clearable
                      maxlength="40"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="numeroTelefono3"
                      label="Número de Teléfono (opcional)"
                      counter
                      clearable
                      maxlength="40"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="cartera"
                      :items="list_cartera"
                      item-text="nombre"
                      item-value="nombre"
                      label="Cartera"
                      clearable
                      :rules="campoRequerido"
                      @click="carteras()"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="num_chasis"
                      label="Número chasis"
                      hint="PRESIONE ENTER"
                      persistent-hint
                      @keyup.enter="buscarVehiculoPorCampo('vin', num_chasis)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="num_motor"
                      label="Número motor"
                      hint="PRESIONE ENTER"
                      persistent-hint
                      @keyup.enter="buscarVehiculoPorCampo('motor', num_motor)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2" v-if="cartera == 'VANGRUPO'">
                    <MiniVanGrupo
                      :van-grupo-id="vanGrupoId"
                      @cliente-seleccionado="vanGrupoCliente = $event"
                      :disabled="
                        numeroAsistencia != '' && numeroAsistencia != null
                      "
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="verDetallesAperturaCierre()"
                          v-if="tipoServicio == 'ADICIONAL'"
                          >Detalles</v-btn
                        >
                      </template>
                      <span>Campos para apertura y cierre</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      v-model="rapiASSAPlataforma"
                      label="RapiASSA Plataforma"
                      :items="rapiAssaOpciones"
                      :rules="
                        (tipoAsistencia == 'AJUSTE' ||
                          tipoAsistencia == 'INSPECCION ON LINE') &&
                        cartera == 'ASSA COMPAÑIA DE SEGUROS'
                          ? campoRequerido
                          : []
                      "
                      counter
                      maxlength="40"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" v-if="cartera == 'VANGRUPO'">
                    <v-text-field
                      v-model="vanGrupoEmpresa"
                      label="VanGrupo Empresa"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" v-if="errorPlaca">
                    <div class="red--text" v-text="errorPlaca"></div>
                  </v-col>
                </template>
              </v-row>
            </v-card>
          </v-container>
        </v-form>
        <!--Contenedor para datos del servicio -->
        <v-container class="mt-1">
          <v-card
            outlined
            width="100%"
            class="pa-2"
            elevation="1"
            style="border: 1px solid black"
          >
            <v-card-title class="pa-0">Datos del servicio</v-card-title>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="fechaHoraOcurrencia"
                  label="Fecha Ocurrencia"
                  type="datetime-local"
                  step="1"
                  clearable
                  :rules="campoRequerido"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-combobox
                  v-model="conductor_grua"
                  :items="list_conductor_grua"
                  item-text="nombre"
                  item-value="nombre"
                  :return-object="false"
                  label="Operador grúa"
                  readonly
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="proveedor"
                  :items="list_proveedor"
                  item-text="nombre"
                  item-value="idProveedor"
                  label="Proveedor"
                  @input="autoCompFechaAsignacion()"
                  clearable
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="2"
                class="d-flex justify-center align-center"
              >
                <v-switch
                  v-model="fueraTurno"
                  inset
                  class="pt-0 mt-3"
                  color="primary"
                  label="Fuera de Turno"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="fechaHoraAsignacion"
                  label="Fecha Asignacion"
                  step="1"
                  :disabled="textFieldAsignacionDisabled"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="align-self-center">
                <v-autocomplete
                  v-model="pais"
                  :items="list_pais"
                  label="Pais"
                  clearable
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" class="align-self-center">
                <v-autocomplete
                  v-model="depaSiniestro"
                  :items="list_depaSiniestro"
                  label="Departamento Siniestro"
                  clearable
                  @input="listaMunicipioSiniestro"
                  persistent-hint
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" class="align-self-center">
                <v-autocomplete
                  v-model="muniSiniestro"
                  :items="list_muniSiniestro"
                  label="Municipio Siniestro"
                  :background-color="colorSiniestro"
                  clearable
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea
                  v-model="comDireccionSiniestro"
                  label="Complemento Direccion Siniestro"
                  :rules="campoRequerido"
                  counter
                  maxlength="1000"
                  auto-grow
                  row-height="0"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="tipoAsistencia"
                  :items="list_tipoAsistencia"
                  item-text="nombre"
                  item-value="nombre"
                  label="Tipo De Asistencia"
                  clearable
                  :rules="campoRequerido"
                  @change="autoCompleteDatosAjustador()"
                  @click="tipoAsistencias()"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" v-if="tipoAsistencia == 'QUEJA'">
                <v-autocomplete
                  v-model="tipoQuejaId"
                  label="Tipo Queja"
                  item-text="tipo"
                  item-value="tipoQuejaId"
                  :items="tipoQueja"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="2"
                v-if="tipoAsistencia == 'INSPECCION ON LINE'"
              >
                <v-autocomplete
                  v-model="tipoInspeccionId"
                  label="¿Por qué no se dio inspección en línea?"
                  item-text="tipo"
                  item-value="tipoInspeccionId"
                  :items="tipoInspeccionOnline"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" :md="tipoAsistencia == 'QUEJA' ? '2' : '3'">
                <v-text-field
                  v-model="pretencionInicial"
                  label="Pretención inicial"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" :md="tipoAsistencia == 'QUEJA' ? '2' : '3'">
                <v-text-field
                  v-model="pretencionFinal"
                  label="Pretención final"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="align-self-center">
                <v-autocomplete
                  v-model="causa"
                  :items="list_causa"
                  label="Causa"
                  clearable
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="align-self-center"
                v-show="isTipoAsistenciaManiobra"
              >
                <v-autocomplete
                  v-model="nombreAutorizaGrua"
                  :items="autorizaGrua"
                  label="Autoriza Maniobra"
                  item-text="nombre"
                  item-value="nombre"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-show="isTipoAsistenciaGrua"
                class="pl-6 align-self-center"
              >
                <v-switch
                  v-model="vehiculoViajaSolo"
                  inset
                  class="pt-0 mt-3"
                  color="primary"
                  label="Vehiculo Viaja Solo"
                  :rules="campoRequerido"
                ></v-switch>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="align-self-center"
                v-show="isTipoAsistenciaGrua"
              >
                <v-text-field
                  v-model="vehiculoRecibeAcompaña"
                  label="Recibe/Acompaña"
                  clearable
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-autocomplete
                  v-model="depaOrigen"
                  :items="list_depaOrigen"
                  label="Departamento Origen"
                  clearable
                  @input="listaMunicipioOrigen"
                  persistent-hint
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-autocomplete
                  v-model="muniOrigen"
                  :items="list_muniOrigen"
                  label="Municipio Origen"
                  :background-color="colorOrigen"
                  clearable
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea
                  v-model="comDireccionOrigen"
                  label="Complemento Direccion Origen"
                  :rules="campoRequerido"
                  counter
                  maxlength="1000"
                  auto-grow
                  row-height="0"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-autocomplete
                  v-model="depaDestino"
                  :items="list_depaDestino"
                  label="Departamento Destino"
                  clearable
                  @input="listaMunicipioDestino"
                  persistent-hint
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <v-autocomplete
                  v-model="muniDestino"
                  :items="list_muniDestino"
                  label="Municipio Destino"
                  :background-color="colorDestino"
                  clearable
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea
                  v-model="comDireccionDestino"
                  label="Complemento Direccion Destino"
                  :rules="campoRequerido"
                  counter
                  maxlength="1000"
                  auto-grow
                  row-height="0"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="placaContraparte"
                  label="Placa Contraparte"
                  :rules="campoRequerido"
                  counter
                  maxlength="35"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="localidad_sisa"
                  :items="items_localidad_sisa"
                  label="Localidad SISA"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="mb-6 align-self-center"
                v-if="$store.state.usuario.rol == 'Admin Proveedores'"
              >
                <v-autocomplete
                  v-model="descuentoId"
                  label="Descuento"
                  item-text="nombre"
                  item-value="descuentoId"
                  :items="descuentos"
                  clearable
                >
                  <template v-slot:item="{ item }">
                    {{ `${item.nombre} (${item.porcentaje * 100}%)` }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="
                  $store.state.usuario.rol == 'Admin Proveedores' ||
                  $store.state.usuario.rol == 'Administrador' ||
                  $store.state.usuario.rol == 'Personal Administrativo'
                "
              >
                <v-autocomplete
                  v-model="selectedError"
                  label="Error Cabinista"
                  item-text="error"
                  item-value="id"
                  :items="erroresAsistencia"
                  @change="updateErrorAsistencia"
                  clearable
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  color="primary"
                  block
                  :disabled="btnConsulta"
                  @click="autoCompConsultaAseguradora"
                  >Consulta Aseguradora <i class="fas fa-chevron-right"></i>
                </v-btn>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="horaConsultaAseguradora"
                  label="Consulta Aseguradora"
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  color="primary"
                  block
                  :disabled="btnConfirmacion"
                  @click="autoCompConfirmacionAseguradora"
                  >Confirmación Aseguradora <i class="fas fa-chevron-right"></i>
                </v-btn>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="horaConfirmacionAseguradora"
                  label="Confirmación Aseguradora"
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
        <!-- Contenedor para finalizacion del servicio -->
        <v-container class="my-1">
          <v-card
            outlined
            width="100%"
            class="pa-2"
            elevation="1"
            style="border: 1px solid black"
          >
            <v-card-title class="pa-0">Finalización del servicio</v-card-title>
            <v-row>
              <v-col cols="12" :md="localForaneo == 'FORANEO' ? 2 : 4">
                <v-tooltip bottom color="primary" v-if="descuentoId != null">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      type="number"
                      v-on="on"
                      v-bind="attrs"
                      v-model="costoServicio"
                      label="Costo Servicio"
                      :readonly="costoEncontrado && !desbloquearCostoServicio"
                      :disabled="costoValid && !desbloquearCostoServicio"
                      :rules="campoRequerido"
                    ></v-text-field>
                  </template>
                  <div class="d-inline-flex">
                    <div class="text-right mr-2">
                      <p class="no-padding-and-margin">Costo Sin Descuento:</p>
                      <p class="no-padding-and-margin">Total Descuento:</p>
                      <p class="no-padding-and-margin">Porcentaje Descuento:</p>
                      <p class="no-padding-and-margin">Recupero:</p>
                    </div>
                    <div class="text-center">
                      <p class="no-padding-and-margin">
                        {{ costoSinDescuento }}
                      </p>
                      <p class="no-padding-and-margin">
                        {{ totalDescuento }}
                      </p>
                      <p class="no-padding-and-margin">
                        {{ getPorcentajeDescuento }}
                      </p>
                      <p class="no-padding-and-margin">
                        {{ getPorcentajeRecupero }}
                      </p>
                    </div>
                  </div>
                </v-tooltip>
                <v-text-field
                  v-else
                  type="number"
                  v-model="costoServicio"
                  label="Costo Servicio"
                  :readonly="costoEncontrado && !desbloquearCostoServicio"
                  :disabled="costoValid && !desbloquearCostoServicio"
                  :rules="campoRequerido"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" v-if="localForaneo == 'FORANEO'">
                <v-text-field
                  v-model="kmCosto"
                  label="Kilometros"
                  :disabled="costoValid && !desbloquearCostoServicio"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pt-6">
                <v-btn
                  outlined
                  color="primary"
                  :disabled="costoValid && !desbloquearCostoServicio"
                  @click="calcularCosto"
                  >Calcular Costo</v-btn
                >
              </v-col>
              <v-col cols="12" md="3" class="align-self-center">
                <v-autocomplete
                  v-model="tipoServicio"
                  :items="list_tipoServicio"
                  label="Tipo Servicio"
                  clearable
                  :rules="campoRequerido"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" class="align-self-center">
                <v-autocomplete
                  v-model="estatusAsistencia"
                  :items="filterEstadosAsistencias"
                  item-text="estado"
                  item-value="estado"
                  @click="listarEstadosAsistencia"
                  label="Estatus Asistencia"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="7"
                class="align-self-center mb-6 pt-0"
                v-if="estatusAsistencia == 'CANCELADO A SOLICITUD'"
              >
              </v-col>
              <v-col
                cols="12"
                md="5"
                class="align-self-center mb-6 pt-0"
                v-if="estatusAsistencia == 'CANCELADO A SOLICITUD'"
              >
                <v-form ref="fObsCancelacion">
                  <v-autocomplete
                    v-model="selectedObsCancelacion"
                    :items="observacionesCancelacion"
                    :rules="
                      estatusAsistencia == 'CANCELADO A SOLICITUD'
                        ? campoRequerido
                        : []
                    "
                    item-text="observacion"
                    item-value="observacion"
                    label="
Observación Cancelación
"
                  ></v-autocomplete>
                </v-form>
              </v-col>

              <v-col cols="12" md="2">
                <v-btn
                  color="primary"
                  block
                  :disabled="btnContacto || fechaHoraAsignacion == null"
                  @click="autoCompFechaContacto()"
                  >Contacto <i class="fas fa-chevron-right"></i>
                </v-btn>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="fechaHoraContacto"
                  label="Fecha Contacto"
                  step="1"
                  :disabled="
                    textFieldContactoDisabled ||
                    fechaHoraAsignacion == null ||
                    $store.state.usuario.rol == 'Inspector'
                  "
                  :rules="campoRequerido"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn
                  color="primary"
                  block
                  :disabled="checkDisabledTermino"
                  @click="autoCompFinalizado()"
                  >Termino <i class="fas fa-chevron-right"></i
                ></v-btn>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="termino"
                  label="Termino"
                  step="1"
                  :disabled="
                    fechaHoraContacto == null ||
                    ($store.state.usuario.rol == 'Inspector' &&
                      obsAdicionales.trim() == '') ||
                    textFieldTerminoDisabled
                  "
                  clearable
                  :rules="campoRequerido"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="cabinistaContacto"
                  label="Cabinista que establecio contacto"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="cabinistaTermino"
                  label="Cabinista que establecio termino"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                v-if="numeroAsistencia && tipoAsistencia.includes('TERCERO')"
              >
                <DatosTercero
                  :numeroAsistencia="numeroAsistencia"
                  ref="datosTercero"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea
                  v-model="obsAdicionales"
                  label="Observaciones Adicionales"
                  :rules="campoRequerido"
                  counter
                  maxlength="4000"
                  auto-grow
                  row-height="0"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="operador" label="Operador" disabled>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.trim="quienSolicita"
                  label="Quién Solicita/Autoriza"
                  clearable
                  counter="50"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="fechaSolicitudAjuste"
                  label="Fecha de solicitud de ajuste"
                  type="datetime-local"
                  step="1"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="localForaneo"
                  :items="list_localForaneo"
                  label="Local/Foraneo"
                  clearable
                  :rules="campoRequerido"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="quienSolicita">
                <v-form ref="fComentarioAutoriza">
                  <v-textarea
                    v-model="comentarioAutoriza"
                    label="Comentario Autorización"
                    counter
                    maxlength="500"
                    :rules="quienSolicita ? campoRequerido : []"
                    no-resize
                    rows="4"
                    outlined
                  ></v-textarea>
                </v-form>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="partePolicial"
                  label="Hay Parte Policial?"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="seMovioDelLugar"
                  label="Se Movio Del lugar"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="zonaPeligrosa"
                  label="zona Peligrosa"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="reporteTardio"
                  label="Reporte Tardio"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="roboRecuperado"
                  label="Robo Recuperado"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="2">
                <v-checkbox v-model="estadoEbriedad" label="Estado de ebriedad">
                </v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-radio-group v-model="radioGroupRecobroConciliacion">
                  <v-radio label="Recupero" value="Recupero"></v-radio>
                  <v-radio label="Recobro" value="Recobro"></v-radio>
                  <v-radio label="Conciliación" value="Conciliación"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                v-if="radioGroupRecobroConciliacion"
              >
                <v-text-field
                  v-model="cantRecupero"
                  type="number"
                  :readonly="cantRecuperoEncontrado && !desbloquearCantRecobro"
                  label="Valor"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                v-if="radioGroupRecobroConciliacion == 'Recupero'"
              >
                <v-text-field
                  type="number"
                  label="Porcentaje Recupero (5%)"
                  :value="getPorcentajeRecupero"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="auto">
                <v-checkbox v-model="protocolo" label="Protocolo"> </v-checkbox>
              </v-col>
              <v-col cols="12" md="auto">
                <v-checkbox v-model="pasaFiscalia" label="Pasa a fiscalia">
                </v-checkbox>
              </v-col>
              <v-col cols="12" md="auto">
                <v-checkbox v-model="reembolso" label="Reembolso"></v-checkbox>
              </v-col>
              <v-row class="mx-0">
                <template v-if="radioGroupRecobroConciliacion == 'Recupero'">
                  <v-col cols="12" md="3">
                    <v-text-field
                      class="mb-2"
                      dense
                      label="DUI Persona Recupero"
                      v-mask="'########-#'"
                      hint="01234567-8"
                      v-model="DUIPersonaRecupero"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      class="mb-2"
                      dense
                      label="Nombre Persona Recupero"
                      v-model="personaRecupero"
                      hint="Nombre que aparece en DUI"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3"></v-col>
                </template>
                <v-col cols="12" md="2">
                  <v-btn
                    color="primary"
                    :disabled="btnCierreFinalizado || termino == null"
                    @click="autoCompCierreFinalizado()"
                    >Cierre Asistencia <i class="fas fa-chevron-right"></i
                  ></v-btn>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="fechaHoraCierreAsistencia"
                    label="Fecha Cierre Asistencia"
                    step="1"
                    persistent-hint
                    :disabled="textFieldCierreDisabled || termino == null"
                    clearable
                    :rules="campoRequerido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="7">
                  <v-text-field
                    v-model="cabinistaCierre"
                    label="Cabinista que establecio cierre de asistencia"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mx-0">
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="numeroCheque"
                    label="Número de cheque"
                    clearable
                    counter="50"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="responsable"
                    label="Quien es el responsable"
                    clearable
                    counter="50"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="fechaHoraProgramado"
                    label="Fecha programado"
                    type="datetime-local"
                    step="1"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-row>
          </v-card>
        </v-container>
      </v-form>

      <!-- Campos para agregar datos por parte del ajustador -->
      <v-container class="mt-1">
        <v-card
          outlined
          width="100%"
          class="pa-2"
          elevation="1"
          style="border: 1px solid black"
        >
          <v-card-title class="pa-0">Datos Ajustador</v-card-title>
          <v-row
            v-if="
              id &&
              ($store.state.usuario.rol == 'Digitador' ||
                $store.state.usuario.rol == 'Team Lider Ajustadores' ||
                $store.state.usuario.rol == 'Administrador' ||
                $store.state.usuario.rol == 'Finanzas' ||
                $store.state.usuario.rol == 'Personal Administrativo' ||
                $store.state.usuario.rol == 'Team Leader Cabina')
            "
          >
            <v-col cols="12" md="2" align-self="center" class="pb-0">
              <v-btn
                @click="mostrarConfirmacion"
                color="primary"
                :disabled="
                  digitador != null || $store.state.usuario.rol != 'Digitador'
                "
                block
                >Digitador
                <v-icon right>fas fa-caret-right</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="4" align-self="center" class="pt-6 pb-0">
              <v-text-field
                :disabled="
                  digitador != null || $store.state.usuario.rol != 'Digitador'
                "
                label="Fecha Hora Digitador:"
                :value="nombreFechaDigitador"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align-self="center" class="pb-0">
              <v-btn
                @click="mostrarConfirmacion"
                color="primary"
                :disabled="
                  (digitador == null && autorizadoPor == null) ||
                  autorizadoPor != null ||
                  $store.state.usuario.rol != 'Team Lider Ajustadores'
                "
                block
                >Autorizado Por
                <v-icon right>fas fa-caret-right</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="4" align-self="center" class="pt-6 pb-0"
              ><v-text-field
                label="Fecha Hora Autorizado Por:"
                :value="nombreFechaAutorizadoPor"
                :disabled="
                  (digitador == null && autorizadoPor == null) ||
                  autorizadoPor != null ||
                  $store.state.usuario.rol != 'Team Lider Ajustadores'
                "
                readonly
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="2" align-self="center">
              <v-btn
                @click="asignarNombreAjustadorCargo()"
                color="primary"
                block
                :disabled="ajustador_cargo != '' && ajustador_cargo != null"
                >Usuario
                <v-icon right>fas fa-caret-right</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="7">
              <v-text-field
                v-model="ajustador_cargo"
                label="Cargado: Plataforma aseguradora/FTP/NUBE/CORREO"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Fecha Carga Portal Aseguradora"
                type="datetime-local"
                v-model="horaCargaPortalAseguradora"
                :readonly="
                  !editarHoraCargaPortal &&
                  (!desbloquearCargaAseguradora || !!horaCargaPortalAseguradora)
                "
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="expedienteAssa"
                label="EXPEDIENTE/RECLAMO"
                counter="40"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="inspeccionInSituVirtual"
                label="INSPECCIÓN IN SITU O VIRTUAL"
                :items="list_inspeccionInSituVirtual"
                counter="20"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="rapiAssaAsegurado"
                label="RAPIASSA ASEGURADO"
                :items="list_rapiAssaAsegurado"
                counter="12"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="rapiAssaTercero"
                label="RAPIASSA TERCERO"
                :items="list_rapiAssaTercero"
                counter="12"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="motivoNoUsoRapiassa"
                label="MOTIVO DE NO USO RAPIASSA"
                :items="list_motivoNoUsoRapiassa"
                counter="200"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="motivoNoUsoRapiassaTercero"
                label="MOTIVO DE NO USO RAPIASSA TERCERO"
                :items="list_motivoNoUsoRapiassa"
                counter="200"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="usoGruaAsegurado"
                label="USÓ DE GRÚA ASEGURADO"
                :items="list_usoGruaAsegurado"
                counter="12"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="usoGruaTercero"
                label="USÓ DE GRÚA TERCERO"
                :items="list_usoGruaAsegurado"
                counter="12"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="tallerAsegurado"
                label="TALLER ASEGURADO"
                :items="list_redTalleres"
                counter="50"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="tallerTercero"
                label="TALLER TERCERO"
                :items="talleresCartera"
                counter="50"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="estadoVirtual"
                label="ESTADO VIRTUAL"
                :items="list_estadoVirtual"
                counter="12"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="motivoDeNoUsoTaller"
                label="MOTIVO DE NO USO TALLER"
                :items="list_motivoDeNoTaller"
                counter="50"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="declinaciones"
                :items="itemsDeclinaciones"
                label="Declinaciones"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="ahorroDe"
                label="Ahorro de $"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="2" align-self="center" class="text-center">
              <v-btn
                color="primary"
                @click="asignarUsuarioEnviadoPor()"
                :disabled="enviadoPor != '' && enviadoPor != null"
              >
                Asignar
                <v-icon right>fas fa-caret-right</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6" md="4" align-self="center">
              <v-text-field
                v-model="enviadoPor"
                label="ENVIADO POR"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="cartera == 'SISA SEGUROS'">
            <v-spacer></v-spacer>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="tallerId"
                label="Taller SISA"
                item-text="nombre"
                item-value="id"
                :items="talleresSISA"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="analistaSISAId"
                label="Analista SISA"
                item-text="nombre"
                item-value="analistaId"
                :items="analistasSISA"
                clearable
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

      <!-- Contenedor para agregar y descargar imagenes -->
      <v-container class="mt-1" v-if="verDet == 1">
        <v-card
          outlined
          width="100%"
          class="pa-2 mb-1"
          elevation="1"
          style="border: 1px solid black"
        >
          <v-card-title class="pa-0">almacenamiento de archivos</v-card-title>
          <v-row justify="center" align="center">
            <v-col cols="6">
              <v-card>
                <v-card-title class="justify-center"
                  >Cargar archivos</v-card-title
                >
                <v-card-actions>
                  <v-file-input
                    v-model="filesCargadas"
                    id="fileButtom"
                    accept="image/*, .mp3, .wav, .pdf"
                    label="File input"
                    multiple
                    small-chips
                    :show-size="1000"
                    counter
                    @change="cargarArchivos()"
                  ></v-file-input>
                  <v-btn
                    :disabled="disabledCargarArchivos"
                    class="mx-auto"
                    rounded
                    outlined
                    elevation="3"
                    color="blue"
                    @click="subirArchivos()"
                  >
                    <i class="fas fa-cloud-upload-alt fa-2x"></i>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="6" class="align-center justify-center">
              <v-card height="150">
                <v-card-title class="justify-center">Ver archivos</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    outlined
                    elevation="3"
                    color="blue"
                    block
                    @click="contarArchivosDescarga()"
                    ><i class="fas fa-cloud-download-alt fa-2x"></i
                  ></v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="imagenesPreview.length > 0">
              <v-sheet elevation="8">
                <div>
                  <v-btn
                    class="ml-4 mt-4"
                    outlined
                    rounded
                    color="blue"
                    @click="descargarZIP()"
                    v-if="mostrarBotonDescargar"
                    >Descargar imagenes</v-btn
                  >
                </div>
                <v-slide-group
                  v-model="model"
                  class="pa-4"
                  active-class="success"
                  center-active
                  show-arrows
                >
                  <v-slide-item
                    v-for="(item, i) in imagenesPreview"
                    :key="i"
                    v-slot="{ toggle }"
                  >
                    <v-card
                      class="ma-4"
                      height="200"
                      width="150"
                      @click="toggle"
                    >
                      <v-row class="fill-height" justify="center">
                        <v-scale-transition>
                          <v-img
                            :src="item.url"
                            @click="verImagen(item)"
                          ></v-img>
                        </v-scale-transition>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </v-col>
            <v-col cols="12" v-if="filesDescargadasAudios.length > 0">
              <v-sheet elevation="8">
                <div>
                  <v-btn
                    class="ml-4 mt-4"
                    outlined
                    rounded
                    color="blue"
                    @click="descargarZipAudios()"
                    v-if="mostrarBotonDescargar"
                    >Descargar audios</v-btn
                  >
                </div>
                <v-slide-group
                  v-model="model"
                  class="pl-4 pr-4 pb-4 pt-0"
                  center-active
                  show-arrows
                >
                  <v-slide-item
                    v-for="(itemAudio, i) in filesDescargadasAudios"
                    :key="i"
                    v-slot="{ toggle }"
                  >
                    <v-card
                      class="ma-4"
                      height="auto"
                      width="auto"
                      tile
                      flat
                      @click="toggle"
                    >
                      <v-row class="" justify="center" align="center">
                        <audio controls>
                          <source :src="itemAudio.url" type="audio/mpeg" />
                          Your browser does not support the audio element.
                        </audio>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </v-col>
            <v-col cols="12" v-if="filesPDF.length > 0">
              <v-sheet elevation="8">
                <div>
                  <v-btn
                    class="ml-4 mt-4"
                    outlined
                    rounded
                    color="blue"
                    @click="descargarPDF()"
                    v-if="mostrarBotonDescargar"
                    >Descargar archivos pdf</v-btn
                  >
                </div>
                <v-slide-group
                  v-model="model"
                  class="pa-4"
                  active-class="primary"
                  center-active
                  show-arrows
                >
                  <v-slide-item
                    v-for="(item, i) in filesPDF"
                    :key="i"
                    v-slot="{ toggle }"
                  >
                    <v-card
                      class="ma-4"
                      height="200"
                      width="150"
                      @click="toggle"
                    >
                      <v-row class="fill-height" justify="center">
                        <v-scale-transition>
                          <v-img
                            :src="require('@/assets/logo_pdf.png')"
                          ></v-img>
                        </v-scale-transition>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

      <!-- Contenedor para encuesta de servicio -->
      <v-container class="mt-1">
        <v-card
          outlined
          width="100%"
          class="pa-2 mb-1"
          elevation="1"
          style="border: 1px solid black"
        >
          <v-card-title class="pa-0"> Encuesta de servicio</v-card-title>
          <v-row>
            <v-col cols="12" md="3" class="pt-0 pr-0">
              <v-card max-width="500" flat>
                <v-card-title
                  class="pb-8 pr-0"
                  style="white-space: no-wrap; word-break: keep-all"
                  >¿Fue resuelta su necesidad?</v-card-title
                >
                <v-checkbox
                  v-model="checkResueltaNecesidad"
                  :label="`Respuesta es: ${checkResueltaNecesidad}`"
                  class="ml-4"
                  hide-details
                ></v-checkbox>
                <v-btn
                  small
                  outlined
                  class="mt-2 ml-3"
                  @click="limpiarResuletaNecesidad()"
                  >Eliminar seleccion</v-btn
                >
                <v-card max-width="500" flat>
                  <v-card-title
                    class="pb-0"
                    style="white-space: no-wrap; word-break: keep-all"
                  >
                    ¿Contesto Llamada?</v-card-title
                  >
                  <v-checkbox
                    v-model="checkNoResponde"
                    label="No responde"
                    class="ml-4 py-0"
                    hide-details
                  ></v-checkbox>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" class="pt-0 px-0">
              <v-card max-width="500" flat>
                <v-card-title
                  class="pb-0 pr-0"
                  style="white-space: no-wrap; word-break: keep-all"
                >
                  ¿Cómo califica la atención en el lugar del evento?
                </v-card-title>
                <v-radio-group
                  v-model="radioGroupCalificaServicio"
                  hide-details
                >
                  <v-radio
                    label="Bueno"
                    value="BUENO"
                    color="green"
                    class="ml-4"
                  ></v-radio>
                  <v-radio
                    label="Malo"
                    value="MALO"
                    color="red"
                    class="ml-4"
                  ></v-radio>
                  <v-radio
                    label="Excelente"
                    value="EXCELENTE"
                    color="primary"
                    class="ml-4"
                  ></v-radio>
                </v-radio-group>
                <v-btn
                  small
                  outlined
                  class="mt-2 ml-3"
                  @click="limpiarCalificaServicio()"
                  >Eliminar seleccion</v-btn
                >
              </v-card>
            </v-col>
            <v-col cols="12" md="3" class="pt-0">
              <v-card max-width="500" flat>
                <v-card-title
                  class="pb-0 pr-0"
                  style="white-space: no-wrap; word-break: keep-all"
                  >¿Cómo califica la atención del ejecutivo de call
                  center?</v-card-title
                >
                <v-radio-group
                  v-model="radioGroupCalificaEjecutivo"
                  hide-details
                >
                  <v-radio
                    label="Bueno"
                    value="BUENO"
                    color="green"
                    class="ml-4"
                  ></v-radio>
                  <v-radio
                    label="Malo"
                    value="MALO"
                    color="red"
                    class="ml-4"
                  ></v-radio>
                  <v-radio
                    label="Excelente"
                    value="EXCELENTE"
                    color="primary"
                    class="ml-4"
                  ></v-radio>
                </v-radio-group>
                <v-btn
                  small
                  outlined
                  class="mt-2 ml-3"
                  @click="radioGroupCalificaEjecutivo = ''"
                  >Eliminar seleccion</v-btn
                >
              </v-card>
            </v-col>
            <v-col cols="12" md="3" class="pt-0">
              <v-card max-width="500" flat>
                <v-card-title
                  class="pb-0 pl-0 pr-0"
                  style="white-space: no-wrap; word-break: keep-all"
                  >Llenó y firmó usted el formulario de reclamos</v-card-title
                >
                <v-radio-group v-model="llenoFormularioReclamo" hide-details>
                  <v-radio label="SI" value="SI" color="success"></v-radio>
                  <v-radio label="NO" value="NO" color="grey"></v-radio>
                </v-radio-group>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" class="pt-0">
              <v-card flat>
                <v-card-title class="pb-0">Quejas u observaciones</v-card-title>
                <v-textarea
                  v-model="textAreaQuejaObservaciones"
                  outlined
                  :readonly="bloquearQuejaObservaciones"
                  auto-grow
                  hide-details
                  class="ml-4 pt-0 mt-0"
                ></v-textarea>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

      <div class="text-center">
        <v-dialog v-model="dialogVerImagen" width="500">
          <v-card>
            <v-card-text class="pt-5">
              <v-img :src="imagenDialog"></v-img>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogVerImagen = false">
                Cerrar
              </v-btn>
              <v-btn
                color="error"
                text
                @click="dialogBorrarImagen = true"
                v-if="banderaEliminar"
              >
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div class="text-center">
        <v-dialog v-model="dialogBorrarImagen" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Eliminar imagen
            </v-card-title>

            <v-card-text class="pt-5 title">
              ¿Está seguro de eliminar esta imagen?
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogBorrarImagen = false">
                No
              </v-btn>
              <v-btn color="primary" text @click="eliminarImagen()">
                Si, seguro
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-flex xs12 sm12 md12 lg12 xl12 class="mt-3">
        <v-btn @click="ocultarNuevo()" class="mr-1" color="cancel" v-if="false"
          >Cancelar</v-btn
        >
        <v-btn
          @click="actualizar()"
          color="success"
          v-if="verDet == 1 && false"
          class="mx-1"
          >Actualizar</v-btn
        >
        <v-btn
          @click="guardar()"
          color="success"
          :loading="btnloadingGuardar"
          :disabled="btnloadingGuardar"
          v-if="verDet == 0 && false"
          class="mx-1"
          >Guardar</v-btn
        >
        <v-btn
          @click="servicioAdicional()"
          color="info"
          v-if="
            solicitudGrua == 1 &&
            $store.state.usuario.rol != 'Inspector' &&
            false
          "
          class="mx-1"
          >Servicio Adicional</v-btn
        >
        <button
          class="btn-hover color-4 mt-0 mb-0 ml-1 mr-1"
          @click="isShowing = true"
          v-if="verDet == 1 && false"
        >
          BITACORA
        </button>
      </v-flex>

      <v-flex xs12 sm12 md12 lg12 xl12>
        <div
          class="red--text"
          v-for="v in validaMensaje"
          :key="v"
          v-text="v"
        ></div>
      </v-flex>
    </v-container>

    <!--Reincidencias -->
    <v-bottom-sheet
      v-model="sheetReincidencia"
      hide-overlay
      persistent
      scrollable
    >
      <v-card height="350">
        <v-card-title>
          <span class="headline">Reincidencia</span>
          <v-spacer></v-spacer>
          Total de asistencias: {{ this.contadorReincidencias }}
        </v-card-title>
        <v-card-text v-if="reincidencias.length > 0">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Numero De Asistencia</th>
                  <th class="text-left">Fecha</th>
                  <th class="text-left">Tipo Asistencia</th>
                  <th class="text-left">Tipo Servicio</th>
                  <th class="text-left">Estatus</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in reincidencias" :key="item.fechaHoraActual">
                  <td>{{ item.numeroAsistencia }}</td>
                  <td>{{ item.fechaHoraOcurrencia }}</td>
                  <td>{{ item.tipoAsistencia }}</td>
                  <td>{{ item.tipoServicio }}</td>
                  <td>{{ item.estatusAsistencia }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text v-if="reincidencias.length <= 0">
          <div class="title">{{ mensajeReincidencia }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            icon
            @click="sheetReincidencia = !sheetReincidencia"
            ><i class="far fa-times-circle fa-2x"></i
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <v-dialog v-model="dialogCartera" max-width="600">
      <v-card>
        <v-card-title style="background-color: #ced4da">
          Seleccione la cartera
        </v-card-title>
        <v-row no-gutters>
          <v-col class="mx-1 mb-1 mt-1">
            <v-card elevation="8" href="#">
              <v-img
                :src="require('@/assets/Seguros-Futuro.jpg')"
                aspect-ratio="1"
                contain
                @click="seleccionarCartera('fa')"
              >
              </v-img>
            </v-card>
          </v-col>
          <v-col class="mx-1 mb-1 mt-1">
            <v-card elevation="8" href="#">
              <v-img
                :src="require('@/assets/ASSA.jpg')"
                aspect-ratio="1"
                contain
                @click="seleccionarCartera('acs')"
              >
              </v-img>
            </v-card>
          </v-col>
          <v-col class="mx-1 mb-1 mt-1 cursor-pointer">
            <v-card elevation="8" href="#">
              <v-img
                :src="require('@/assets/SISA.png')"
                aspect-ratio="1"
                contain
                @click="seleccionarCartera('sisa')"
              >
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_chat_wha" max-width="700" persistent>
      <v-card tile elevation="0">
        <v-row no-gutters>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="12">
                <v-toolbar color="blue-grey lighten-1" dark tile elevation="0">
                  <v-tabs
                    v-model="tabs_chat_wa"
                    background-color="blue-grey lighten-1"
                  >
                    <v-tab
                      href="#cliente"
                      @click="
                        abrirDialogChat(
                          numeroTelefono,
                          'cliente',
                          titularPoliza
                        )
                      "
                      >Asegurado: {{ this.titularPoliza }}</v-tab
                    >
                    <v-tab
                      href="#proveedor"
                      @click="
                        abrirDialogChat(
                          telefonoProveedor,
                          'proveedor',
                          nombreProveedor
                        )
                      "
                      >Proveedor: {{ this.nombreProveedor }}</v-tab
                    >
                  </v-tabs>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon large @click="dialog_chat_wha = false"
                      >far fa-times-circle</v-icon
                    >
                  </v-btn>
                </v-toolbar>
              </v-col>
              <v-col cols="12">
                <v-card
                  tile
                  elevation="0"
                  height="700px"
                  style="display: flex !important; flex-direction: column"
                >
                  <v-card-text
                    style="flex-grow: 1; overflow: auto"
                    class="scrollable"
                    ref="msgContainer"
                    v-if="items_chat != 0"
                  >
                    <v-row v-for="(item, i) in items_chat" :key="i" no-gutters>
                      <!-- MENSAJES RECIBIDOS -->
                      <v-col md="7" class="my-1" v-if="item.tipo_usuario == 1">
                        <v-card class="pa-2" color="blue-grey lighten-4">
                          <v-toolbar
                            flat
                            class="pa-0"
                            dense
                            color="blue-grey lighten-4"
                            height="30"
                          >
                            <v-spacer></v-spacer>
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on"
                                  >fas fa-sort-down</v-icon
                                >
                              </template>
                              <v-list>
                                <template
                                  v-for="(
                                    item_actions, index
                                  ) in items_actions_chat_wa"
                                >
                                  <v-list-item
                                    :key="index"
                                    @click="
                                      accionesMensaje(item_actions.action, item)
                                    "
                                    v-if="
                                      item_actions.action == 'descargar' &&
                                      item.tipo != 'text' &&
                                      false
                                    "
                                  >
                                    <v-list-item-title>{{
                                      item_actions.title
                                    }}</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item
                                    :key="index"
                                    @click="
                                      accionesMensaje(item_actions.action, item)
                                    "
                                    v-if="item_actions.action == 'reenviar'"
                                  >
                                    <v-list-item-title>{{
                                      item_actions.title
                                    }}</v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-list>
                            </v-menu>
                          </v-toolbar>
                          <div v-if="item.tipo == 'text'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <v-textarea
                                  v-model="item.mensaje"
                                  auto-grow
                                  row-height="1"
                                  flat
                                  solo
                                  readonly
                                  color="blue-grey lighten-4"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'image'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <v-img
                                  @click="
                                    abrirDocumentoWa(item.preview, item.tipo)
                                  "
                                  :src="item.preview"
                                  height="200"
                                  contain
                                />
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'document'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <a
                                  @click="
                                    abrirDocumentoWa(item.preview, item.tipo)
                                  "
                                  class="subtitle-1"
                                  onmouseover=""
                                  style="cursor: pointer"
                                >
                                  <v-icon color="primary" x-large
                                    >fas fa-file-alt</v-icon
                                  >
                                  {{ item.mensaje }}
                                </a>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'audio'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <audio controls :src="item.preview"></audio>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'video'" class="text-center">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <video height="300" width="355" controls>
                                  <source
                                    type="video/mp4"
                                    :src="item.preview"
                                  />
                                  <source
                                    type="video/3gp"
                                    :src="item.preview"
                                  />
                                </video>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'sticker'">
                            <v-img
                              :src="item.preview"
                              height="100"
                              contain
                            ></v-img>
                          </div>
                          <div v-if="item.tipo == 'location'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <GmapMap
                                  :center="{
                                    lat: item.latitude,
                                    lng: item.longitude,
                                  }"
                                  :zoom="16"
                                  map-type-id="terrain"
                                  style="width: 300px; height: 200px"
                                  :options="{
                                    zoomControl: false,
                                    mapTypeControl: false,
                                    scaleControl: false,
                                    streetViewControl: false,
                                    rotateControl: false,
                                    fullscreenControl: false,
                                    disableDefaultUi: false,
                                    draggable: false,
                                  }"
                                  @click="
                                    abrirDocumentoWa(
                                      item.latitude + ',' + item.longitude,
                                      item.tipo
                                    )
                                  "
                                >
                                  <GmapMarker
                                    :position="{
                                      lat: item.latitude,
                                      lng: item.longitude,
                                    }"
                                    :clickable="false"
                                    :draggable="false"
                                  />
                                </GmapMap>
                              </v-col>
                            </v-row>
                          </div>
                          <v-card-actions class="pa-0">
                            <v-spacer></v-spacer>
                            <span class="caption mr-1">{{
                              formatoFecha(item.fecha_mensaje)
                            }}</span>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                      <v-spacer></v-spacer>
                      <!-- MENSAJES ENVIADOS -->
                      <v-col md="7" class="my-1" v-if="item.tipo_usuario == 2">
                        <v-card
                          class="pa-2"
                          color="blue-grey lighten-4"
                          max-width="700"
                        >
                          <v-toolbar
                            flat
                            class="pa-0"
                            dense
                            color="blue-grey lighten-4"
                            height="40"
                          >
                            <v-spacer></v-spacer>
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on"
                                  >fas fa-sort-down</v-icon
                                >
                              </template>
                              <v-list>
                                <template
                                  v-for="(
                                    item_actions, index
                                  ) in items_actions_chat_wa"
                                >
                                  <v-list-item
                                    :key="index"
                                    @click="
                                      accionesMensaje(item_actions.action, item)
                                    "
                                    v-if="
                                      item_actions.action == 'descargar' &&
                                      item.tipo != 'text' &&
                                      false
                                    "
                                  >
                                    <v-list-item-title>{{
                                      item_actions.title
                                    }}</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item
                                    :key="index"
                                    @click="
                                      accionesMensaje(item_actions.action, item)
                                    "
                                    v-if="item_actions.action == 'reenviar'"
                                  >
                                    <v-list-item-title>{{
                                      item_actions.title
                                    }}</v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-list>
                            </v-menu>
                          </v-toolbar>
                          <div v-if="item.tipo == 'text'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <v-textarea
                                  v-model="item.mensaje"
                                  auto-grow
                                  row-height="1"
                                  flat
                                  solo
                                  readonly
                                  color="blue-grey lighten-4"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'image'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <v-img
                                  @click="
                                    abrirDocumentoWa(item.preview, item.tipo)
                                  "
                                  :src="item.preview"
                                  height="200"
                                  contain
                                />
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'document'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <a
                                  @click="
                                    abrirDocumentoWa(item.preview, item.tipo)
                                  "
                                  class="subtitle-1"
                                  onmouseover=""
                                  style="cursor: pointer"
                                >
                                  <v-icon color="primary" x-large
                                    >fas fa-file-alt</v-icon
                                  >
                                  {{ item.mensaje }}
                                </a>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'audio'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <audio controls :src="item.preview"></audio>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'video'" class="text-center">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <video height="300" width="355" controls>
                                  <source
                                    type="video/mp4"
                                    :src="item.preview"
                                  />
                                  <source
                                    type="video/3gp"
                                    :src="item.preview"
                                  />
                                </video>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'sticker'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <v-img
                                  :src="item.preview"
                                  height="100"
                                  contain
                                ></v-img>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="item.tipo == 'location'">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="auto">
                                <v-list-item-action
                                  class="mx-auto"
                                  v-if="bandera_reenvio"
                                >
                                  <v-checkbox
                                    v-model="items_mensajes_seleccionados"
                                    :value="item"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </v-col>
                              <v-col cols="10">
                                <GmapMap
                                  :center="{
                                    lat: item.latitude,
                                    lng: item.longitude,
                                  }"
                                  :zoom="16"
                                  map-type-id="terrain"
                                  style="width: 355px; height: 200px"
                                  :options="{
                                    zoomControl: false,
                                    mapTypeControl: false,
                                    scaleControl: false,
                                    streetViewControl: false,
                                    rotateControl: false,
                                    fullscreenControl: false,
                                    disableDefaultUi: false,
                                    draggable: false,
                                  }"
                                  @click="
                                    abrirDocumentoWa(
                                      item.latitude + ',' + item.longitude,
                                      item.tipo
                                    )
                                  "
                                >
                                  <GmapMarker
                                    :position="{
                                      lat: item.latitude,
                                      lng: item.longitude,
                                    }"
                                    :clickable="false"
                                    :draggable="false"
                                  />
                                </GmapMap>
                              </v-col>
                            </v-row>
                          </div>
                          <v-card-actions class="pa-0">
                            <v-spacer></v-spacer>
                            <span class="caption mr-1">{{
                              formatoFecha(item.fecha_mensaje)
                            }}</span>
                            <v-icon small v-if="item.estado == 'sent'"
                              >fa-solid fa-check</v-icon
                            >
                            <v-icon small v-if="item.estado == 'delivered'"
                              >fa-solid fa-check-double</v-icon
                            >
                            <v-icon
                              small
                              color="blue"
                              v-if="item.estado == 'read'"
                              >fa-solid fa-check-double</v-icon
                            >
                            <v-icon
                              small
                              color="red"
                              v-if="item.estado == 'failed'"
                              @click="verMensajeErrorWa(item.mensaje_error)"
                              >fas fa-exclamation-circle</v-icon
                            >
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <!-- NO HAY MENSAJES -->
                  <v-card-text
                    v-else
                    style="flex-grow: 1; overflow: auto"
                    class="scrollable"
                    ref="msgContainer"
                  >
                    <h1 class="text-center">No hay mensajes aún...</h1>
                    <v-img
                      :src="require('@/assets/icon_empty.jpg')"
                      width="200"
                      class="mx-auto mt-3"
                    ></v-img>
                  </v-card-text>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        v-if="bottom_sheet_multimedia"
                        class="pb-1"
                      >
                        <v-bottom-navigation class="elevation-0">
                          <!-- ENVIO DE MULTIMEDIA -->
                          <v-file-input
                            v-model="items_multimedia"
                            class="mx-1 my-auto"
                            multiple
                            outlined
                            dense
                            hide-details
                            :accept="accept_multimedia"
                            @change="verificarMultimedia()"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="deep-purple accent-4"
                                dark
                                label
                                small
                              >
                                {{ text }}
                              </v-chip>

                              <span
                                v-else-if="index === 2"
                                class="text-overline grey--text text--darken-3 mx-2"
                              >
                                +{{ items_multimedia.length - 2 }} Archivo(s)
                              </span>
                            </template>
                          </v-file-input>
                          <v-divider vertical></v-divider>
                          <v-btn
                            class="pa-0"
                            @click="enviarmensajeMultimedia()"
                            v-if="items_multimedia.length != 0"
                          >
                            <v-icon color="primary">fas fa-paper-plane</v-icon>
                          </v-btn>
                          <v-divider vertical></v-divider>
                          <v-btn
                            class="pa-0"
                            @click="bottom_sheet_multimedia = false"
                          >
                            <v-icon>fas fa-times</v-icon>
                          </v-btn>
                        </v-bottom-navigation>
                      </v-col>
                      <v-col cols="12" class="pt-1 pb-0">
                        <v-bottom-navigation class="elevation-0">
                          <!-- MENU DE PLANTILLAS -->
                          <v-menu offset-x>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn outlined small v-bind="attrs" v-on="on">
                                <v-icon color="black"> fas fa-terminal </v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <template
                                v-for="(item, index) in items_plantillas"
                              >
                                <v-list-item link :key="index">
                                  <v-list-item-title
                                    @click="enviarMensajePlantilla(item)"
                                    >{{
                                      item.identificador_wa_api
                                    }}</v-list-item-title
                                  >
                                </v-list-item>
                              </template>
                            </v-list>
                          </v-menu>
                          <!-- MENU DE TIPO DE MULTIMEDIA -->
                          <v-menu offset-x>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn outlined small v-bind="attrs" v-on="on"
                                ><v-icon color="black">fas fa-plus</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <template
                                v-for="(item, index) in items_tipo_multimedia"
                              >
                                <v-list-item link :key="index">
                                  <v-list-item-title
                                    @click="enviarMultimedia(item)"
                                    >{{ item.nombre }}</v-list-item-title
                                  >
                                </v-list-item>
                              </template>
                            </v-list>
                          </v-menu>
                          <!-- MENSAJE DE TEXTO -->
                          <v-text-field
                            v-model="mensaje_chat"
                            label="Escribir mensaje"
                            counter="4096"
                            maxlength="4096"
                            single-line
                            outlined
                            hide-details
                            @keyup.enter="enviarMensajeLibre()"
                          >
                          </v-text-field>
                          <v-tooltip
                            top
                            v-if="items_mensajes_seleccionados.length != 0"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="reenviarMensaje()"
                              >
                                <v-icon>fas fa-share</v-icon>
                              </v-btn>
                            </template>
                            <span>Reenviar</span>
                          </v-tooltip>
                          <v-tooltip top v-if="bandera_reenvio">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="cancelarReenvio()"
                              >
                                <v-icon>fas fa-window-close</v-icon>
                              </v-btn>
                            </template>
                            <span>Cancelar reenvio</span>
                          </v-tooltip>
                        </v-bottom-navigation>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_preview_file_wa" width="700" scrollable>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center" justify="center">
            <v-col cols="12" v-if="tipo_base64_wa == 'image'">
              <v-img :src="base64_wa" height="700" contain />
            </v-col>
            <v-col cols="auto" v-if="tipo_base64_wa == 'video'">
              <video controls height="700" width="700">
                <source type="video/mp4" :src="base64_wa" />
              </video>
            </v-col>
            <v-col cols="12" v-if="tipo_base64_wa == 'audio'">
              <audio controls :src="base64_wa"></audio>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :href="base64_wa">Descargar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_preview_file_wa = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar_msg_error"
      elevation="24"
      color="red accent-2"
      top
    >
      {{ msg_error }}

      <v-btn @click="snackbar_msg_error = false" icon>
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Componentes de cierre -->
    <cierre-bam
      :estado_dialog.sync="dialog_cierre_bam"
      :id_cabina="id"
      ref="childComponent_bam"
    />
    <cierre-continental
      :estado_dialog.sync="dialog_cierre_continental"
      :id_cabina="id"
      ref="childComponent_cont"
    />
    <cierre-el-roble
      :estado_dialog.sync="dialog_cierre_elroble"
      :id_cabina="id"
      ref="childComponent_roble"
    />
    <cierre-ficohsa
      :estado_dialog.sync="dialog_cierre_ficohsa"
      :id_cabina="id"
      ref="childComponent_ficohsa"
    />
    <cierre-gy-t
      :estado_dialog.sync="dialog_cierre_gyt"
      :id_cabina="id"
      ref="childComponent_gyt"
    />
    <cierre-la-ceiba
      :estado_dialog.sync="dialog_cierre_ceiba"
      :id_cabina="id"
      ref="childComponent_ceiba"
    />
    <cierre-la-general
      :estado_dialog.sync="dialog_cierre_laGeneral"
      :id_cabina="id"
      ref="childComponent_general"
    />
    <cierre-qualitas
      :estado_dialog.sync="dialog_cierre_qualitas"
      :id_cabina="id"
      ref="childComponent_qua"
    />
    <cierre-qualitas-cr
      :estado_dialog.sync="dialog_cierre_qualitasCr"
      :id_cabina="id"
      ref="childComponent_quacr"
    />
    <cierre-resurrecion
      :estado_dialog.sync="dialog_cierre_resurrecion"
      :id_cabina="id"
      ref="childComponent_resurr"
    />
    <cierre-universales
      :estado_dialog.sync="dialog_cierre_universales"
      :id_cabina="id"
      ref="childComponent_univer"
    />
    <v-btn
      fixed
      bottom
      right
      dark
      color="indigo darken-1"
      style="margin-bottom: 200px"
      v-if="verNuevo == 1 && hasEncuestaSisa"
      @click="openEncuestaSisa"
    >
      ENCUESTA SISA
    </v-btn>
    <v-btn
      fixed
      bottom
      right
      color="cancel"
      style="margin-bottom: 160px"
      v-if="verNuevo == 1"
      @click="ocultarNuevo()"
    >
      CANCELAR
    </v-btn>
    <v-btn
      fixed
      bottom
      right
      color="orange"
      style="margin-bottom: 120px"
      v-if="verDet == 1"
      @click="isShowing = true"
    >
      BITACORA
    </v-btn>
    <v-btn
      fixed
      bottom
      right
      color="green"
      style="margin-bottom: 120px"
      @click="guardar()"
      :loading="btnloadingGuardar"
      :disabled="btnloadingGuardar"
      v-if="verDet == -1 && estatusAcciones('Crear')"
    >
      GUARDAR
    </v-btn>
    <v-btn
      fixed
      bottom
      right
      color="green"
      style="margin-bottom: 80px"
      v-if="verDet == 1 && estatusAcciones('Actualizar')"
      @click="actualizar()"
    >
      ACTUALIZAR
    </v-btn>
    <v-btn
      dark
      fixed
      bottom
      right
      color="blue"
      style="margin-bottom: 40px"
      v-if="
        solicitudGrua == 1 &&
        $store.state.usuario.rol != 'Inspector' &&
        estatusAcciones('Crear')
      "
      @click="servicioAdicional()"
    >
      SERVICIO ADICIONAL
    </v-btn>
    <v-btn
      v-scroll="onScroll"
      @click="toTop"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="red"
      v-if="verNuevo == 1 && false"
      class="mb-10"
    >
      <i class="fas fa-chevron-up"></i>
    </v-btn>

    <v-snackbar
      v-model="snackbar_file_exece_size"
      color="white"
      :timeout="0"
      top
    >
      <v-list class="pa-0">
        <span class="title"
          >Estos archivos no se enviaran porque sobrepasan el limite de
          tamaño</span
        ><br />
        <span class="subtitle-1">*Video (16 MB)</span><br />
        <span class="subtitle-1">*Documento (100 MB)</span>
        <template v-for="(item, i) in items_file_exeded_size">
          <v-list-item :key="i">
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
      <v-btn color="black" icon @click="snackbar_file_exece_size = false">
        <v-icon>fas fa-times-circle</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import settings from "../settings/index";
import moment from "moment";
import cierreBam from "../components/CierreAseguradoras/CierreBam.vue";
import cierreContinental from "../components/CierreAseguradoras/CierreContinental.vue";
import cierreElRoble from "../components/CierreAseguradoras/CierreElRoble.vue";
import cierreFicohsa from "../components/CierreAseguradoras/CierreFicohsa.vue";
import cierreGyT from "../components/CierreAseguradoras/CierreGyT.vue";
import cierreLaCeiba from "../components/CierreAseguradoras/CierreLaCeiba.vue";
import cierreLaGeneral from "../components/CierreAseguradoras/CierreLaGeneral.vue";
import cierreQualitas from "../components/CierreAseguradoras/CierreQualitas.vue";
import cierreQualitasCr from "../components/CierreAseguradoras/CierreQualitasCr.vue";
import cierreResurrecion from "../components/CierreAseguradoras/CierreResurrecion.vue";
import cierreUniversales from "../components/CierreAseguradoras/CierreUniversales.vue";
import MiniBitacora from "./Minis/MiniBitacora.vue";
import WhatsAppDialog from "../components/WhatsAppDialog.vue";
import { gmapApi } from "vue2-google-maps";
import imageCompression from "browser-image-compression";

import {
  dbRefProveedor,
  geofireRef,
  storage,
  dbRefAssaAsistencias,
} from "../main";
import MiniVanGrupo from "./Minis/MiniVanGrupo.vue";
import DatosTercero from "./DatosTercero.vue";
import TimePickerMenu from "./Minis/TimePickerMenu.vue";

export default {
  data() {
    return {
      autorizaGrua: [],
      nombreAutorizaGrua: "",
      vehiculoRecibeAcompaña: "",
      vehiculoViajaSolo: false,
      desbloqueoUsuariosLegales: [1035, 1063],
      horaConsultaAseguradora: null,
      horaConfirmacionAseguradora: null,
      btnConsulta: false,
      btnConfirmacion: false,
      hasEncuestaSisa: false,
      erroresAsistencia: [],
      selectedError: null,
      cantRecuperoEncontrado: false,
      rapiASSAPlataforma: null,
      rapiAssaOpciones: ["SI", "NO", "PENDIENTE"],
      vanGrupoCliente: null,
      vanGrupoServicios: [
        "ABASTO DE COMBUSTIBLE",
        "PASO DE CORRIENTE",
        "CERRAJERIA",
        "CAMBIO DE LLANTA",
        "GRUA LIVIANA",
        "GRUA POR ACCIDENTE LIVIANA",
        "GRUA PESADA",
        "GRUA POR ACCIDENTE PESADA",
        "GRUA PARA TERCERO",
        "GRUA PARA MOTOCICLETA",
        "CERRAJERIA HOGAR",
        "ELECTRICIDAD HOGAR",
        "FONTANERIA HOGAR",
      ],
      serviciosParaEncuesta: [
        "AJUSTE",
        "GRUA LIVIANA",
        "PASO DE CORRIENTE",
        "INSPECCION ON LINE",
        "CERRAJERIA",
        "CAMBIO DE LLANTA",
        "GRUA POR ACCIDENTE LIVIANA",
        "GRUA PESADA",
        "CONDUCTOR DESIGNADO",
        "GRUA PARA MOTOCICLETA",
        "TAXI",
        "MECANICA LIGERA",
        "ABASTO DE COMBUSTIBLE",
        "FONTANERIA HOGAR",
        "GRUA POR ACCIDENTE PESADA",
        "CERRAJERIA HOGAR",
        "ELECTRICIDAD HOGAR",
      ],
      morosidad: null,
      dañosPropios: null,
      vanGrupoId: null,
      vanGrupoEmpresa: null,
      horaCargaPortalAseguradora: null,
      helperNumeroTelefono: null,
      mensajeLinkEncuesta: "",
      mostrarLinkWhatsapp: false,
      bloquearQuejaObservaciones: false,
      peticionPendiente: false,
      isShowing: false,
      usuariosCostoDesbloqueado: [1, 5, 8, 1079, 1032, 1051, 1115],
      usuariosCantRecDesbloqueado: [1007, 1032, 1035, 1011, 1051],
      usuariosCargaAseguradoraDesbloqueado: [1127, 1145],
      analistasSISA: [],
      analistaSISAId: null,
      tallerId: null,
      talleresSISA: [],
      observacionesCancelacion: [],
      selectedObsCancelacion: null,
      comentarioAutoriza: null,
      costoCancelToken: null,
      costoEncontrado: false,
      dialogConfirm: false,
      isDigitador: false,
      digitador: null,
      fechaDigitador: null,
      autorizadoPor: null,
      fechaAutorizadoPor: null,
      gruasRegionales: [],
      snackState: false,
      snackText: "Mensaje",
      snackColor: "warning",
      snackTime: 4500,
      snackBarGlobal: false,
      snackBarGlobalText: "",
      dialog_cierre_bam: false,
      dialog_cierre_continental: false,
      dialog_cierre_elroble: false,
      dialog_cierre_ficohsa: false,
      dialog_cierre_gyt: false,
      dialog_cierre_ceiba: false,
      dialog_cierre_laGeneral: false,
      dialog_cierre_qualitas: false,
      dialog_cierre_qualitasCr: false,
      dialog_cierre_resurrecion: false,
      dialog_cierre_universales: false,
      cabinas: [],
      bitacoras: [],
      reincidencias: [],
      headers: [
        { text: "Opciones", value: "opciones", width: 200 },
        {
          text: "# Expediente",
          value: "expediente",
          align: "left",
        },
        {
          text: "Número Asistencia",
          value: "numeroAsistencia",
          align: "left",
        },
        {
          text: "Cartera",
          value: "cartera",
          align: "left",
        },
        {
          text: "Estatus",
          align: "left",
          value: "estatusAsistencia",
        },
        {
          text: "Fecha",
          value: "fechaHoraActual",
          align: "left",
          width: 110,
        },
        {
          text: "Proveedor",
          value: "proveedor",
          align: "left",
        },
        {
          text: "Tipo Asistencia",
          value: "tipoAsistencia",
          align: "center",
        },
        {
          text: "Tipo Servicio",
          value: "tipoServicio",
          align: "center",
        },
        { text: "Telefono", value: "numeroTelefono" },
        { text: "Placa", value: "placa", align: "left" },
        { text: "Poliza", value: "poliza", align: "left" },
        { text: "Marca", value: "marca", align: "left" },
        { text: "Modelo", value: "modelo", align: "left" },
        { text: "Año", value: "año", align: "left" },
        { text: "Titular poliza", value: "titularPoliza", align: "left" },
        { text: "Operador", value: "operador", align: "left" },
      ],
      valid: true,
      campoRequerido: [(v) => !!v || "Este campo es obligatorio"],
      search: "",
      btnloadingGuardar: false,
      id: "",
      idBase: "",
      idBaseAssa: "",
      fechaHoraActualNuevo: "",
      fechaHoraActual: "",
      cartera: "",
      list_cartera: [],
      fechaHoraOcurrencia: "",
      numeroAsistencia: "",
      tipoQueja: [],
      tipoQuejaId: null,
      tipoInspeccionOnline: [],
      descuentoId: null,
      descuentos: [],
      tipoInspeccionId: null,
      relacionTitular: [],
      relacionTitularId: null,
      numeroTelefono: "",
      numeroTelefono2: "",
      numeroTelefono3: "",
      placa: "",
      poliza: "",
      marca: "",
      modelo: "",
      año: 0,
      uso: "",
      titularPoliza: "",
      color: "",
      nombreConductor: "",
      pais: "",
      list_pais: settings.list_pais,
      depaSiniestro: "",
      list_depaSiniestro: settings.list_depaSiniestro,
      muniSiniestro: "",
      list_muniSiniestro: settings.list_muniSiniestro,
      comDireccionSiniestro: "",
      causa: "",
      list_causa: settings.list_causa,
      tipoServicio: "",
      list_tipoServicio: settings.list_tipoServicio,
      proveedor: "",
      list_proveedor: [],
      nombreProveedor: "",
      telefonoProveedor: "",
      fechaHoraAsignacion: "",
      depaOrigen: "",
      list_depaOrigen: settings.list_depaOrigen,
      muniOrigen: "",
      list_muniOrigen: settings.list_muniOrigen,
      comDireccionOrigen: "",
      depaDestino: "",
      list_depaDestino: settings.list_depaDestino,
      muniDestino: "",
      list_muniDestino: settings.list_muniDestino,
      comDireccionDestino: "",
      fechaHoraContacto: "",
      costoServicio: 0,
      costoSinDescuento: 0,
      totalDescuento: 0,
      fechaHoraCierreAsistencia: "",
      placaContraparte: "",
      partePolicial: false,
      obsAdicionales: "",
      tipoAsistencia: "",
      list_tipoAsistencia: [],
      quienSolicita: "",
      fechaSolicitudAjuste: "",
      seMovioDelLugar: false,
      zonaPeligrosa: false,
      reporteTardio: false,
      roboRecuperado: false,
      localForaneo: "",
      fueraTurno: false,
      kmCosto: 0,
      DUIPersonaRecupero: null,
      personaRecupero: null,
      list_localForaneo: settings.list_localForaneo,
      operador: "",
      estatusAsistencia: "EN PROCESO",
      list_estatusAsistencia: [],
      verNuevo: 0,
      errorPlaca: null,
      rulesC: [(c) => !!c || "El campo no puede esta vacio, colocar un cero."],
      valida: 0,
      validaMensaje: [],
      verDet: 0,
      solicitudGrua: 0,
      fab: false,
      colorSiniestro: "",
      colorOrigen: "",
      colorDestino: "",
      cantRecupero: "",
      overlay: false,
      snackError: false,
      snackErrorListar: false,
      btnContacto: false,
      btnFinalizado: false,
      btnCierreFinalizado: false,
      termino: "",
      estadoEbriedad: false,
      protocolo: false,
      pasaFiscalia: false,
      costoValid: false,
      textFieldAsignacionDisabled: true,
      textFieldContactoDisabled: true,
      textFieldTerminoDisabled: true,
      textFieldCierreDisabled: true,
      numeroCheque: "",
      responsable: "",
      metodoSolicitudAsistencia: "LLAMADA",
      list_metodoSolicitud: settings.list_metodoSolicitud,
      agente: "",
      checkboxRapiAssaSegunPlataforma: false,
      radioGroupRecobroConciliacion: null,
      pretencionInicial: "",
      pretencionFinal: "",
      num_chasis: "",
      num_motor: "",
      localidad_sisa: "",
      items_localidad_sisa: settings.list_localidad_sisa,
      //variables para ventana de reincidencias
      sheetReincidencia: false,
      btnSheetReincidencia: true,
      contadorReincidencias: 0,
      mensajeReincidencia: "Cargando...",
      //variables para almacenamiento de imagenes
      filesCargadas: [],
      filesDescargadas: [],
      imagenesPreview: [],
      filesDescargadasAudios: [],
      filesPDF: [],
      disabledCargarArchivos: true,
      disabledDescargarArchivos: true,
      numeroAsistenciaCargar: "",
      numeroAsistenciaDescargar: "",
      nombreImagen: "",
      model: null,
      listaArchivos: [],
      dialogVerImagen: false,
      dialogBorrarImagen: false,
      imagenDialog: "",
      banderaEliminar: false,
      bandera: 0,
      snackArchivoSubido: false,
      snackArchivoEliminado: false,
      overlayArchivos: false,
      tipoDatoArchivo: "",
      mostrarBotonDescargar: false,
      cabinistaContacto: "",
      cabinistaTermino: "",
      cabinistaCierre: "",
      fechaHoraProgramado: "",
      reembolso: false,
      //variables para encuesta de servicio
      checkResueltaNecesidad: null,
      checkNoResponde: null,
      radioGroupCalificaServicio: "",
      radioGroupCalificaEjecutivo: "",
      textAreaQuejaObservaciones: "",
      llenoFormularioReclamo: "",
      //variables varios
      dialogCartera: false,
      //variables para telegram
      chatId: -799958226,
      token: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
      chatIdproveedor: "",
      //variables de datos del ajustador para Assa
      expedienteAssa: "",
      inspeccionInSituVirtual: "",
      rapiAssaAsegurado: "",
      rapiAssaTercero: "",
      motivoNoUsoRapiassa: "",
      motivoNoUsoRapiassaTercero: "",
      motivoDeNoUsoTaller: "",
      usoGruaAsegurado: "",
      usoGruaTercero: "",
      tallerAsegurado: "",
      tallerTercero: "",
      estadoVirtual: "",
      list_inspeccionInSituVirtual: settings.list_inspeccionInSituVirtual,
      list_rapiAssaAsegurado: settings.list_rapiAssaAsegurado,
      list_rapiAssaTercero: settings.list_rapiAssaTercero,
      list_usoGruaAsegurado: settings.list_usoGruaAsegurado,
      list_estadoVirtual: settings.list_estadoVirtual,
      list_redTalleres: settings.list_redTalleres,
      list_motivoNoUsoRapiassa: settings.list_motivoNoUsoRapiassa,
      list_motivoDeNoTaller: settings.list_motivoDeNoTaller,
      itemsDeclinaciones: [
        "ESTADO DE EBRIEDAD",
        "CAMBIO DE CONDUCTOR",
        "FRAUDE",
      ],
      declinaciones: "",
      ahorroDe: "",
      enviadoPor: "",
      ajustador_cargo: "",
      //url_open_win: "http://localhost:8080/adminArchivos/",
      url_open_win: process.env.VUE_APP_URL_ADMIN_ONE_DRIVE,
      conductor_grua: "",
      list_conductor_grua: [],
      connection: "",
      dialog_chat_wha: false,
      items_chat: [],
      mensaje_chat: "",
      codigoSMS: "",
      temp_telefono: "",
      items_plantillas: [],
      items_tipo_multimedia: [
        { nombre: "Imagenes", tipo: "image", accept: "image/jpeg, image/png" },
        { nombre: "Videos", tipo: "video", accept: "video/mp4, video/3gp" },
        //{ nombre: "Audio", tipo: "audio", accept: "audio/aac, audio/mp4, audio/mpeg, audio/amr, audio/ogg" },
        {
          nombre: "Documentos",
          tipo: "document",
          accept:
            "text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        //{ nombre: "Ubicación", tipo: "ubicacion", accept: "" }
      ],
      nombre_encabezado_chat: "",
      dialog_preview_file_wa: false,
      base64_wa: "",
      tipo_base64_wa: "",
      bottom_sheet_multimedia: false,
      items_multimedia: [],
      extencion_multimedia: "",
      accept_multimedia: "",
      snackbar_msg_error: false,
      msg_error: "",
      items_actions_chat_wa: [
        { title: "Descargar", action: "descargar", tipo: "media" },
        { title: "Reenviar", action: "reenviar" },
        { title: "Eliminar", action: "eliminar" },
      ],
      items_mensajes_seleccionados: [],
      bandera_reenvio: false,
      options_image_compress: {
        maxSizeMB: 5,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        alwaysKeepResolution: true,
      },
      snackbar_file_exece_size: false,
      items_file_exeded_size: [],
      expediente: "",
      id_cartera: 0,
      tabs_chat_wa: "cliente",
    };
  },
  created() {
    this.listarComboBox();
    this.verificarUsuario();
    this.getProveedores();
    this.tipoAsistencias();
    // this.esuchadorApi();
  },
  watch: {
    vanGrupoCliente(val) {
      if (val) {
        this.titularPoliza = val.titularPoliza;
        this.poliza = val.DUI;
        if (val.tipo_tercero == "0002") {
          this.vanGrupoId = val.id_uuid;
          this.nombreConductor = `${val.nombre.trim()} ${val.apellidos.trim()}`;
        } else {
          this.vanGrupoId = val.titularPolizaId;
          this.nombreConductor = val.titularPoliza;
        }
        this.vanGrupoEmpresa = val.empresa;
      }
    },
    proveedor(val) {
      if (!val) {
        this.fechaHoraAsignacion = null;
      }
    },
    tipoAsistencia(val) {
      if (val && val != "QUEJA") {
        this.tipoQuejaId = null;
      }

      if (val && val != "INSPECCION ON LINE") {
        this.tipoInspeccionId = null;
      }
    },
    localForaneo(val) {
      if (val != "FORANEO") {
        this.kmCosto = 0;
      }
    },
  },
  computed: {
    talleresCartera() {
      if (this.cartera == "SISA SEGUROS") {
        return [
          "CENTRO DE ESTIMACION",
          "TALLER PARTICULAR",
          "PAGO EXPRESS",
          "VALUO VIDEO LLAMADA",
          "REPARACION POR SER ASEGURADO CON SISA",
        ];
      }
      return this.list_redTalleres;
    },
    isTipoAsistenciaGrua() {
      return this.tipoAsistencia.includes("GRUA");
    },
    isTipoAsistenciaManiobra() {
      return this.tipoAsistencia.includes("MANIOBRA");
    },
    filterEstadosAsistencias() {
      const helper = this.list_estatusAsistencia;
      if (
        this.tipoAsistencia != "LEGAL" &&
        this.tipoAsistencia != "GESTION LEGAL" &&
        this.tipoAsistencia != "Efecto de Pago Legal" &&
        this.tipoServicio != "CONEXION"
      ) {
        return helper.filter((ta) => ta.estado != "EN TRAMITE");
      }

      return helper;
    },
    showBitacoraLegal() {
      return this.tipoAsistencia == "LEGAL" && !this.desbloquearLegales;
    },
    getPorcentajeDescuento() {
      const descuento = this.descuentos.filter(
        (d) => d.descuentoId == this.descuentoId
      );

      if (descuento.length > 0) {
        return `${descuento[0].porcentaje * 100}%`;
      }

      return "0%";
    },
    getNumeroTelefono() {
      return this.numeroTelefono;
    },
    getWhatsAppURL() {
      const whatsAppLink = `https://api.whatsapp.com/send?phone=${this.codigoSMS}${this.numeroTelefono}&text=`;

      return `${whatsAppLink}${encodeURIComponent(this.mensajeLinkEncuesta)}`;
    },
    checkDisabledTermino() {
      const EDUARDO_RIVAS = 1063;
      const INDIANA_OBANDO = 1035;

      return (
        (this.obsAdicionales.trim() == "" &&
          this.$store.state.usuario.rol == "Inspector") ||
        (this.tipoAsistencia == "LEGAL" &&
          this.$store.state.usuario.idUsuario != INDIANA_OBANDO &&
          this.$store.state.usuario.idUsuario != EDUARDO_RIVAS) ||
        this.btnFinalizado ||
        this.fechaHoraContacto == null
      );
    },
    formTitle() {
      return "Seguimiento";
    },
    desbloquearCostoServicio() {
      return this.usuariosCostoDesbloqueado.some(
        (id) => this.$store.state.usuario.idUsuario == id
      );
    },
    desbloquearLegales() {
      return this.desbloqueoUsuariosLegales.some(
        (id) => this.$store.state.usuario.idUsuario == id
      );
    },
    desbloquearCantRecobro() {
      return this.usuariosCantRecDesbloqueado.some(
        (id) => this.$store.state.usuario.idUsuario == id
      );
    },
    desbloquearCargaAseguradora() {
      return this.usuariosCargaAseguradoraDesbloqueado.some(
        (id) => this.$store.state.usuario.idUsuario == id
      );
    },
    editarHoraCargaPortal() {
      return this.$store.state.usuario.idUsuario == 1143;
    },
    getPorcentajeRecupero() {
      return (this.cantRecupero * 0.05).toFixed(2);
    },
    nombreFechaDigitador() {
      if (this.digitador && this.fechaDigitador) {
        return `${this.digitador} (${this.fechaDigitador.replace("T", " ")})`;
      } else {
        return null;
      }
    },
    nombreFechaAutorizadoPor() {
      if (this.autorizadoPor && this.fechaAutorizadoPor) {
        return `${this.autorizadoPor} (${this.fechaAutorizadoPor.replace(
          "T",
          " "
        )})`;
      } else {
        return null;
      }
    },
    google: gmapApi,
  },
  components: {
    cierreBam,
    cierreContinental,
    cierreElRoble,
    cierreFicohsa,
    cierreGyT,
    cierreLaCeiba,
    cierreLaGeneral,
    cierreQualitas,
    cierreQualitasCr,
    cierreResurrecion,
    cierreUniversales,
    MiniBitacora,
    MiniVanGrupo,
    WhatsAppDialog,
    DatosTercero,
    TimePickerMenu,
  },
  mounted() {
    // this.connection.on("Receive", (model) => {
    //   //console.log(model);
    //   this.agregarActualizarWa(model);
    // });
  },
  methods: {
    updateDetallesCabina() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/DetallesCabina/${this.numeroAsistencia}`,
          {
            horaConsultaAseguradora: this.horaConsultaAseguradora,
            horaConfirmacionAseguradora: this.horaConfirmacionAseguradora,
            vehiculoViajaSolo: this.vehiculoViajaSolo,
            vehiculoRecibeAcompaña: this.vehiculoRecibeAcompaña,
            quienAutorizaGrua: this.nombreAutorizaGrua,
          },
          configuracion
        )
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    openEncuestaSisa() {
      if (!this.id) return;
      const routeData = this.$router.resolve({
        path: `Sisa/Encuesta/${this.id}`,
      });
      window.open(routeData.href, "_blank");
    },
    updateErrorAsistencia(id) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/ErroresAsistencia/${this.numeroAsistencia}`,
          {
            ErrorAsistenciaId: id,
          },
          configuracion
        )
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    getErrorAsistencia() {
      if (!this.id) return;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(`api/ErroresAsistencia/${this.numeroAsistencia}`, configuracion)
        .then((res) => {
          this.selectedError = res.data.errorId;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDetallesAsistencia() {
      if (!this.id) return;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(`api/DetallesCabina/${this.numeroAsistencia}`, configuracion)
        .then((res) => {
          this.horaConfirmacionAseguradora = res.data.horaConfirmadoAseguradora;
          this.horaConsultaAseguradora = res.data.horaConsultaAseguradora;
          this.vehiculoRecibeAcompaña = res.data.vehiculoRecibeAcompaña;
          this.nombreAutorizaGrua = res.data.quienAutorizaGrua;
          this.vehiculoViajaSolo = res.data.vehiculoViajaSolo;

          if (this.horaConsultaAseguradora) {
            this.btnConsulta = true;
          }
          if (this.horaConfirmacionAseguradora) {
            this.btnConfirmacion = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buscarVehiculoPorCampo(campo, valor) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.cartera == "ASSA COMPAÑIA DE SEGUROS") {
        axios
          .get(`/api/Assas/Buscar?campo=${campo}&valor=${valor}`, configuracion)
          .then((res) => {
            this.agregarDetalleAssa(res.data);
            this.sheetReincidencia = true;
            this.listarReincidencia();
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.cartera == "FUTURO ASISTENCIA") {
        axios
          .get(
            `/api/Asegurados/Buscar?campo=${campo}&valor=${valor}`,
            configuracion
          )
          .then((res) => {
            this.agregarDetalle(res.data);
            this.sheetReincidencia = true;
            this.listarReincidencia();
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    checkHasEncuestaSISA() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(`Sisa/HistorialEncuesta/${this.numeroAsistencia}`, configuracion)
        .then((res) => {
          this.hasEncuestaSisa = res.data;
        })
        .catch(() => {
          this.hasEncuestaSisa = false;
        });
    },
    hasBoleta(tipoAsistencia) {
      const tipos = [
        "ASISTENCIA PARA TERCERO",
        "ABASTO DE COMBUSTIBLE",
        "ABASTO DE AIRE",
        "CAMBIO DE LLANTA",
        "CERRAJERIA",
        "PASO DE CORRIENTE",
        "GRUA LIVIANA",
        "GRUA PARA MOTOCICLETA",
        "GRUA PARA TERCERO",
        "GRUA PESADA",
        "GRUA POR ACCIDENTE LIVIANA",
        "GRUA POR ACCIDENTE PESADA",
        "MANIOBRA",
        "MECANICA LIGERA",
        "TAXI",
        "CONDUCTOR DESIGNADO",
        "FONTANERIA HOGAR",
        "CERRAJERIA HOGAR",
        "ARMADO DE MUEBLES",
        "ELECTRICIDAD HOGAR",
        "MANIOBRA",
        "GRUA PARA TERCERO LIVIANA",
        "MANIOBRA PARA TERCERO LIVIANA",
        "MANIOBRA PARA TERCERO PESADA",
        "MANIOBRA ASEGURADO LIVIANA",
        "MANIOBRA ASEGURADO PESADA",
        "MANIOBRAS DESPERFECTO ASEGURADO PESADO",
        "MANIOBRAS DESPERFECTO ASEGURADO LIVIANA",
        "GRUA PARA MOTOCICLETA TERCERO",
        "GRUA PARA TERCERO PESADA",
        "PASO DE CORRIENTE PARA TERCERO",
        "CERRAJERIA PARA TERCERO",
        "CAMBIO DE LLANTA PARA TERCERO",
        "MECANICA LIGERA PARA TERCERO",
      ];

      return tipos.some((ta) => ta == tipoAsistencia);
    },
    checkHighLightRow(asistencia) {
      if (asistencia.termino && !asistencia.fechaHoraProgramado) {
        return "highlight-row default-row";
      } else if (asistencia.fechaHoraProgramado) {
        return "highlight-row-programada default-row";
      } else {
        return "default-row";
      }
    },
    generarBoletaElectronica(numeroAsistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/Cabinas/GenerarBoletaElectronica",
          {
            numeroAsistencia: numeroAsistencia,
          },
          configuracion
        )
        .then((res) => {
          if (res.data.includes(numeroAsistencia)) {
            this.snackText = res.data;
            this.snackColor = "primary";
            this.snackState = true;
          }
        })
        .catch((err) => {
          console.error(err);
          this.snackText = "No se pudo Generar la Boleta";
          this.snackColor = "error";
          this.snackState = true;
        });
    },
    openBoletaProveedor(numAsistencia) {
      const routeData = this.$router.resolve({
        path: `Boleta/${numAsistencia}`,
      });
      window.open(routeData.href, "_blank");
    },
    previewEncuestaLink() {
      const linkBase = process.env.VUE_APP_AXIOS;
      const linkEncuesta = `${linkBase}/Sisa/Encuesta/${this.id}`;

      this.mostrarLinkWhatsapp = true;
      this.helperNumeroTelefono = this.numeroTelefono;
      this.codigoSMS = "+503";

      this.mensajeLinkEncuesta = `${this.getSaludo()} tengo el gusto con ${this.titularPoliza.trim()}. \n`;
      this.mensajeLinkEncuesta += `Le saluda ${this.getNombreOperador()} de SISA asistencia; queremos agradecerle por utilizar nuestro servicio este día; y conocer su grado de satisfacción por medio de una breve encuesta por medio del siguiente link:`;
      this.mensajeLinkEncuesta += `\n\n ${linkEncuesta}`;
    },
    getSaludo() {
      const hora = new Date().getHours();

      if (hora >= 4 && hora < 12) {
        return "Buenos días,";
      } else if (hora >= 12 && hora < 18) {
        return "Buenas tardes,";
      } else {
        return "Buenas noches,";
      }
    },
    getNombreOperador() {
      const nombreUsuario = this.$store.state.usuario.nombre.trim();
      const splitNombre = nombreUsuario.split(" ");

      return splitNombre.length > 2
        ? `${splitNombre[0]} ${splitNombre[2]}`
        : nombreUsuario;
    },
    calcularCosto() {
      if (
        this.estatusAsistencia == "EN PROCESO" ||
        this.estatusAsistencia == "EN TRAMITE" ||
        this.estatusAsistencia == "SERVICIO MUERTO/BANDERAZO" ||
        this.estatusAsistencia == "FINALIZADO"
      ) {
        this.costoEncontrado = false;

        let header = { Authorization: "Bearer " + this.$store.state.token };

        axios
          .post(
            "api/CostosProveedores/GetCosto",
            {
              numeroAsistencia: this.numeroAsistencia,
              proveedorId: this.proveedor,
              tipoAsistencia: this.tipoAsistencia,
              fueraTurno: this.fueraTurno,
              localidad: this.localForaneo,
              expediente: this.expediente,
              kmCosto: this.kmCosto,
              cartera: this.cartera,
              estatusAsistencia: this.estatusAsistencia,
              descuentoId: this.descuentoId,
              nombreRecupero: this.radioGroupRecobroConciliacion,
              recupero: this.cantRecupero,
            },
            {
              headers: header,
              cancelToken: this.costoCancelToken
                ? this.costoCancelToken.token
                : null,
            }
          )
          .then((res) => {
            const detalleCostos = res.data;
            this.costoServicio = detalleCostos.costo.toFixed(2);
            this.costoSinDescuento = detalleCostos.costoSinDescuento.toFixed(2);
            this.totalDescuento = detalleCostos.totalDescuento.toFixed(2);

            this.costoEncontrado = this.costoServicio > 0 ? true : false;
          })
          .catch((err) => {
            if (axios.isCancel(err)) {
              console.warn(err.message);
            } else {
              this.costoEncontrado = false;
              console.error(err);
            }
            this.costoServicio = 0;
          });
      }
    },
    cerrarConfirmacion() {
      this.isDigitador = null;
      this.dialogConfirm = false;
    },
    mostrarConfirmacion() {
      if (this.$store.state.usuario.rol == "Digitador") {
        this.isDigitador = true;
      } else {
        this.isDigitador = false;
      }
      this.dialogConfirm = true;
    },
    verificarDigitadorAutorizado() {
      if (this.isDigitador) {
        this.asignarDigitador();
      } else {
        this.asignarAutorizadoPor();
      }
    },
    asignarDigitador() {
      if (this.id) {
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };

        axios
          .put(
            `api/Cabinas/AsignarDigitador`,
            {
              cabinaId: this.id,
              usuarioId: this.$store.state.usuario.idUsuario,
              fecha: this.getFechaHoraActual(),
            },
            configuracion
          )
          .then((res) => {
            this.digitador = res.data.digitador;
            this.fechaDigitador = res.data.fecha;

            this.listar();
            this.cerrarConfirmacion();
          })
          .catch((err) => console.error(err));
      }
    },
    asignarAutorizadoPor() {
      if (this.id) {
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };

        axios
          .put(
            `api/Cabinas/AsignarAutorizadoPor`,
            {
              cabinaId: this.id,
              usuarioId: this.$store.state.usuario.idUsuario,
              fecha: this.getFechaHoraActual(),
            },
            configuracion
          )
          .then((res) => {
            this.autorizadoPor = res.data.autorizadoPor;
            this.fechaAutorizadoPor = res.data.fecha;

            this.listar();
            this.cerrarConfirmacion();
          })
          .catch((err) => console.error(err));
      }
    },
    getFechaHoraActual() {
      let today = new Date();
      let fechaGuardado =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      return fechaGuardado;
    },
    listarEstadosAsistencia() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/EstadosAsistencia", configuracion)
        .then((res) => {
          const isAdminProveedores =
            this.$store.state.usuario.rol == "Admin Proveedores";
          if (isAdminProveedores) {
            this.list_estatusAsistencia = res.data;
          } else {
            const omitirEstados = ["NO PAGADA"];
            this.list_estatusAsistencia = res.data.filter(
              (estado) => !omitirEstados.includes(estado.estado)
            );
          }

          if (this.desbloquearLegales) {
            this.list_estatusAsistencia = res.data;
          } else {
            if (this.estatusAsistencia == "FINALIZADO") {
              this.list_estatusAsistencia = res.data;
            } else {
              if (this.tipoAsistencia == "LEGAL") {
                this.list_estatusAsistencia = res.data.filter(
                  (estado) => estado.estado != "FINALIZADO"
                );
              }
            }
          }
        })
        .catch((err) => console.error(err));
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      this.listarEstadosAsistencia();

      axios
        .get("api/Cabinas/RelacionTitular", configuracion)
        .then((res) => {
          this.relacionTitular = res.data;
        })
        .catch((err) => console.error(err));

      axios
        .get("api/TallerSisa", configuracion)
        .then((res) => {
          this.talleresSISA = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
      axios
        .get("api/ObservacionesCancelacion", configuracion)
        .then((res) => {
          this.observacionesCancelacion = res.data;
        })
        .catch((err) => console.error(err));

      axios
        .get(
          "api/HistorialOperadoresGrua/GruasDisponibles?disponibles=false",
          configuracion
        )
        .then((res) => (this.gruasRegionales = res.data))
        .catch((err) => console.error(err));

      axios
        .get("api/TipoQuejas", configuracion)
        .then((res) => (this.tipoQueja = res.data))
        .catch((err) => console.error(err));

      axios
        .get("api/TipoInspeccionOnline", configuracion)
        .then((res) => (this.tipoInspeccionOnline = res.data))
        .catch((err) => console.error(err));

      axios
        .get("api/Descuento", configuracion)
        .then((res) => (this.descuentos = res.data))
        .catch((err) => console.error(err));

      axios
        .get("api/ConfiguracionesGenerales/UsuariosCostos", configuracion)
        .then((res) => {
          this.usuariosCostoDesbloqueado = res.data.split(",");
        })
        .catch((err) => console.error(err));

      axios
        .get("api/Analistas", configuracion)
        .then((res) => {
          this.analistasSISA = res.data;
        })
        .catch((err) => console.error(err));

      axios
        .get("api/ConfiguracionesGenerales/UsuariosAseguradora", configuracion)
        .then((res) => {
          this.usuariosCargaAseguradoraDesbloqueado = res.data.split(",");
        })
        .catch((err) => console.error(err));

      axios
        .get("api/ConfiguracionesGenerales/UsuariosCantRecupero", configuracion)
        .then((res) => {
          this.usuariosCantRecDesbloqueado = res.data.split(",");
        })
        .catch((err) => console.error(err));

      axios
        .get("api/ErroresAsistencia", configuracion)
        .then((res) => {
          this.erroresAsistencia = res.data;
        })
        .catch((err) => console.error(err));

      axios
        .get("api/ConfiguracionesGenerales/UsuariosLegales", configuracion)
        .then((res) => {
          this.desbloqueoUsuariosLegales = res.data.split(",");
        })
        .catch((err) => console.error(err));

      axios
        .get("api/AutorizaGrua", configuracion)
        .then((res) => (this.autorizaGrua = res.data))
        .catch((err) => console.error(err));
    },
    esuchadorApi() {
      // this.connection = new signalR.HubConnectionBuilder()
      //   .withAutomaticReconnect()
      //   .withUrl(process.env.VUE_APP_AXIOS + "/callWhatsAppApi", {
      //     skipNegotiation: true,
      //     transport: signalR.HttpTransportType.WebSockets,
      //   })
      //   .build();
      // this.connection
      //   .start()
      //   .then(() => {
      //     console.log("Conexión establecida");
      //   })
      //   .catch(() => {
      //     console.log("No se pudo conectar");
      //   });
    },
    abrirDialogChat(telefono, ref, header_titulo) {
      return;
      //console.log(telefono, ref, header_titulo);
      this.tabs_chat_wa = "cliente";
      this.dialog_chat_wha = true;
      this.nombre_encabezado_chat = header_titulo;
      this.temp_telefono = this.asignarCodigoArea(this.pais) + telefono;

      this.listarChat();
      this.listarPlantillas();
    },
    async verMultimediaWhatsApp(id_multimedia) {
      if (id_multimedia == null) {
        return;
      }
      var result = await axios.get(
        "api/WhatsAppApi/getObtenerUrlMedia/" +
          id_multimedia +
          "/" +
          this.numeroAsistencia
      );

      if (result.data == "404") {
        return;
      }

      return (
        "data:" +
        result.data.split(" ")[1] +
        ";base64," +
        result.data.split(" ")[0]
      );
    },
    abrirDocumentoWa(preview, tipo) {
      //console.log(preview);
      //console.log(tipo);
      if (tipo == "image") {
        this.base64_wa = preview;
        this.tipo_base64_wa = tipo;
        this.dialog_preview_file_wa = true;
      }

      if (tipo == "video") {
        var video = document.createElement("video");
        document.body.appendChild(video);
        video.src = preview;
        video.controls = true;

        this.base64_wa = preview;
        this.tipo_base64_wa = tipo;
        this.dialog_preview_file_wa = true;
      }

      if (tipo == "document") {
        var w = window.open("about:blank");

        setTimeout(function () {
          w.document.body.appendChild(w.document.createElement("iframe")).src =
            preview;
          w.document.getElementsByTagName("iframe")[0].style.width = "100%";
          w.document.getElementsByTagName("iframe")[0].style.height = "100%";
        }, 0);
      }

      if (tipo == "audio") {
        this.base64_wa = preview;
        this.tipo_base64_wa = tipo;
        this.dialog_preview_file_wa = true;
      }

      if (tipo == "location") {
        window.open("https://maps.google.com/?q=" + preview, "_blank");
      }
    },
    listarChat() {
      this.items_chat = [];
      this.items_mensajes_seleccionados = [];
      axios
        .get(
          "api/WhatsAppApi/Listar/" +
            this.numeroAsistencia +
            "/" +
            this.temp_telefono
        )
        .then(async (response) => {
          for (var i = 0; i < response.data.length; i++) {
            await this.verMultimediaWhatsApp(
              response.data[i].id_multimedia
            ).then((response_item) => {
              //console.log(response_item);
              this.items_chat.push({
                id_wa_api: response.data[i].id_wa_api,
                id_usuario: response.data[i].id_usuario,
                id_wa: response.data[i].id_wa,
                id_multimedia: response.data[i].id_multimedia,
                nombre_contacto: response.data[i].nombre_contacto,
                numero_contacto: response.data[i].numero_contacto,
                mensaje: response.data[i].mensaje,
                fecha_mensaje: response.data[i].fecha_mensaje,
                numero_asistencia: response.data[i].numero_asistencia,
                tipo: response.data[i].tipo,
                estado: response.data[i].estado,
                tipo_usuario: response.data[i].tipo_usuario,
                mensaje_error: response.data[i].mensaje_error,
                preview: response_item,
                latitude: parseFloat(response.data[i].latitude),
                longitude: parseFloat(response.data[i].longitude),
                name: response.data[i].name,
                address: response.data[i].address,
              });
              this.onScrollChat();
            });
          }
        });
    },
    agregarActualizarWa(model) {
      if (model.entry[0].changes[0].value.messages != null) {
        this.agregarMensajeRecibido(model);
      }
      if (model.entry[0].changes[0].value.statuses != null) {
        this.actualizarEstadoMensaje(model);
      }
    },
    agregarMensajeRecibido(model) {
      axios
        .get(
          "api/WhatsAppApi/ListarPorIdWa/" +
            model.entry[0].changes[0].value.messages[0].id
        )
        .then(async (obj) => {
          //console.log(obj.data);
          await this.verMultimediaWhatsApp(obj.data.id_multimedia).then(
            (response_item) => {
              this.items_chat.push({
                id_wa_api: obj.data.id_wa_api,
                id_usuario: obj.data.id_usuario,
                id_wa: obj.data.id_wa,
                id_multimedia: obj.data.id_multimedia,
                nombre_contacto: obj.data.nombre_contacto,
                numero_contacto: obj.data.numero_contacto,
                mensaje: obj.data.mensaje,
                fecha_mensaje: obj.data.fecha_mensaje,
                numero_asistencia: obj.data.numero_asistencia,
                tipo: obj.data.tipo,
                estado: obj.data.estado,
                tipo_usuario: obj.data.tipo_usuario,
                mensaje_error: obj.data.mensaje_error,
                preview: response_item,
                latitude: parseFloat(obj.data.latitude),
                longitude: parseFloat(obj.data.longitude),
                name: obj.data.name,
                address: obj.data.address,
              });
            }
          );
        });
      this.onScrollChat();
    },
    async actualizarEstadoMensaje(item) {
      //console.log(item.entry[0].changes[0].value.statuses[0]);
      if (
        item.entry[0].changes[0].value.statuses[0].errors != null &&
        item.entry[0].changes[0].value.statuses[0].status == "failed"
      ) {
        var index = this.items_chat.findIndex(
          (obj) => obj.id_wa == item.entry[0].changes[0].value.statuses[0].id
        );
        //console.log(this.items_chat[index]);
        if (index != -1) {
          this.items_chat[index].estado =
            item.entry[0].changes[0].value.statuses[0].status;
          this.items_chat[index].mensaje_error =
            item.entry[0].changes[0].value.statuses[0].errors[0].title;
        }
      }
      if (item.entry[0].changes[0].value.statuses[0].errors == null) {
        var index = this.items_chat.findIndex(
          (obj) => obj.id_wa == item.entry[0].changes[0].value.statuses[0].id
        );
        if (index != -1) {
          this.items_chat[index].estado =
            item.entry[0].changes[0].value.statuses[0].status;
        }
      }
    },
    verMensajeErrorWa(item) {
      this.msg_error = item;
      this.snackbar_msg_error = true;
    },
    listarPlantillas() {
      axios.get("api/WhatsAppApiPlantillas/Listar").then((response) => {
        //console.log(response.data);
        this.items_plantillas = response.data;
      });
    },
    enviarMensajePlantilla(item) {
      //console.log(item);
      axios
        .get(
          "api/WhatsAppApiParametrosPlantillas/Listar/" +
            item.id_plantilla_wa_api
        )
        .then((response) => {
          //console.log(response.data);
          //ENVIO DE PLANTILLA SIN VARIABLE DE ENCABEZADO Y CUERPO DE MENSAJE
          if (response.data.length == 0 && item.encabezado_variable == false) {
            this.enviarPlantillaSinParametros(item);
          } else if (
            response.data.length == 0 &&
            item.encabezado_variable == true
          ) {
            this.enviarPlantillaHeaderVariables(item);
          } else if (
            response.data.length > 0 &&
            item.encabezado_variable == false
          ) {
            this.enviarPlantillaBodyVariables(item, response.data);
          } else if (
            response.data.length > 0 &&
            item.encabezado_variable == true
          ) {
            this.enviarPlantillaConParametros(item, response.data);
          }
        });
    },
    enviarPlantillaSinParametros(plantilla) {
      //console.log("sin variables", plantilla);
      var encabezado_db = plantilla.mensaje_encabezado;
      var mensaje_db = plantilla.mensaje_plantilla;

      var date = new Date();
      axios
        .post("api/WhatsAppApiContactos/Crear", {
          id_usuario: this.$store.state.usuario.idUsuario,
          mensaje_encabezado: encabezado_db,
          template_bd: mensaje_db,
          temp_asistencia: this.numeroAsistencia,
          nombre_contacto: "",
          numero_contacto: this.temp_telefono,
          fecha_mensaje:
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate() +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes() +
            ":" +
            date.getSeconds(),
          tipo_mensaje: "text",
          messaging_product: "whatsapp",
          to: this.temp_telefono,
          type: "template",
          template: {
            name: plantilla.identificador_wa_api,
            language: {
              code: "es",
            },
          },
        })
        .then((response) => {
          //console.log("RESPONSE ", response.data);
          axios
            .get("api/WhatsAppApi/ListarPorIdWa/" + response.data)
            .then(async (obj) => {
              //console.log(obj.data);
              await this.verMultimediaWhatsApp(obj.data.id_multimedia).then(
                (response_item) => {
                  this.items_chat.push({
                    id_wa_api: obj.data.id_wa_api,
                    id_usuario: obj.data.id_usuario,
                    id_wa: obj.data.id_wa,
                    id_multimedia: obj.data.id_multimedia,
                    nombre_contacto: obj.data.nombre_contacto,
                    numero_contacto: obj.data.numero_contacto,
                    mensaje: obj.data.mensaje,
                    fecha_mensaje: obj.data.fecha_mensaje,
                    numero_asistencia: obj.data.numero_asistencia,
                    tipo: obj.data.tipo,
                    estado: obj.data.estado,
                    tipo_usuario: obj.data.tipo_usuario,
                    mensaje_error: obj.data.mensaje_error,
                    preview: response_item,
                    latitude: obj.data.latitude,
                    longitude: obj.data.longitude,
                    name: obj.data.name,
                    address: obj.data.address,
                  });
                  this.onScrollChat();
                }
              );
            });
        });
    },
    enviarPlantillaHeaderVariables(plantilla) {
      //console.log("solo header variable", plantilla);
      var encabezado_db = plantilla.mensaje_encabezado;
      encabezado_db = encabezado_db.replace(
        "{{1}}",
        eval("this." + plantilla.encabezado)
      );

      var date = new Date();
      axios
        .post("api/WhatsAppApiContactos/Crear", {
          id_usuario: this.$store.state.usuario.idUsuario,
          mensaje_encabezado: encabezado_db,
          template_bd: plantilla.mensaje_plantilla,
          temp_asistencia: this.numeroAsistencia,
          nombre_contacto: "",
          fecha_mensaje:
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate() +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes() +
            ":" +
            date.getSeconds(),
          numero_contacto: this.temp_telefono,
          tipo_mensaje: "text",
          messaging_product: "whatsapp",
          to: this.temp_telefono,
          type: "template",
          template: {
            name: plantilla.identificador_wa_api,
            language: {
              code: "es",
            },
            components: [
              {
                type: "header",
                parameters: [
                  {
                    type: "text",
                    text: eval("this." + plantilla.encabezado),
                  },
                ],
              },
            ],
          },
        })
        .then((response) => {
          if (response.data.error) {
            this.alertaError(response.data.error.error_data.details);
            return;
          }
          axios
            .get("api/WhatsAppApi/ListarPorIdWa/" + response.data)
            .then(async (obj) => {
              await this.verMultimediaWhatsApp(obj.data.id_multimedia).then(
                (response_item) => {
                  this.items_chat.push({
                    id_wa_api: obj.data.id_wa_api,
                    id_usuario: obj.data.id_usuario,
                    id_wa: obj.data.id_wa,
                    id_multimedia: obj.data.id_multimedia,
                    nombre_contacto: obj.data.nombre_contacto,
                    numero_contacto: obj.data.numero_contacto,
                    mensaje: obj.data.mensaje,
                    fecha_mensaje: obj.data.fecha_mensaje,
                    numero_asistencia: obj.data.numero_asistencia,
                    tipo: obj.data.tipo,
                    estado: obj.data.estado,
                    tipo_usuario: obj.data.tipo_usuario,
                    mensaje_error: obj.data.mensaje_error,
                    preview: response_item,
                    latitude: obj.data.latitude,
                    longitude: obj.data.longitude,
                    name: obj.data.name,
                    address: obj.data.address,
                  });
                  this.onScrollChat();
                }
              );
            });
        });
    },
    enviarPlantillaBodyVariables(plantilla, valores = []) {
      //console.log("aqui solo body", plantilla, valores);
      var mensaje_db = plantilla.mensaje_plantilla;
      var parametros_wa = [];

      for (var i = 0; i < valores.length; i++) {
        //AQUI SE VA CREADO LA CADENA CON LOS VALORES DE LAS VARIABLES A GUARDAR EN BD
        mensaje_db = mensaje_db.replace(
          valores[i].clave,
          eval("this." + valores[i].nombre_variable_cabina)
        );

        //ESTA CONDICION SIRVE PARA REMOVER LOS MULTIPLES SALTOS DE LINEAS
        if (
          "this.obsAdicionales" ==
          "this." + valores[i].nombre_variable_cabina
        ) {
          var temp = eval("this." + valores[i].nombre_variable_cabina);
          var temp_replace = temp.replace(/\n|\r/g, ",");

          parametros_wa.push({
            type: "text",
            text: temp_replace,
          });
        } else {
          parametros_wa.push({
            type: "text",
            text: eval("this." + valores[i].nombre_variable_cabina),
          });
        }
      }

      var date = new Date();
      axios
        .post("api/WhatsAppApiContactos/Crear", {
          id_usuario: this.$store.state.usuario.idUsuario,
          mensaje_encabezado: "",
          template_bd: mensaje_db,
          temp_asistencia: this.numeroAsistencia,
          nombre_contacto: "",
          fecha_mensaje:
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate() +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes() +
            ":" +
            date.getSeconds(),
          numero_contacto: this.temp_telefono,
          tipo_mensaje: "text",
          messaging_product: "whatsapp",
          to: this.temp_telefono,
          type: "template",
          template: {
            name: plantilla.identificador_wa_api,
            language: {
              code: "es",
            },
            components: [
              {
                type: "body",
                parameters: parametros_wa,
              },
            ],
          },
        })
        .then((response) => {
          if (response.data.error) {
            this.alertaError(response.data.error.error_data.details);
            return;
          }
          axios
            .get("api/WhatsAppApi/ListarPorIdWa/" + response.data)
            .then(async (obj) => {
              await this.verMultimediaWhatsApp(obj.data.id_multimedia).then(
                (response_item) => {
                  this.items_chat.push({
                    id_wa_api: obj.data.id_wa_api,
                    id_usuario: obj.data.id_usuario,
                    id_wa: obj.data.id_wa,
                    id_multimedia: obj.data.id_multimedia,
                    nombre_contacto: obj.data.nombre_contacto,
                    numero_contacto: obj.data.numero_contacto,
                    mensaje: obj.data.mensaje,
                    fecha_mensaje: obj.data.fecha_mensaje,
                    numero_asistencia: obj.data.numero_asistencia,
                    tipo: obj.data.tipo,
                    estado: obj.data.estado,
                    tipo_usuario: obj.data.tipo_usuario,
                    mensaje_error: obj.data.mensaje_error,
                    preview: response_item,
                    latitude: obj.data.latitude,
                    longitude: obj.data.longitude,
                    name: obj.data.name,
                    address: obj.data.address,
                  });
                  this.onScrollChat();
                }
              );
            });
        });
    },
    enviarPlantillaConParametros(plantilla, valores = []) {
      //console.log("con variables body y header", plantilla, valores);
      var encabezado_db = plantilla.mensaje_encabezado;
      encabezado_db = encabezado_db.replace(
        "{{1}}",
        eval("this." + plantilla.encabezado)
      );

      var mensaje_db = plantilla.mensaje_plantilla;
      var parametros_wa = [];
      for (var i = 0; i < valores.length; i++) {
        //AQUI SE VA CREADO LA CADENA CON LOS VALORES DE LAS VARIABLES A GUARDAR EN BD
        mensaje_db = mensaje_db.replace(
          valores[i].clave,
          eval("this." + valores[i].nombre_variable_cabina)
        );

        //ESTA CONDICION SIRVE PARA REMOVER LOS MULTIPLES SALTOS DE LINEAS
        if (
          "this.obsAdicionales" ==
          "this." + valores[i].nombre_variable_cabina
        ) {
          var temp = eval("this." + valores[i].nombre_variable_cabina);
          var temp_replace = temp.replace(/\n|\r/g, ",");

          parametros_wa.push({
            type: "text",
            text: temp_replace,
          });
        } else {
          parametros_wa.push({
            type: "text",
            text: eval("this." + valores[i].nombre_variable_cabina),
          });
        }
      }

      var date = new Date();
      axios
        .post("api/WhatsAppApiContactos/Crear", {
          id_usuario: this.$store.state.usuario.idUsuario,
          mensaje_encabezado: encabezado_db,
          template_bd: mensaje_db,
          temp_asistencia: this.numeroAsistencia,
          nombre_contacto: "",
          fecha_mensaje:
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate() +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes() +
            ":" +
            date.getSeconds(),
          numero_contacto: this.temp_telefono,
          tipo_mensaje: "text",
          messaging_product: "whatsapp",
          to: this.temp_telefono,
          type: "template",
          template: {
            name: plantilla.identificador_wa_api,
            language: {
              code: "es",
            },
            components: [
              {
                type: "header",
                parameters: [
                  {
                    type: "text",
                    text: eval("this." + plantilla.encabezado),
                  },
                ],
              },
              {
                type: "body",
                parameters: parametros_wa,
              },
            ],
          },
        })
        .then((response) => {
          //console.log(response.data);
          if (response.data.error) {
            this.alertaError(response.data.error.error_data.details);
            return;
          }
          axios
            .get("api/WhatsAppApi/ListarPorIdWa/" + response.data)
            .then(async (obj) => {
              await this.verMultimediaWhatsApp(obj.data.id_multimedia).then(
                (response_item) => {
                  this.items_chat.push({
                    id_wa_api: obj.data.id_wa_api,
                    id_usuario: obj.data.id_usuario,
                    id_wa: obj.data.id_wa,
                    id_multimedia: obj.data.id_multimedia,
                    nombre_contacto: obj.data.nombre_contacto,
                    numero_contacto: obj.data.numero_contacto,
                    mensaje: obj.data.mensaje,
                    fecha_mensaje: obj.data.fecha_mensaje,
                    numero_asistencia: obj.data.numero_asistencia,
                    tipo: obj.data.tipo,
                    estado: obj.data.estado,
                    tipo_usuario: obj.data.tipo_usuario,
                    mensaje_error: obj.data.mensaje_error,
                    preview: response_item,
                    latitude: obj.data.latitude,
                    longitude: obj.data.longitude,
                    name: obj.data.name,
                    address: obj.data.address,
                  });
                  this.onScrollChat();
                }
              );
            });
        });
    },
    enviarMensajeLibre() {
      if (this.items_multimedia.length > 0) {
        return;
      }

      axios
        .post("api/WhatsAppApi/enviarMensaje", {
          id_usuario: this.$store.state.usuario.idUsuario,
          numero_asistencia: this.numeroAsistencia,
          messaging_product: "whatsapp",
          recipient_type: "individual",
          to: this.temp_telefono,
          type: "text",
          text: {
            body: this.mensaje_chat,
          },
        })
        .then((response) => {
          //console.log(response.data);
          axios
            .get("api/WhatsAppApi/ListarPorIdWa/" + response.data)
            .then(async (obj) => {
              //console.log(obj.data);
              await this.verMultimediaWhatsApp(obj.data.id_multimedia).then(
                (response_item) => {
                  this.items_chat.push({
                    id_wa_api: obj.data.id_wa_api,
                    id_usuario: obj.data.id_usuario,
                    id_wa: obj.data.id_wa,
                    id_multimedia: obj.data.id_multimedia,
                    nombre_contacto: obj.data.nombre_contacto,
                    numero_contacto: obj.data.numero_contacto,
                    mensaje: obj.data.mensaje,
                    fecha_mensaje: obj.data.fecha_mensaje,
                    numero_asistencia: obj.data.numero_asistencia,
                    tipo: obj.data.tipo,
                    estado: obj.data.estado,
                    tipo_usuario: obj.data.tipo_usuario,
                    mensaje_error: obj.data.mensaje_error,
                    preview: response_item,
                    latitude: obj.data.latitude,
                    longitude: obj.data.longitude,
                    name: obj.data.name,
                    address: obj.data.address,
                  });
                }
              );
            });

          this.mensaje_chat = "";
          this.onScrollChat();
        });
    },
    enviarMultimedia(item) {
      //console.log(item);
      this.extencion_multimedia = item.tipo;
      this.accept_multimedia = item.accept;
      this.bottom_sheet_multimedia = true;
    },
    enviarmensajeMultimedia() {
      this.items_multimedia.forEach(async (element) => {
        //console.log(element);
        let header = {
          Authorization:
            "Bearer EAAFZBrSG2cjsBO7lKIZBmwddrwQTtzOhDsNMEMaCI8FT3gorQNNMZCVhspfUgLC3D6h8s407sKWyBTWylXPG0bQCAIMIfz9fhFTx4rqwyTzaWFdXbLhEd5hbqfsk4tJQc5XaECZChDiT9XK4ZBNElwIJhB9oxrOui3Rrbu82yLaIpVWzZBOcJ4CF0PsN3w238A",
        };
        let configuracion = { headers: header };

        const form = new FormData();
        form.append("file", element, element.name);
        form.append("type", element.type);
        form.append("messaging_product", "whatsapp");

        const response = await axios.post(
          "https://graph.facebook.com/v18.0/113495845187060/media",
          form,
          configuracion
        );

        axios
          .post("api/WhatsAppApi/enviarMensaje", {
            id_usuario: this.$store.state.usuario.idUsuario,
            numero_asistencia: this.numeroAsistencia,
            messaging_product: "whatsapp",
            recipient_type: "individual",
            to: this.temp_telefono,
            type: this.extencion_multimedia,
            [this.extencion_multimedia]: {
              id: response.data.id,
            },
          })
          .then((response) => {
            //console.log("RESPONSE", response.data);
            axios
              .get("api/WhatsAppApi/ListarPorIdWa/" + response.data)
              .then(async (obj) => {
                //console.log(obj.data);
                await this.verMultimediaWhatsApp(obj.data.id_multimedia).then(
                  (response_item) => {
                    this.items_chat.push({
                      id_wa_api: obj.data.id_wa_api,
                      id_usuario: obj.data.id_usuario,
                      id_wa: obj.data.id_wa,
                      id_multimedia: obj.data.id_multimedia,
                      nombre_contacto: obj.data.nombre_contacto,
                      numero_contacto: obj.data.numero_contacto,
                      mensaje: obj.data.mensaje,
                      fecha_mensaje: obj.data.fecha_mensaje,
                      numero_asistencia: obj.data.numero_asistencia,
                      tipo: obj.data.tipo,
                      estado: obj.data.estado,
                      tipo_usuario: obj.data.tipo_usuario,
                      mensaje_error: obj.data.mensaje_error,
                      preview: response_item,
                      latitude: obj.data.latitude,
                      longitude: obj.data.longitude,
                      name: obj.data.name,
                      address: obj.data.address,
                    });
                  }
                );
              });

            this.items_multimedia = [];
            this.mensaje_chat = "";
            this.onScrollChat();
          });
      });
    },
    accionesMensaje(item_actions, item) {
      //console.log(item_actions, item);
      if (item_actions == "reenviar") {
        this.bandera_reenvio = true;
      }
    },
    reenviarMensaje() {
      //console.log(this.items_mensajes_seleccionados);
      for (var i = 0; i < this.items_mensajes_seleccionados.length; i++) {
        switch (this.items_mensajes_seleccionados[i].tipo) {
          case "text":
            axios
              .post("api/WhatsAppApi/enviarMensaje", {
                id_usuario: this.$store.state.usuario.idUsuario,
                numero_asistencia: this.numeroAsistencia,
                messaging_product: "whatsapp",
                recipient_type: "individual",
                to: this.asignarCodigoArea(this.pais) + this.telefonoProveedor,
                type: this.items_mensajes_seleccionados[0].tipo,
                text: {
                  body: this.items_mensajes_seleccionados[0].mensaje,
                },
              })
              .then(() => {
                this.alertaCorrecto("Mensaje reenviado");
              })
              .catch(() => {
                this.alertaError("No se pudo enviar el mensaje");
              });
            break;
          case "location":
            axios
              .post("api/WhatsAppApi/enviarMensaje", {
                id_usuario: this.$store.state.usuario.idUsuario,
                numero_asistencia: this.numeroAsistencia,
                messaging_product: "whatsapp",
                recipient_type: "individual",
                to: this.asignarCodigoArea(this.pais) + this.telefonoProveedor,
                type: this.items_mensajes_seleccionados[0].tipo,
                location: {
                  longitude: this.items_mensajes_seleccionados[0].longitude,
                  latitude: this.items_mensajes_seleccionados[0].latitude,
                  name: this.items_mensajes_seleccionados[0].name,
                  address: this.items_mensajes_seleccionados[0].address,
                },
              })
              .then(() => {
                this.alertaCorrecto("Mensaje reenviado");
              })
              .catch(() => {
                this.alertaError("No se pudo enviar el mensaje");
              });
            break;
          case "image":
          case "video":
          case "audio":
          case "document":
            axios
              .post("api/WhatsAppApi/enviarMensaje", {
                id_usuario: this.$store.state.usuario.idUsuario,
                numero_asistencia: this.numeroAsistencia,
                messaging_product: "whatsapp",
                recipient_type: "individual",
                to: this.asignarCodigoArea(this.pais) + this.telefonoProveedor,
                type: this.items_mensajes_seleccionados[0].tipo,
                [this.items_mensajes_seleccionados[0].tipo]: {
                  id: this.items_mensajes_seleccionados[0].id_multimedia,
                },
              })
              .then(() => {
                this.alertaCorrecto("Mensaje reenviado");
              })
              .catch(() => {
                this.alertaError("No se pudo enviar el mensaje");
              });
            break;
        }
      }
    },
    cancelarReenvio() {
      this.bandera_reenvio = false;
      this.items_mensajes_seleccionados = [];
    },
    async verificarMultimedia() {
      this.items_file_exeded_size = [];
      for (var i = 0; i < this.items_multimedia.length; i++) {
        if (this.extencion_multimedia == "image") {
          if (this.items_multimedia[i].size >= 5000000) {
            this.items_multimedia[i] = await imageCompression(
              this.items_multimedia[i],
              this.options_image_compress
            );
          }
        }
        if (this.extencion_multimedia == "video") {
          if (this.items_multimedia[i].size >= 16000000) {
            this.items_multimedia.splice(i, 1);
            this.items_file_exeded_size.push(this.items_multimedia[i].name);
          }
        }
        if (this.extencion_multimedia == "document") {
          if (this.items_multimedia[i].size >= 100000000) {
            this.items_multimedia.splice(i, 1);
            this.items_file_exeded_size.push(this.items_multimedia[i].name);
          }
        }
      }
      //console.log(this.items_file_exeded_size);
      if (this.items_file_exeded_size.length > 0) {
        this.snackbar_file_exece_size = true;
      }
    },
    deleteChip(index, text) {
      this.items_multimedia.splice(index, 1);
    },
    asignarCodigoArea(data) {
      if (data == "EL SALVADOR") {
        return "503";
      } else if (data == "GUATEMALA") {
        return "502";
      } else if (data == "HONDURAS") {
        return "504";
      } else if (data == "NICARAGUA") {
        return "505";
      } else if (data == "COSTA RICA") {
        return "506";
      } else if (data == "PANAMÁ") {
        return "507";
      } else if (data == "BELICE") {
        return "501";
      } else if (data == "MÉXICO") {
        return "52";
      }
    },
    alertaError(mensaje) {
      this.$toast.error(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 0,
      });
    },
    alertaCorrecto(mensaje) {
      this.$toast.success(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 10000,
      });
    },
    onScrollChat() {
      this.$nextTick(function () {
        var container = this.$refs.msgContainer;
        container.scrollTop = container.scrollHeight + 120;
      });
    },
    verDetallesAperturaCierre() {
      if (this.cartera == "BAM") {
        this.dialog_cierre_bam = true;
        this.$refs.childComponent_bam.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "SEGUROS CONTINENTAL SA") {
        this.dialog_cierre_continental = true;
        this.$refs.childComponent_cont.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "SEGUROS EL ROBLE") {
        this.dialog_cierre_elroble = true;
        this.$refs.childComponent_roble.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "SEGUROS FICOHSA") {
        this.dialog_cierre_ficohsa = true;
        this.$refs.childComponent_ficohsa.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "G&T") {
        this.dialog_cierre_gyt = true;
        this.$refs.childComponent_gyt.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "SEGUROS LA CEIBA") {
        this.dialog_cierre_ceiba = true;
        this.$refs.childComponent_ceiba.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "LA GENERAL") {
        this.dialog_cierre_laGeneral = true;
        this.$refs.childComponent_general.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "QUALITAS COMPAÑIA DE SEGUROS") {
        this.dialog_cierre_qualitas = true;
        this.$refs.childComponent_qua.listarDatos_qua(this.estatusAsistencia);
      }
      if (this.cartera == "QUALITAS COSTA RICA") {
        this.dialog_cierre_qualitasCr = true;
        this.$refs.childComponent_quacr.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "LA RESURRECCION") {
        this.dialog_cierre_resurrecion = true;
        this.$refs.childComponent_resurr.listarDatos(this.estatusAsistencia);
      }
      if (this.cartera == "SEGUROS UNIVERSALES") {
        this.dialog_cierre_universales = true;
        this.$refs.childComponent_univer.listarDatos(this.estatusAsistencia);
      }
    },
    async validarCierreCamposCartera(endpoint) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      return await axios.get(
        "api/" + endpoint + "/Listar/" + this.id,
        configuracion
      );
    },
    tipoAsistencias() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/TipoAsistencias/Activas", configuracion)
        .then((res) => (this.list_tipoAsistencia = res.data))
        .catch((err) => console.error(err));
    },
    carteras() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => (this.list_cartera = res.data))
        .catch((err) => console.error(err));
    },
    async operadoresGrua() {
      var result = await settings.metodos.listarOperadoresGrua();
      this.list_conductor_grua = result.data;
    },
    estatusAcciones(nombre) {
      var item = this.$store.state.acciones.find(
        (object) => object.nombre_acciones == nombre
      );
      if (item.estatus) {
        return true;
      }
    },
    async oneDrive(item) {
      window.open(this.url_open_win + item.numeroAsistencia, "_blank");
    },
    seleccionarCartera(item) {
      this.dialogCartera = false;
      switch (item) {
        case "fa":
          this.cartera = "FUTURO ASISTENCIA";
          this.tipoServicio = "EMERGENCIA";
          break;
        case "acs":
          this.cartera = "ASSA COMPAÑIA DE SEGUROS";
          this.tipoServicio = "EMERGENCIA";
          break;
        case "sisa":
          this.cartera = "SISA SEGUROS";
          this.tipoServicio = "ADICIONAL";
          break;
      }
    },
    limpiarCalificaServicio() {
      this.radioGroupCalificaServicio = null;
    },
    limpiarResuletaNecesidad() {
      this.checkResueltaNecesidad = null;
    },
    getProveedores() {
      const listaProveedores = [];
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/DetallexProveedores/Listar", configuracion)
        .then(function (response) {
          const list_proveedores = response.data;
          for (var i = 0; i < list_proveedores.length; i++) {
            if (list_proveedores[i].estado) {
              me.list_proveedor.push({
                idProveedor: list_proveedores[i].idProveedor,
                nombre: list_proveedores[i].nombre,
              });
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
      return listaProveedores;
    },
    mostrarNuevo() {
      let me = this;
      this.carteras();
      var today = new Date();
      this.operador = me.$store.state.usuario.nombre;
      this.verNuevo = 1;
      this.verDet = -1;
      this.dialogCartera = true;
      this.fechaHoraActualNuevo =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    buscarPlaca() {
      switch (this.cartera) {
        case "FUTURO ASISTENCIA":
          this.getPlacaFuturo();
          break;
        case "ASSA COMPAÑIA DE SEGUROS":
          this.getPlacaAssa();
          break;
      }
    },
    buscarPoliza() {
      switch (this.cartera) {
        case "FUTURO ASISTENCIA":
          this.getPolizaFuturo();
          break;
        case "ASSA COMPAÑIA DE SEGUROS":
          this.getPolizaAssa();
          break;
      }
    },
    getPlacaFuturo() {
      let me = this;
      me.errorPlaca = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Asegurados/MostrarCodigoPlaca/" + this.placa, configuracion)
        .then(function (response) {
          me.agregarDetalle(response.data);
          me.sheetReincidencia = true;
          me.listarReincidencia();
        })
        .catch(function (error) {
          console.error(error);
          me.errorPlaca = "No se encuentra registrada la placa.";
        });
    },
    getPlacaAssa() {
      let me = this;
      me.errorPlaca = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Assas/MostrarCodigoPlaca/" + this.placa, configuracion)
        .then(function (response) {
          me.agregarDetalleAssa(response.data);
          if (response.data.año < 2007) {
            me.activarNotificacionPlaca();
          }
          me.sheetReincidencia = true;
          me.listarReincidencia();
        })
        .catch(function (error) {
          console.error(error);
          me.errorPlaca = "No se encuentra registrada la placa.";
        });
    },
    getPolizaFuturo() {
      let me = this;
      me.errorPlaca = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Asegurados/MostrarCodigoPoliza/" + this.poliza, configuracion)
        .then(function (response) {
          me.agregarDetalle(response.data);
          me.sheetReincidencia = true;
          me.listarReincidencia();
        })
        .catch(function (error) {
          console.error(error);
          me.errorPlaca = "No se encuentra registrada la poliza.";
        });
    },
    getPolizaAssa() {
      let me = this;
      me.errorPlaca = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Assas/MostrarCodigoPoliza/" + this.poliza, configuracion)
        .then(function (response) {
          me.agregarDetalleAssa(response.data);
          me.sheetReincidencia = true;
          me.listarReincidencia();
        })
        .catch(function (error) {
          console.error(error);
          me.errorPlaca = "No se encuentra registrada la poliza.";
        });
    },
    agregarDetalle(data) {
      this.errorPlaca = null;
      this.idBase = data["idBase"];
      this.placa = data["placa"].trim();
      this.poliza = data["poliza"].trim();
      this.marca = data["marca"].trim();
      this.modelo = data["modelo"].trim();
      this.año = data["año"];
      this.titularPoliza = data["asegurado"].trim();
      this.condicion = data["condicion"];
      this.uso = data["uso"].trim();
      this.color = data["color"].trim();
      this.num_motor = data["motor"].trim();
      this.num_chasis = data["vin"].trim();
    },
    agregarDetalleAssa(data) {
      this.errorPlaca = null;
      this.idBaseAssa = data["idBaseAssa"];
      this.placa = data["placa"];
      this.poliza = data["poliza"];
      this.marca = data["marca"];
      this.modelo = data["modelo"];
      this.año = data["año"];
      this.titularPoliza = data["nombre"];
      this.condicion = data["condicion"];
      this.color = data["color"];
      this.agente = data["agente"];
      this.num_motor = data["motor"];
      this.num_chasis = data["vin"];
      this.morosidad = data["morosidad"];
      this.dañosPropios = data["dañosPropios"];
    },
    verificarUsuario() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/Roles/Listar/" + this.$store.state.usuario.idRol,
          configuracion
        )
        .then((response) => {
          if (response.data[0].solo_mis_asistencias) {
            this.listarPorProveedor();
          } else {
            this.listar();
          }
        });
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.cabinas = [];
      me.overlay = true;
      axios
        .get("api/Cabinas/Listar", configuracion)
        .then(function (response) {
          me.cabinas = response.data;
          //SE ACTUALIZARA LA INFORMACION PARA MOSTRAR LA INFORMACION EN FIREBASE DE ASSA
          me.cabinas.forEach(function (data, index) {
            if (me.cabinas[index]["cartera"] == "ASSA COMPAÑIA DE SEGUROS") {
              dbRefAssaAsistencias
                .child(me.cabinas[index]["numeroAsistencia"])
                .set({
                  color: me.cabinas[index]["color"],
                  marca: me.cabinas[index]["marca"],
                  modelo: me.cabinas[index]["modelo"],
                  pais: me.cabinas[index]["pais"],
                  placa: me.cabinas[index]["placa"],
                  poliza: me.cabinas[index]["poliza"],
                  tipoAsistencia: me.cabinas[index]["tipoAsistencia"],
                  titularPoliza: me.cabinas[index]["titularPoliza"],
                });
            }
          });
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function (error) {
          me.snackErrorListar = true;
          me.overlay = false;
        });
    },
    listarPorProveedor() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.cabinas = [];
      me.overlay = true;
      axios
        .get(
          "api/Cabinas/ListarPorproveedor/" + this.$store.state.usuario.nombre,
          configuracion
        )
        .then(function (response) {
          me.cabinas = response.data;
          me.overlay = false;
        })
        .catch(function (error) {
          console.error(error);
          me.snackErrorListar = true;
          me.overlay = false;
        });
    },
    verDetalles(item) {
      this.limpiar();
      this.carteras();
      this.bloquearQuejaObservaciones = item.preguntaQuejaObservaciones
        ? true
        : false;
      this.btnSheetReincidencia = false;
      this.id = item.idCabina;
      this.idBase = item.idBase;
      this.idUsuario = item.idUsuario;
      this.proveedor = item.idProveedor;
      this.fechaHoraActual = item.fechaHoraActual;
      this.fechaHoraActualNuevo = item.fechaHoraActual;
      this.numeroAsistencia = item.numeroAsistencia;
      this.cartera = item.cartera;
      this.fechaHoraOcurrencia = item.fechaHoraOcurrencia;
      this.relacionTitularId = item.relacionTitularId;
      this.tipoQuejaId = item.tipoQuejaId;
      this.tipoInspeccionId = item.tipoInspeccionId;
      this.numeroTelefono = item.numeroTelefono;
      this.numeroTelefono2 = item.numeroTelefono2;
      this.numeroTelefono3 = item.numeroTelefono3;
      this.placa = item.placa;
      this.poliza = item.poliza;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.año = item.año;
      this.uso = item.uso;
      this.titularPoliza = item.titularPoliza;
      this.color = item.color;
      this.nombreConductor = item.nombreConductor;
      this.pais = item.pais;
      this.depaSiniestro = item.depaSiniestro;
      this.list_muniSiniestro[0] = item.muniSiniestro;
      this.muniSiniestro = this.list_muniSiniestro[0];
      this.comDireccionSiniestro = item.comDireccionSiniestro;
      this.causa = item.causa;
      this.horaCargaPortalAseguradora = item.horaCargaPortalAseguradora;
      this.tipoServicio = item.tipoServicio;
      this.nombreProveedor = item.proveedor;
      this.fueraTurno = !!item.fueraTurno;
      this.telefonoProveedor = item.telefonoProveedor;
      this.fechaHoraAsignacion = item.fechaHoraAsignacion;
      this.depaOrigen = item.depaOrigen;
      this.list_muniOrigen[0] = item.muniOrigen;
      this.muniOrigen = this.list_muniOrigen[0];
      this.comDireccionOrigen = item.comDireccionOrigen;
      this.depaDestino = item.depaDestino;
      this.list_muniDestino[0] = item.muniDestino;
      this.muniDestino = this.list_muniDestino[0];
      this.comDireccionDestino = item.comDireccionDestino;
      this.fechaHoraContacto = item.fechaHoraContacto;
      this.costoServicio = item.costoServicio;
      this.kmCosto = !item.kmCosto ? 0 : item.kmCosto;
      this.fechaHoraCierreAsistencia = item.fechaHoraCierreAsistencia;
      this.placaContraparte = item.placaContraparte;
      this.partePolicial = item.partePolicial;
      this.obsAdicionales = item.obsAdicionales;
      this.tipoAsistencia = item.tipoAsistencia;
      this.operador = item.operador;
      this.quienSolicita = item.quienSolicita;
      this.fechaSolicitudAjuste = item.fechaSolicitudAjuste;
      this.seMovioDelLugar = item.seMovioDelLugar;
      this.zonaPeligrosa = item.zonaPeligrosa;
      this.reporteTardio = item.reporteTardio;
      this.estatusAsistencia = item.estatusAsistencia;
      this.roboRecuperado = item.roboRecuperado;
      this.localForaneo = item.localForaneo;
      this.radioGroupRecobroConciliacion = item.nombreRecupero;
      this.cantRecupero = item.cantRecupero;

      this.cantRecuperoEncontrado = !!item.cantRecupero;

      this.termino = item.termino;
      this.estadoEbriedad = item.estadoEbriedad;
      this.numeroCheque = item.numeroCheque;
      this.cabinistaContacto = item.cabinistaContacto;
      this.cabinistaTermino = item.cabinistaTermino;
      this.cabinistaCierre = item.cabinistaCierre;
      this.protocolo = item.protocolo;
      this.pasaFiscalia = item.pasaFiscalia;
      this.responsable = item.responsable;
      this.fechaHoraProgramado = item.fechaHoraProgramado;
      this.agente = item.agente;
      this.reembolso = item.reembolso;
      this.metodoSolicitudAsistencia = item.metodoSolicitudAsistencia;
      this.checkboxRapiAssaSegunPlataforma =
        item.checkboxRapiAssaSegunPlataforma;
      this.rapiASSAPlataforma = item.rapiASSAPlataforma;
      this.pretencionInicial = item.pretencionInicial;
      this.pretencionFinal = item.pretencionFinal;
      this.declinaciones = item.declinaciones;
      this.ahorroDe = item.ahorroDe;
      this.llenoFormularioReclamo = item.preguntaLlenoFormularioReclamo;
      this.enviadoPor = item.enviadoPor;
      this.ajustador_cargo = item.ajustador_cargo;
      this.conductor_grua = item.conductor_grua;
      this.num_chasis = item.numero_chasis;
      this.num_motor = item.numero_motor;
      this.localidad_sisa = item.localidad_sisa;
      //variables de ajustadores para ASSA
      this.expedienteAssa = item.expedienteAssa;
      this.inspeccionInSituVirtual = item.inspeccionInSituVirtual;
      this.rapiAssaAsegurado = item.rapiAssaAsegurado;
      this.rapiAssaTercero = item.rapiAssaTercero;
      this.motivoNoUsoRapiassa = item.motivoNoUsoRapiassa;
      this.motivoNoUsoRapiassaTercero = item.motivoNoUsoRapiassaTercero;
      this.motivoDeNoUsoTaller = item.motivoDeNoTaller;
      this.usoGruaAsegurado = item.usoGruaAsegurado;
      this.usoGruaTercero = item.usoGruaTercero;
      this.tallerAsegurado = item.tallerAsegurado;
      this.tallerTercero = item.tallerTercero;
      this.estadoVirtual = item.estadoVirtual;
      this.digitador = item.digitador;
      this.autorizadoPor = item.autorizadoPor;
      this.fechaDigitador = item.fechaDigitador;
      this.fechaAutorizadoPor = item.fechaAutorizadoPor;
      this.vanGrupoId = item.vanGrupoID;
      this.vanGrupoEmpresa = item.vanGrupoEmpresa;
      this.selectedObsCancelacion = item.observacionCancelacion;
      this.comentarioAutoriza = item.comentarioAutoriza;
      this.costoSinDescuento = !!item.costoSinDescuento
        ? item.costoSinDescuento
        : "0.00";
      this.totalDescuento = !!item.totalDescuento
        ? item.totalDescuento
        : "0.00";
      this.descuentoId = item.descuentoId;
      this.analistaSISAId = item.analistaId;
      this.tallerId = item.tallerId;
      this.DUIPersonaRecupero = item.dui;
      this.personaRecupero = item.personaRecupero;
      this.morosidad = item.morosidad;
      this.dañosPropios = item.dañosPropios;
      this.verNuevo = 1;
      this.verDet = 1;
      this.solicitudGrua = 1;
      //verificar si los campos esta completos
      this.verificarFechaAsignacion();
      this.verificarFechaContacto();
      this.verificarFinalizado();
      this.verificarCierreFinalizado();
      if (
        this.$store.state.usuario.nombre != "Iris Regina Hernandez" &&
        this.$store.state.usuario.nombre != "Milton Vladimir Maldonado" &&
        this.$store.state.usuario.nombre != "Andrea Zaldivar" &&
        this.$store.state.usuario.nombre != "Wendy Escalante" &&
        this.$store.state.usuario.nombre != "Manuel Antonio Alonso"
      ) {
        this.verificaCostoServicio();
      }
      //detalles de encuesta
      if (item.preguntaResueltaNecesidad == "SI") {
        this.checkResueltaNecesidad = true;
      } else if (item.preguntaResueltaNecesidad == "NO") {
        this.checkResueltaNecesidad = false;
      } else {
        this.checkResueltaNecesidad = null;
      }

      if (item.preguntaNoRespondeLlamada == "SI") {
        this.checkNoResponde = true;
      } else if (item.preguntaNoRespondeLlamada == "NO") {
        this.checkNoResponde = false;
      } else {
        this.checkNoResponde = null;
      }

      this.radioGroupCalificaEjecutivo = item.preguntaCalificaEjecutivo;
      this.radioGroupCalificaServicio = item.preguntaCalificaServicio;
      this.textAreaQuejaObservaciones = item.preguntaQuejaObservaciones;
      this.expediente = item.expediente;

      this.getErrorAsistencia();
      this.getDetallesAsistencia();
      this.checkHasEncuestaSISA();
    },
    guardar() {
      try {
        this.updateDetallesCabina();
        if (this.$refs.datosTercero) {
          this.$refs.datosTercero.save();
        }
      } catch (error) {}

      this.$refs.fCliente.validate();

      if (this.validar()) {
        return;
      }

      // ==> VALIDACION SOLO PARA 'VANGRUPO'
      if (
        this.cartera == "VANGRUPO" &&
        this.vanGrupoServicios.includes(this.tipoAsistencia)
      ) {
        if (this.vanGrupoId == null || this.vanGrupoId == "") {
          this.snackText = "Debe Seleccionar un Cliente VanGrupo...";
          this.snackColor = "error";
          this.snackTime = 5000;
          this.snackState = true;

          return;
        }
      }

      if (
        (this.cartera == "ASSA COMPAÑIA DE SEGUROS" &&
          this.tipoAsistencia == "AJUSTE") ||
        this.tipoAsistencia == "INSPECCION ON LINE"
      ) {
        if (this.rapiASSAPlataforma == null || this.rapiASSAPlataforma == "") {
          this.snackText = "RapiASSA es Requerido...";
          this.snackColor = "error";
          this.snackTime = 5000;
          this.snackState = true;
          return;
        }
      }

      if (this.peticionPendiente) return;
      this.peticionPendiente = true;

      this.btnloadingGuardar = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .post(
          "api/Cabinas/Crear",
          {
            idBase: me.idBase,
            idUsuario: me.$store.state.usuario.idUsuario,
            idProveedor: me.proveedor,
            idBaseAssa: me.idBaseAssa,
            cartera: me.cartera,
            fechaHoraActual: me.fechaHoraActualNuevo,
            fechaHoraOcurrencia: me.fechaHoraOcurrencia,
            relacionTitularId: this.relacionTitularId,
            numeroTelefono: me.numeroTelefono,
            numeroTelefono2: this.numeroTelefono2,
            numeroTelefono3: this.numeroTelefono3,
            placa: me.placa,
            poliza: me.poliza,
            marca: me.marca,
            modelo: me.modelo,
            año: me.año,
            uso: me.uso,
            color: me.color,
            nombreConductor: me.nombreConductor,
            titularPoliza: me.titularPoliza,
            pais: me.pais,
            depaSiniestro: me.depaSiniestro,
            muniSiniestro: me.muniSiniestro,
            comDireccionSiniestro: me.comDireccionSiniestro,
            causa: me.causa,
            tipoServicio: me.tipoServicio,
            proveedor: me.nombreProveedor,
            telefonoProveedor: me.telefonoProveedor,
            fechaHoraAsignacion: me.fechaHoraAsignacion,
            depaOrigen: me.depaOrigen,
            muniOrigen: me.muniOrigen,
            comDireccionOrigen: me.comDireccionOrigen,
            depaDestino: me.depaDestino,
            muniDestino: me.muniDestino,
            comDireccionDestino: me.comDireccionDestino,
            fechaHoraContacto: me.fechaHoraContacto,
            costoServicio: me.costoServicio,
            fechaHoraCierreAsistencia: me.fechaHoraCierreAsistencia,
            placaContraparte: me.placaContraparte,
            partePolicial: me.partePolicial,
            obsAdicionales: me.obsAdicionales,
            tipoAsistencia: me.tipoAsistencia,
            quienSolicita: me.quienSolicita,
            fechaSolicitudAjuste: me.fechaSolicitudAjuste,
            seMovioDelLugar: me.seMovioDelLugar,
            zonaPeligrosa: me.zonaPeligrosa,
            reporteTardio: me.reporteTardio,
            operador: me.$store.state.usuario.nombre,
            estatusAsistencia: me.estatusAsistencia,
            roboRecuperado: me.roboRecuperado,
            localForaneo: me.localForaneo,
            nombreRecupero: me.radioGroupRecobroConciliacion,
            cantRecupero: me.cantRecupero,
            termino: me.termino,
            estadoEbriedad: me.estadoEbriedad,
            numeroCheque: me.numeroCheque,
            cabinistaContacto: me.cabinistaContacto,
            cabinistaTermino: me.cabinistaTermino,
            cabinistaCierre: me.cabinistaCierre,
            protocolo: me.protocolo,
            pasaFiscalia: me.pasaFiscalia,
            responsable: me.responsable,
            fechaHoraProgramado: me.fechaHoraProgramado,
            reembolso: me.reembolso,
            metodoSolicitudAsistencia: me.metodoSolicitudAsistencia,
            expedienteAssa: me.expedienteAssa,
            inspeccionInSituVirtual: me.inspeccionInSituVirtual,
            rapiAssaAsegurado: me.rapiAssaAsegurado,
            rapiAssaTercero: me.rapiAssaTercero,
            motivoNoUsoRapiassa: me.motivoNoUsoRapiassa,
            motivoNoUsoRapiassaTercero: me.motivoNoUsoRapiassaTercero,
            usoGruaAsegurado: me.usoGruaAsegurado,
            usoGruaTercero: me.usoGruaTercero,
            tallerAsegurado: me.tallerAsegurado,
            tallerTercero: me.tallerTercero,
            estadoVirtual: me.estadoVirtual,
            motivoDeNoTaller: me.motivoDeNoUsoTaller,
            agente: me.agente,
            checkboxRapiAssaSegunPlataforma: me.checkboxRapiAssaSegunPlataforma,
            rapiASSAPlataforma: me.rapiASSAPlataforma,
            pretencionInicial: me.pretencionInicial,
            pretencionFinal: me.pretencionFinal,
            declinaciones: me.declinaciones,
            ahorroDe: me.ahorroDe,
            preguntaLlenoFormularioReclamo: me.llenoFormularioReclamo,
            enviadoPor: me.enviadoPor,
            ajustador_cargo: me.ajustador_cargo,
            conductor_grua: me.conductor_grua,
            numero_chasis: me.num_chasis,
            numero_motor: me.num_motor,
            localidad_sisa: me.localidad_sisa,
            expediente: null,
            bitacoras: me.bitacoras,
            fueraTurno: me.fueraTurno,
            kmCosto: me.kmCosto,
            tipoQuejaId: me.tipoQuejaId,
            tipoInspeccionId: me.tipoInspeccionId,
            vanGrupoID: me.cartera == "VANGRUPO" ? me.vanGrupoId : null,
            vanGrupoEmpresa:
              this.cartera == "VANGRUPO" ? this.vanGrupoEmpresa : null,
            observacionCancelacion: this.selectedObsCancelacion,
            comentarioAutoriza: this.comentarioAutoriza,
            dui: this.DUIPersonaRecupero,
            personaRecupero: this.personaRecupero,
            morosidad: this.morosidad,
            dañosPropios: this.dañosPropios,
          },
          configuracion
        )
        .then((response) => {
          if (this.cartera == "VANGRUPO") {
            this.agregarHistorialVanGrupo(response.data);
          }

          this.ocultarNuevo();
          this.verificarUsuario();
          this.limpiar();
        })
        .catch(function (error) {
          console.error(error);
          me.snackError = true;
          me.btnloadingGuardar = false;
        })
        .finally(() => (this.peticionPendiente = false));
      me.obtenerDatosBitacora();
      this.bitacoras = [];

      // me.enviarCorreo();
    },
    agregarHistorialVanGrupo(numeroAsistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/VanGrupo/Historial",
          {
            numeroAsistencia: numeroAsistencia,
            titularId: this.vanGrupoCliente.titularPolizaId,
            nombreTitular: this.vanGrupoCliente.titularPoliza,
            terceroId:
              this.vanGrupoCliente.tipo_tercero == "0001"
                ? null
                : this.vanGrupoCliente.id_uuid,
            nombreTercero:
              this.vanGrupoCliente.tipo_tercero == "0001"
                ? null
                : `${this.vanGrupoCliente.nombre.trim()} ${this.vanGrupoCliente.apellidos.trim()}`,
            DUITitular: this.vanGrupoCliente.DUI,
            tipoServicio: this.vanGrupoCliente.tipo_servicio,
            empresa: this.vanGrupoCliente.empresa,
            cuotasMora: this.vanGrupoCliente.cuotasmora,
            totalMora: this.vanGrupoCliente.totalmora,
            tipoTercero: this.vanGrupoCliente.tipo_tercero,
          },
          configuracion
        )
        .catch((err) => console.error(err));
    },
    servicioAdicional() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      if (this.peticionPendiente) return;
      this.peticionPendiente = true;

      var today = new Date();
      me.fechaHoraActualNuevo =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      axios
        .post(
          "api/Cabinas/Crear",
          {
            idBase: me.idBase,
            idUsuario: me.$store.state.usuario.idUsuario,
            idProveedor: "",
            idBaseAssa: me.idBaseAssa,
            cartera: me.cartera,
            fechaHoraActual: me.fechaHoraActualNuevo,
            fechaHoraOcurrencia: me.fechaHoraOcurrencia,
            relacionTitularId: this.relacionTitularId,
            numeroTelefono: me.numeroTelefono,
            numeroTelefono2: this.numeroTelefono2,
            numeroTelefono3: this.numeroTelefono3,
            placa: me.placa,
            poliza: me.poliza,
            marca: me.marca,
            modelo: me.modelo,
            año: me.año,
            uso: me.uso,
            color: me.color,
            nombreConductor: me.nombreConductor,
            titularPoliza: me.titularPoliza,
            pais: me.pais,
            depaSiniestro: me.depaSiniestro,
            muniSiniestro: me.muniSiniestro,
            comDireccionSiniestro: me.comDireccionSiniestro,
            causa: me.causa,
            tipoServicio: me.tipoServicio,
            proveedor: "",
            telefonoProveedor: me.telefonoProveedor,
            fechaHoraAsignacion: "",
            depaOrigen: me.depaOrigen,
            muniOrigen: me.muniOrigen,
            comDireccionOrigen: me.comDireccionOrigen,
            depaDestino: me.depaDestino,
            muniDestino: me.muniDestino,
            comDireccionDestino: me.comDireccionDestino,
            fechaHoraContacto: "",
            costoServicio: 0,
            fechaHoraCierreAsistencia: "",
            placaContraparte: me.placaContraparte,
            partePolicial: me.partePolicial,
            obsAdicionales: me.obsAdicionales,
            tipoAsistencia: me.tipoAsistencia,
            quienSolicita: me.quienSolicita,
            fechaSolicitudAjuste: me.fechaSolicitudAjuste,
            seMovioDelLugar: me.seMovioDelLugar,
            zonaPeligrosa: me.zonaPeligrosa,
            reporteTardio: me.reporteTardio,
            operador: me.$store.state.usuario.nombre,
            estatusAsistencia: me.estatusAsistencia,
            roboRecuperado: me.roboRecuperado,
            localForaneo: me.localForaneo,
            nombreRecupero: null,
            cantRecupero: null,
            termino: "",
            estadoEbriedad: me.estadoEbriedad,
            numeroCheque: me.numeroCheque,
            cabinistaContacto:
              this.tipoAsistencia == "LEGAL" ? null : me.cabinistaContacto,
            cabinistaTermino:
              this.tipoAsistencia == "LEGAL" ? null : me.cabinistaTermino,
            cabinistaCierre:
              this.tipoAsistencia == "LEGAL" ? null : me.cabinistaCierre,
            protocolo: me.protocolo,
            pasaFiscalia: me.pasaFiscalia,
            responsable: me.responsable,
            metodoSolicitudAsistencia: me.metodoSolicitudAsistencia,
            expedienteAssa: me.expedienteAssa,
            inspeccionInSituVirtual: me.inspeccionInSituVirtual,
            rapiAssaAsegurado: me.rapiAssaAsegurado,
            rapiAssaTercero: me.rapiAssaTercero,
            motivoNoUsoRapiassa: me.motivoNoUsoRapiassa,
            motivoNoUsoRapiassaTercero: me.motivoNoUsoRapiassaTercero,
            usoGruaAsegurado: me.usoGruaAsegurado,
            usoGruaTercero: me.usoGruaTercero,
            tallerAsegurado: me.tallerAsegurado,
            tallerTercero: me.tallerTercero,
            estadoVirtual: me.estadoVirtual,
            agente: me.agente,
            checkboxRapiAssaSegunPlataforma: me.checkboxRapiAssaSegunPlataforma,
            rapiASSAPlataforma: me.rapiASSAPlataforma,
            motivoDeNoTaller: me.motivoDeNoUsoTaller,
            pretencionInicial: me.pretencionInicial,
            pretencionFinal: me.pretencionFinal,
            declinaciones: me.declinaciones,
            ahorroDe: me.ahorroDe,
            enviadoPor: me.enviadoPor,
            ajustador_cargo: me.ajustador_cargo,
            conductor_grua: me.conductor_grua,
            numero_chasis: me.num_chasis,
            numero_motor: me.num_motor,
            localidad_sisa: me.localidad_sisa,
            expediente: me.expediente,
            bitacoras: me.bitacoras,
            tipoQuejaId: me.tipoQuejaId,
            tipoInspeccionId: me.tipoInspeccionId,
            vanGrupoID: me.cartera == "VANGRUPO" ? me.vanGrupoId : null,
            vanGrupoEmpresa:
              this.cartera == "VANGRUPO" ? this.vanGrupoEmpresa : null,
            observacionCancelacion: this.selectedObsCancelacion,
            comentarioAutoriza: this.comentarioAutoriza,
            dui: this.DUIPersonaRecupero,
            personaRecupero: this.personaRecupero,
            morosidad: this.morosidad,
            dañosPropios: this.dañosPropios,
          },
          configuracion
        )
        .then(function (response) {
          me.ocultarNuevo();
          me.verificarUsuario();
          me.limpiar();
        })
        .catch(function (error) {
          console.error(error);
          me.snackError = true;
        })
        .finally(() => (this.peticionPendiente = false));
      me.obtenerDatosBitacora();
      this.bitacoras = [];

      // me.enviarCorreo();
    },
    validar() {
      this.valida = 0;
      this.validaMensaje = [];

      if (
        this.estatusAsistencia != "EN PROCESO" &&
        this.estatusAsistencia != "SIN ASIGNAR" &&
        this.estatusAsistencia != "EN TRAMITE"
      ) {
        if (
          !this.localidad_sisa &&
          (this.cartera == "SISA SEGUROS" || this.cartera == "SISA/VIP")
        ) {
          this.validaMensaje.push("EL CAMPO DE LOCALIDAD SISA ES OBLIGATORIO");
          this.valida = 1;
          return this.valida;
        }
      }

      if (
        this.estatusAsistencia != "EN PROCESO" &&
        this.estatusAsistencia != "SIN ASIGNAR" &&
        this.estatusAsistencia != "EN TRAMITE"
      ) {
        if (
          !this.placa ||
          !this.poliza ||
          !this.marca ||
          !this.modelo ||
          this.año == null ||
          !this.titularPoliza ||
          !this.cartera ||
          !this.fechaHoraOcurrencia ||
          !this.numeroTelefono ||
          !this.color ||
          !this.nombreConductor ||
          !this.pais ||
          !this.depaSiniestro ||
          !this.muniSiniestro ||
          !this.comDireccionSiniestro ||
          !this.causa ||
          !this.tipoAsistencia ||
          !this.proveedor ||
          !this.depaOrigen ||
          !this.muniOrigen ||
          !this.comDireccionOrigen ||
          !this.depaDestino ||
          !this.muniDestino ||
          !this.comDireccionDestino ||
          !this.fechaHoraContacto ||
          this.costoServicio == null ||
          !this.termino ||
          !this.fechaHoraCierreAsistencia ||
          !this.placaContraparte ||
          !this.obsAdicionales ||
          !this.tipoServicio ||
          !this.localForaneo
        ) {
          this.validaMensaje.push("LOS CAMPOS NO PUEDEN QUEDAR VACIOS");
          this.$refs.form.validate();
        }
      } else if (this.estatusAsistencia == "EN PROCESO") {
        if (
          !this.titularPoliza ||
          !this.nombreConductor ||
          !this.relacionTitularId ||
          (this.gruasRegionales.some((g) => g.idProveedor == this.proveedor) &&
            !this.conductor_grua) ||
          !this.placa ||
          !this.poliza ||
          !this.marca ||
          !this.modelo ||
          !this.color ||
          !this.año ||
          !this.tipoAsistencia ||
          !this.comDireccionSiniestro
        ) {
          this.validaMensaje.push(
            "VERIFICAR LOS CAMPOS: Datos del cliente, tipo asistencia y dirección siniestro"
          );
        }
      }
      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    async actualizar() {
      try {
        this.updateDetallesCabina();
        if (this.$refs.datosTercero) {
          this.$refs.datosTercero.save();
        }
      } catch (error) {}
      if (this.estatusAsistencia == "FINALIZADO") {
        if (this.cartera == "BAM") {
          let response = await this.validarCierreCamposCartera("CierreBam");
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (!response.data[0].asistencia || !response.data[0].reclamo) {
            //console.log("BAM los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "SEGUROS CONTINENTAL SA") {
          let response = await this.validarCierreCamposCartera(
            "CierreContiental"
          );
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (!response.data[0].caso) {
            //console.log(" CONTINENTAL los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "SEGUROS EL ROBLE") {
          let response = await this.validarCierreCamposCartera("CierreElRoble");
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (!response.data[0].expediente || !response.data[0].asistencia) {
            //console.log("ROBLE los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "SEGUROS FICOHSA") {
          let response = await this.validarCierreCamposCartera("CierreFicohsa");
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (!response.data[0].expediente || !response.data[0].atencion) {
            //console.log("FICHOSA los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "G&T") {
          let response = await this.validarCierreCamposCartera("CierreGyT");
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (
            !response.data[0].analista ||
            !response.data[0].boleta ||
            !response.data[0].reclamo
          ) {
            //console.log(" GYT los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "SEGUROS LA CEIBA") {
          let response = await this.validarCierreCamposCartera("CierreLaCeiba");
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (
            !response.data[0].reclamo ||
            !response.data[0].agente ||
            !response.data[0].analista ||
            !response.data[0].aviso ||
            !response.data[0].grupo
          ) {
            //console.log(" LA CEIBA los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "LA GENERAL") {
          let response = await this.validarCierreCamposCartera(
            "CierreLaGeneral"
          );
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (!response.data[0].boleta || !response.data[0].reclamo) {
            //console.log("LA GENERAL los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "QUALITAS COMPAÑIA DE SEGUROS") {
          let response = await this.validarCierreCamposCartera(
            "CierreQualitas"
          );
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (
            !response.data[0].cabinista ||
            !response.data[0].endoso ||
            !response.data[0].inciso ||
            !response.data[0].reporte_sac ||
            !response.data[0].reporte_sise ||
            !response.data[0].siniestro ||
            !response.data[0].spooler
          ) {
            //console.log("QUALITAS los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "QUALITAS COSTA RICA") {
          let response = await this.validarCierreCamposCartera(
            "CierreQualitasCR"
          );
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (
            !response.data[0].cabinista ||
            !response.data[0].endoso ||
            !response.data[0].inciso ||
            !response.data[0].reporte ||
            !response.data[0].siniestro
          ) {
            //console.log("QUALITAS CR los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "LA RESURRECCION") {
          let response = await this.validarCierreCamposCartera(
            "CierreResurreccion"
          );
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (!response.data[0].dui) {
            //console.log("RESURRECION los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }
        if (this.cartera == "SEGUROS UNIVERSALES") {
          let response = await this.validarCierreCamposCartera(
            "CierreUniversales"
          );
          if (response.data.length == 0) {
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
          if (
            !response.data[0].asistencia ||
            !response.data[0].reclamo ||
            !response.data[0].analista
          ) {
            //console.log("UNIVERSALES los campos estan incompletos");
            this.snackBarGlobalText =
              "Debe de completar los campos DETALLES de la cartera para finalizar la asistencia";
            this.snackBarGlobal = true;
            return;
          }
        }

        if (
          this.cartera == "FUTURO ASISTENCIA" &&
          this.quienSolicita &&
          !this.comentarioAutoriza
        ) {
          if (!this.$refs.fComentarioAutoriza.validate()) {
            this.snackBarGlobalText =
              "Debe Colocar un Comentario de Autorización!";
            this.snackBarGlobal = true;

            return;
          }
        }
      }

      if (this.estatusAsistencia == "CANCELADO A SOLICITUD") {
        if (!this.$refs.fObsCancelacion.validate()) {
          this.snackBarGlobalText =
            "Debe Seleccionar una Observación de Cancelación";
          this.snackBarGlobal = true;
          return;
        }
      } else {
        if (this.validar()) {
          return;
        }
      }
      //verificar que si la asistencia finalizo cambiar el codigo al proveedor para no mostrar el mapa en la pagina web
      if (this.estatusAsistencia == "FINALIZADO") {
        var code = this.codeRandom();
        navigator.geolocation.getCurrentPosition((position) => {
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
          var query = geofireRef.query({
            center: [lat, lng],
            radius: 170,
          });
          query.on("key_entered", (key, location, distance) => {
            const dataName = dbRefProveedor.child(key);
            dataName.on("value", (snapchop) => {
              let data = snapchop.val();
              if (data.name == this.proveedor) {
                dbRefProveedor.child(key + "/" + "code").set(code);
              }
            });
          });
        });
      }

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      //verificacion de pregunta si fue resuelta necesidad
      if (me.checkResueltaNecesidad) {
        var checkBoxConvertir = "SI";
      } else if (me.checkResueltaNecesidad == false) {
        var checkBoxConvertir = "NO";
      } else {
        var checkBoxConvertir = null;
      }

      if (me.checkNoResponde) {
        var checkBoxNoResponde = "SI";
      } else if (me.checkNoResponde == false) {
        var checkBoxNoResponde = "NO";
      } else {
        var checkBoxNoResponde = null;
      }

      if (this.peticionPendiente) return;

      this.peticionPendiente = true;

      axios
        .put(
          "api/Cabinas/Actualizar",
          {
            idCabina: me.id,
            idBase: me.idBase,
            idUsuario: me.$store.state.usuario.idUsuario,
            idProveedor: me.proveedor,
            cartera: me.cartera,
            fechaHoraActual: me.fechaHoraActualNuevo,
            fechaHoraOcurrencia: me.fechaHoraOcurrencia,
            relacionTitularId: this.relacionTitularId,
            numeroTelefono: me.numeroTelefono,
            numeroTelefono2: this.numeroTelefono2,
            numeroTelefono3: this.numeroTelefono3,
            placa: me.placa,
            poliza: me.poliza,
            marca: me.marca,
            modelo: me.modelo,
            año: me.año,
            uso: me.uso,
            color: me.color,
            nombreConductor: me.nombreConductor,
            titularPoliza: me.titularPoliza,
            pais: me.pais,
            depaSiniestro: me.depaSiniestro,
            muniSiniestro: me.muniSiniestro,
            comDireccionSiniestro: me.comDireccionSiniestro,
            causa: me.causa,
            tipoServicio: me.tipoServicio,
            proveedor: me.nombreProveedor,
            telefonoProveedor: me.telefonoProveedor,
            fechaHoraAsignacion: me.fechaHoraAsignacion,
            depaOrigen: me.depaOrigen,
            muniOrigen: me.muniOrigen,
            comDireccionOrigen: me.comDireccionOrigen,
            depaDestino: me.depaDestino,
            muniDestino: me.muniDestino,
            comDireccionDestino: me.comDireccionDestino,
            fechaHoraContacto: me.fechaHoraContacto,
            costoServicio: me.costoServicio,
            fechaHoraCierreAsistencia: me.fechaHoraCierreAsistencia,
            placaContraparte: me.placaContraparte,
            partePolicial: me.partePolicial,
            obsAdicionales: me.obsAdicionales,
            tipoAsistencia: me.tipoAsistencia,
            quienSolicita: me.quienSolicita,
            fechaSolicitudAjuste: me.fechaSolicitudAjuste,
            seMovioDelLugar: me.seMovioDelLugar,
            zonaPeligrosa: me.zonaPeligrosa,
            reporteTardio: me.reporteTardio,
            operador: me.operador,
            estatusAsistencia: me.estatusAsistencia,
            roboRecuperado: me.roboRecuperado,
            localForaneo: me.localForaneo,
            nombreRecupero: me.radioGroupRecobroConciliacion,
            cantRecupero: me.cantRecupero,
            termino: me.termino,
            numeroCheque: me.numeroCheque,
            estadoEbriedad: me.estadoEbriedad,
            cabinistaContacto: me.cabinistaContacto,
            cabinistaTermino: me.cabinistaTermino,
            cabinistaCierre: me.cabinistaCierre,
            protocolo: me.protocolo,
            pasaFiscalia: me.pasaFiscalia,
            responsable: me.responsable,
            preguntaNoRespondeLlamada: checkBoxNoResponde,
            preguntaResueltaNecesidad: checkBoxConvertir,
            preguntaCalificaServicio: me.radioGroupCalificaServicio,
            preguntaCalificaEjecutivo: me.radioGroupCalificaEjecutivo,
            preguntaQuejaObservaciones: me.textAreaQuejaObservaciones,
            fechaHoraProgramado: me.fechaHoraProgramado,
            metodoSolicitudAsistencia: me.metodoSolicitudAsistencia,
            reembolso: me.reembolso,
            expedienteAssa: me.expedienteAssa,
            inspeccionInSituVirtual: me.inspeccionInSituVirtual,
            rapiAssaAsegurado: me.rapiAssaAsegurado,
            rapiAssaTercero: me.rapiAssaTercero,
            motivoNoUsoRapiassa: me.motivoNoUsoRapiassa,
            motivoNoUsoRapiassaTercero: me.motivoNoUsoRapiassaTercero,
            usoGruaAsegurado: me.usoGruaAsegurado,
            usoGruaTercero: me.usoGruaTercero,
            tallerTercero: me.tallerTercero,
            tallerAsegurado: me.tallerAsegurado,
            estadoVirtual: me.estadoVirtual,
            agente: me.agente,
            checkboxRapiAssaSegunPlataforma: me.checkboxRapiAssaSegunPlataforma,
            rapiASSAPlataforma: me.rapiASSAPlataforma,
            motivoDeNoTaller: me.motivoDeNoUsoTaller,
            pretencionInicial: me.pretencionInicial,
            pretencionFinal: me.pretencionFinal,
            declinaciones: me.declinaciones,
            ahorroDe: me.ahorroDe,
            enviadoPor: me.enviadoPor,
            ajustador_cargo: me.ajustador_cargo,
            preguntaLlenoFormularioReclamo: me.llenoFormularioReclamo,
            conductor_grua: me.conductor_grua,
            numero_chasis: me.num_chasis,
            numero_motor: me.num_motor,
            localidad_sisa: me.localidad_sisa,
            expediente: me.expediente,
            fueraTurno: me.fueraTurno,
            kmCosto: me.kmCosto,
            tipoQuejaId: me.tipoQuejaId,
            tipoInspeccionId: me.tipoInspeccionId,
            vanGrupoID: me.cartera == "VANGRUPO" ? me.vanGrupoId : null,
            vanGrupoEmpresa:
              this.cartera == "VANGRUPO" ? this.vanGrupoEmpresa : null,
            horaCargaPortalAseguradora: me.horaCargaPortalAseguradora,
            descuentoId: this.descuentoId,
            totalDescuento: this.totalDescuento,
            costoSinDescuento: this.costoSinDescuento,
            analistaId: this.analistaSISAId,
            tallerId: this.tallerId,
            observacionCancelacion: this.selectedObsCancelacion,
            comentarioAutoriza: this.comentarioAutoriza,
            dui: this.DUIPersonaRecupero,
            personaRecupero: this.personaRecupero,
            morosidad: this.morosidad,
            dañosPropios: this.dañosPropios,
          },
          configuracion
        )
        .then(function (response) {
          if (response.status == 400) {
            me.snackError = true;
          }
          if (me.cartera == "ASSA COMPAÑIA DE SEGUROS") {
            if (me.estatusAsistencia != "EN PROCESO") {
              dbRefAssaAsistencias
                .child(me.numeroAsistencia)
                .remove()
                .then(function () {
                  console.log("Remove succeeded.");
                })
                .catch(function (error) {
                  console.log("Remove failed: " + error.message);
                });
            }
          }

          //ABRIR MENSAJE WHATSAPP
          if (
            me.cartera == "SISA SEGUROS" &&
            me.estatusAsistencia == "FINALIZADO" &&
            me.serviciosParaEncuesta.includes(me.tipoAsistencia)
          ) {
            me.previewEncuestaLink();
          }
          me.ocultarNuevo();
          me.verificarUsuario();
          me.limpiar();
        })
        .catch((error) => {
          console.log(error);

          const response = error.response;

          if (response && response.data && response.data.includes("conexión")) {
            this.snackBarGlobal = true;
            this.snackBarGlobalText = response.data;
          } else {
            this.snackError = true;
          }
        })
        .finally(() => {
          this.peticionPendiente = false;
        });
    },
    clicked() {
      this.mostrarLinkWhatsapp = false;
      this.ocultarNuevo();
      this.limpiar();
    },
    codeRandom() {
      var code = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 5; i++) {
        code += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return code;
    },
    limpiar() {
      this.bloquearQuejaObservaciones = false;
      this.selectedObsCancelacion = null;
      this.comentarioAutoriza = null;
      this.rapiASSAPlataforma = null;
      this.vanGrupoCliente = null;
      this.vanGrupoId = null;
      this.vanGrupoEmpresa = null;
      this.personaRecupero = null;
      this.morosidad = null;
      this.dañosPropios = null;
      this.DUIPersonaRecupero = null;
      this.btnloadingGuardar = false;
      this.horaCargaPortalAseguradora = null;
      this.id = "";
      this.idBase = "";
      this.idUsuario = "";
      this.idProveedor = 0;
      this.numeroAsistencia = "";
      this.cartera = "";
      this.fechaHoraActualNuevo = "";
      this.fechaHoraOcurrencia = "";
      this.relacionTitularId = null;
      this.tipoQuejaId = null;
      this.tipoInspeccionId = null;
      this.numeroTelefono = this.numeroTelefono2 = this.numeroTelefono3 = "";
      this.placa = "";
      this.poliza = "";
      this.modelo = "";
      this.marca = "";
      this.año = 0;
      this.uso = "";
      this.titularPoliza = "";
      (this.condicion = ""), (this.color = "");
      this.nombreConductor = "";
      this.asegurado = "";
      this.pais = "";
      this.depaSiniestro = "";
      this.muniSiniestro = "";
      this.comDireccionSiniestro = "";
      this.causa = "";
      this.tipoServicio = "";
      this.proveedor = "";
      this.nombreProveedor = "";
      this.telefonoProveedor = "";
      this.fechaHoraAsignacion = "";
      this.depaOrigen = "";
      this.muniOrigen = "";
      this.comDireccionOrigen = "";
      this.depaDestino = "";
      this.muniDestino = "";
      this.comDireccionDestino = "";
      this.fechaHoraContacto = "";
      this.costoServicio = 0;
      this.fechaHoraCierreAsistencia = "";
      this.placaContraparte = "";
      this.partePolicial = false;
      this.obsAdicionales = "";
      this.tipoAsistencia = "";
      this.quienSolicita = "";
      this.fechaSolicitudAjuste = "";
      this.seMovioDelLugar = false;
      this.zonaPeligrosa = false;
      this.analistaSISAId = null;
      this.tallerId = null;
      this.reporteTardio = false;
      this.roboRecuperado = false;
      (this.localForaneo = ""), (this.operador = "");
      this.estatusAsistencia = "EN PROCESO";
      this.radioGroupRecobroConciliacion = null;
      this.cantRecupero = "";
      this.verDet = 0;
      this.bitacoras = [];
      this.validaMensaje = [];
      this.errorPlaca = null;
      this.solicitudGrua = 0;
      this.colorSiniestro = "";
      this.colorOrigen = "";
      this.colorDestino = "";
      this.btnContacto = false;
      this.btnFinalizado = false;
      this.btnCierreFinalizado = false;
      this.termino = "";
      this.estadoEbriedad = false;
      this.btnSheetReincidencia = true;
      this.costoValid = false;
      this.numeroCheque = "";
      this.cabinistaContacto = "";
      this.cabinistaTermino = "";
      this.cabinistaCierre = "";
      this.protocolo = false;
      this.pasaFiscalia = false;
      this.responsable = "";
      this.agente = "";
      this.fechaHoraProgramado = "";
      this.reembolso = false;
      this.metodoSolicitudAsistencia = "LLAMADA";
      (this.checkboxRapiAssaSegunPlataforma = false),
        (this.pretencionInicial = "");
      this.pretencionFinal = "";
      this.declinaciones = "";
      this.ahorroDe = "";
      this.llenoFormularioReclamo = "";
      this.enviadoPor = "";
      this.ajustador_cargo = "";
      this.conductor_grua = "";
      this.num_chasis = "";
      this.num_motor = "";
      this.localidad_sisa = "";
      //dialog bitacora
      this.cadena = "";
      this.separado = [];
      this.seguimiento = "";
      this.numeroAsistenciaDialog = "";
      this.operadorDialog = "";
      this.comDireccionSiniestroDialog = "";
      this.tipoServicioDialog = "";
      this.proveedorDialog = "";
      this.atiendeDialog = "";
      this.fechaHoraActualDialog = "";
      this.fechaHoraAsignacionDialog = "";
      this.fechaHoraContactoDialog = "";
      this.fechaHoraCierreAsistenciaDialog = "";
      this.obsAdicionalesDialog = "";
      this.reincidencias = [];
      this.contadorReincidencias = 0;
      this.mensajeReincidencia = "Cargando...";
      this.imagenesPreview = [];
      this.filesDescargadasAudios = [];
      this.checkResueltaNecesidad = null;
      this.checkNoResponde = null;
      this.radioGroupCalificaServicio = "";
      this.radioGroupCalificaEjecutivo = "";
      this.textAreaQuejaObservaciones = "";
      //variables ajustador de assa
      this.expedienteAssa = "";
      this.inspeccionInSituVirtual = "";
      this.rapiAssaAsegurado = "";
      this.rapiAssaTercero = "";
      (this.motivoNoUsoRapiassa = ""), (this.usoGruaAsegurado = "");
      this.motivoNoUsoRapiassaTercero = "";
      this.usoGruaTercero = "";
      this.tallerAsegurado = "";
      this.tallerTercero = "";
      this.estadoVirtual = "";
      this.motivoDeNoUsoTaller = ";";
      this.expediente = null;
      this.digitador = null;
      this.autorizadoPor = null;
      this.fechaDigitador = null;
      this.fechaAutorizadoPor = null;
      this.fueraTurno = false;
      this.kmCosto = 0;
      this.costoSinDescuento = null;
      this.totalDescuento = null;
      this.descuentoId = null;
      this.selectedError = null;
      this.hasEncuestaSisa = false;
      this.horaConsultaAseguradora = null;
      this.horaConfirmacionAseguradora = null;
      this.btnConsulta = false;
      this.btnConfirmacion = false;
      this.vehiculoRecibeAcompaña = "";
      this.nombreAutorizaGrua = "";
      this.vehiculoViajaSolo = null;

      this.listarComboBox();
    },
    //Al presionar el boton se auto-completa el campo con la fecha y horas
    autoCompFechaAsignacion() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.gruasRegionales.length > 0) {
        if (this.gruasRegionales.some((g) => g.idProveedor == this.proveedor)) {
          axios
            .get(
              `api/HistorialOperadoresGrua/GetOperadorGrua/${this.proveedor}`,
              configuracion
            )
            .then((res) => {
              if (res.data.length == 0) {
                this.snackState = true;
                this.snackText =
                  "Esta grúa no tiene asignado ningún conductor.";
                this.snackColor = "red darken-3";

                this.conductor_grua = "";
              } else {
                this.list_conductor_grua = [];
                this.list_conductor_grua.push(res.data);
                this.conductor_grua = res.data.nombre;
              }
            })
            .catch((err) => console.error(err));
        } else {
          this.conductor_grua = "";
        }
      }

      axios
        .get(
          "api/DetallexProveedores/ListarId/" + this.proveedor,
          configuracion
        )
        .then(function (response) {
          me.nombreProveedor = response.data[0].nombre;
          me.telefonoProveedor = response.data[0].telefono;
          if (me.nombreProveedor == "INFORMATIVO") {
            me.completarCampos();
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      var today = new Date();
      var horaAsignacion =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.fechaHoraAsignacion =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        horaAsignacion;
    },
    completarCampos() {
      this.cartera = "ASISTENCIA REGIONAL";
      this.placa = "NO REQUERIDO";
      this.poliza = "NO REQUERIDO";
      this.modelo = "NO REQUERIDO";
      this.marca = "NO REQUERIDO";
      this.uso = "NO REQUERIDO";
      this.titularPoliza = "NO REQUERIDO";
      this.color = "NO REQUERIDO";
      this.asegurado = "NO REQUERIDO";
      this.pais = "NO REQUERIDO";
      this.depaSiniestro = "NO REQUERIDO";
      this.muniSiniestro = "NO REQUERIDO";
      this.comDireccionSiniestro = "NO REQUERIDO";
      this.causa = "NO REQUERIDO";
      this.tipoServicio = "NO REQUERIDO";
      this.depaOrigen = "NO REQUERIDO";
      this.muniOrigen = "NO REQUERIDO";
      this.comDireccionOrigen = "NO REQUERIDO";
      this.depaDestino = "NO REQUERIDO";
      this.muniDestino = "NO REQUERIDO";
      this.comDireccionDestino = "NO REQUERIDO";
      this.autoCompFechaContacto();
      this.autoCompCierreFinalizado();
      this.placaContraparte = "NO REQUERIDO";
      this.tipoAsistencia = "INFORMATIVO";
      (this.localForaneo = "NO REQUERIDO"),
        (this.estatusAsistencia = "CANCELADO");
      this.autoCompFinalizado();
    },
    autoCompFechaOcurrencia() {
      var today = new Date();
      var horaOcurrencia =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();

      this.fechaHoraOcurrencia =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        "T" +
        horaOcurrencia;
    },
    autoCompFechaContacto() {
      var today = new Date();
      var horaContacto =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.fechaHoraContacto =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        horaContacto;
      this.btnContacto = true;
      this.cabinistaContacto = this.$store.state.usuario.nombre;
    },
    autoCompConsultaAseguradora() {
      var today = new Date();
      const hora =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.horaConsultaAseguradora =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        hora;
      this.btnConsulta = true;
    },
    autoCompConfirmacionAseguradora() {
      var today = new Date();
      const hora =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.horaConfirmacionAseguradora =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        hora;
      this.btnConfirmacion = true;
    },
    autoCompFinalizado() {
      var today = new Date();
      var horaFinalizado =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      this.termino =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        horaFinalizado;
      this.btnFinalizado = true;
      this.cabinistaTermino = this.$store.state.usuario.nombre;
    },
    autoCompCierreFinalizado() {
      if (
        (!this.textAreaQuejaObservaciones ||
          this.textAreaQuejaObservaciones.trim() == "") &&
        this.cartera != "SISA SEGUROS"
      ) {
        this.snackState = true;
        this.snackColor = "error";
        this.snackText =
          "Debe completar la Encuesta de Servicio antes de cerrar la asistencia...";
        this.$vuetify.goTo(9999);
      } else {
        var today = new Date();
        var horaCierreFinalizado =
          new Date().getHours() +
          ":" +
          new Date().getMinutes() +
          ":" +
          new Date().getSeconds();
        this.fechaHoraCierreAsistencia =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate() +
          " " +
          horaCierreFinalizado;
        this.btnCierreFinalizado = true;
        this.cabinistaCierre = this.$store.state.usuario.nombre;
      }
    },
    obtenerDatosBitacora() {
      let me = this;
      me.bitacoras.push({
        idUsuario: me.$store.state.usuario.idUsuario,
        fechaHoraActual: me.fechaHoraActualNuevo,
        operador: me.$store.state.usuario.nombre,
        comDireccionSiniestro: me.comDireccionSiniestro,
        tipoServicio: me.tipoServicio,
        proveedor: me.proveedor,
        atiende: "",
        fechaHoraAsignacion: me.fechaHoraAsignacion,
        seguimiento: "",
        fechaHoraContacto: me.fechaHoraContacto,
        fechaHoraCierreAsistencia: me.fechaHoraCierreAsistencia,
        obsAdicionales: me.obsAdicionales,
      });
    },
    listaMunicipioSiniestro() {
      this.list_muniSiniestro = [];
      if (this.depaSiniestro === "AHUACHAPAN") {
        this.list_muniSiniestro.push(
          "Ahuachapán",
          "Apaneca",
          "Atiquizaya",
          "Concepción de Ataco",
          "El Refugio",
          "Guaymango",
          "Jujutla",
          "San Francisco Menéndez",
          "San Lorenzo",
          "San Pedro Puxtla",
          "Tacuba",
          "Turín"
        );
        this.colorSiniestro = "#E57373";
      } else if (this.depaSiniestro === "CABAÑAS") {
        this.list_muniSiniestro.push(
          "Sensuntepeque",
          "Cinquera",
          "Dolores",
          "Guacotecti",
          "Ilobasco",
          "Jutiapa",
          "San Isidro",
          "Tejutepeque",
          "Victoria"
        );
        this.colorSiniestro = "#F06292";
      } else if (this.depaSiniestro === "CHALATENANGO") {
        this.list_muniSiniestro.push(
          "Chalatenango",
          "Agua Caliente",
          "Arcatao",
          "Azacualpa",
          "Citalá",
          "Comalapa",
          "Concepción Quezaltepeque",
          "Dulce Nombre de María",
          "El Carrizal",
          "El Paraíso",
          "La Laguna",
          "La Palma",
          "La Reina",
          "Las Vueltas",
          "Nombre de Jesús",
          "Nueva Concepción",
          "Nueva Trinidad",
          "Ojos de Agua",
          "Potonico",
          "San Antonio de La Cruz",
          "San Antonio Los Ranchos",
          "San Fernando",
          "San Francisco Lempa",
          "San Francisco Morazán",
          "San Ignacio",
          "San Isidro Labrador",
          "San José Cancasque",
          "San José Las Flores",
          "San Luis del Carmen",
          "San Miguel de Mercedes",
          "San Rafael",
          "Santa Rita",
          "Tejutla"
        );
        this.colorSiniestro = "#BA68C8";
      } else if (this.depaSiniestro === "CUSCATLAN") {
        this.list_muniSiniestro.push(
          "Cojutepeque",
          "Candelaria",
          "El Carmen",
          "El Rosario",
          "Monte San Juan",
          "Oratorio de Concepción",
          "San Bartolomé Perulapía",
          "San Cristóbal",
          "San José Guayabal",
          "San Pedro Perulapán",
          "San Rafael Cedros",
          "San Ramón",
          "Santa Cruz Analquito",
          "Santa Cruz Michapa",
          "Suchitoto",
          "Tenancingo"
        );
        this.colorSiniestro = "#9575CD";
      } else if (this.depaSiniestro === "LA LIBERTAD") {
        this.list_muniSiniestro.push(
          "Santa Tecla",
          "Antiguo Cuscatlán",
          "Chiltiupán",
          "Ciudad Arce",
          "Colón",
          "Comasagua",
          "Huizúcar",
          "Jayaque",
          "Jicalapa",
          "Nuevo Cuscatlán",
          "Puerto de la Libertad",
          "Quezaltepeque",
          "Sacacoyo",
          "San José Villanueva",
          "San Juan Opico",
          "San Matías",
          "San Pablo Tacachico",
          "Talnique",
          "Tamanique",
          "Teotepeque",
          "Tepecoyo",
          "Zaragoza"
        );
        this.colorSiniestro = "#7986CB";
      } else if (this.depaSiniestro === "LA PAZ") {
        this.list_muniSiniestro.push(
          "Zacatecoluca",
          "Cuyultitán",
          "El Rosario",
          "Jerusalén",
          "Mercedes La Ceiba",
          "Olocuilta",
          "Paraíso de Osorio",
          "San Antonio Masahuat",
          "San Emigdio",
          "San Francisco Chinameca",
          "San Juan Nonualco",
          "San Juan Talpa",
          "San Juan Tepezontes",
          "San Luis La Herradura",
          "San Luis Talpa",
          "San Miguel Tepezontes",
          "San Pedro Masahuat",
          "San Pedro Nonualco",
          "San Rafael Obrajuelo",
          "Santa María Ostuma",
          "Santiago Nonualco",
          "Tapalhuaca"
        );
        this.colorSiniestro = "#64B5F6";
      } else if (this.depaSiniestro === "LA UNION") {
        this.list_muniSiniestro.push(
          "La Unión",
          "Anamorós",
          "Bolívar",
          "Concepción de Oriente",
          "Conchagua",
          "El Carmen",
          "El Sauce",
          "Intipucá",
          "Lislique",
          "Meanguera del Golfo",
          "Nueva Esparta",
          "Pasaquina",
          "Polorós",
          "San Alejo",
          "San José La Fuente",
          "Santa Rosa de Lima",
          "Yayantique",
          "Yucuaiquín"
        );
        this.colorSiniestro = "#4FC3F7";
      } else if (this.depaSiniestro === "MORAZAN") {
        this.list_muniSiniestro.push(
          "San Francisco Gotera",
          "Arambala",
          "Cacaopera",
          "Chilanga",
          "Corinto",
          "Delicias de Concepción",
          "El Divisadero",
          "El Rosario",
          "Gualococti",
          "Guatajiagua",
          "Joateca",
          "Jocoaitique",
          "Jocoro",
          "Lolotiquillo",
          "Meanguera",
          "Osicala",
          "Perquín",
          "San Carlos",
          "San Fernando",
          "San Isidro",
          "San Simón",
          "Sensembra",
          "Sociedad",
          "Torola",
          "Yamabal",
          "Yoloaiquín"
        );
        this.colorSiniestro = "#4DD0E1";
      } else if (this.depaSiniestro === "SAN MIGUEL") {
        this.list_muniSiniestro.push(
          "San Miguel",
          "Carolina",
          "Chapeltique",
          "Chinameca",
          "Chirilagua",
          "Ciudad Barrios",
          "Comacarán",
          "El Tránsito",
          "Lolotique",
          "Moncagua",
          "Nueva Guadalupe",
          "Nuevo Edén de San Juan",
          "Quelepa",
          "San Antonio del Mosco",
          "San Gerardo",
          "San Jorge",
          "San Luis de La Reina",
          "San Rafael Oriente",
          "Sesori",
          "Uluazapa"
        );
        this.colorSiniestro = "#4DB6AC";
      } else if (this.depaSiniestro === "SAN SALVADOR") {
        this.list_muniSiniestro.push(
          "San Salvador",
          "Aguilares",
          "Apopa",
          "Ayutuxtepeque",
          "Ciudad Delgado",
          "Cuscatancingo",
          "El Paisnal",
          "Guazapa",
          "Ilopango",
          "Mejicanos",
          "Nejapa",
          "Panchimalco",
          "Rosario de Mora",
          "San Marcos",
          "San Martín",
          "Santiago Texacuangos",
          "Santo Tomás",
          "Soyapango",
          "Tonacatepeque"
        );
        this.colorSiniestro = "#81C784";
      } else if (this.depaSiniestro === "SAN VICENTE") {
        this.list_muniSiniestro.push(
          "San Vicente",
          "Apastepeque",
          "Guadalupe",
          "San Cayetano Istepeque",
          "San Esteban Catarina",
          "San Ildefonso",
          "San Lorenzo",
          "San Sebastián",
          "Santa Clara",
          "Santo Domingo",
          "Tecoluca",
          "Tepetitán",
          "Verapaz"
        );
        this.colorSiniestro = "#AED581";
      } else if (this.depaSiniestro === "SANTA ANA") {
        this.list_muniSiniestro.push(
          "Santa Ana",
          "Candelaria de la Frontera",
          "Chalchuapa",
          "Coatepeque",
          "El Congo",
          "El Porvenir",
          "Masahuat",
          "Metapán",
          "San Antonio Pajonal",
          "San Sebastián Salitrillo",
          "Santa Rosa Guachipilín",
          "Santiago de la Frontera",
          "Texistepeque"
        );
        this.colorSiniestro = "#DCE775";
      } else if (this.depaSiniestro === "SONSONATE") {
        this.list_muniSiniestro.push(
          "Sonsonate",
          "Acajutla",
          "Armenia",
          "Caluco",
          "Cuisnahuat",
          "Izalco",
          "Juayúa",
          "Nahulingo",
          "Nahuizalco",
          "Salcoatitán",
          "San Antonio del Monte",
          "San Julián",
          "Santa Catarina Masahuat",
          "Santa Isabel Ishuatán",
          "Santo Domingo de Guzmán",
          "Sonzacate"
        );
        this.colorSiniestro = "#FFF176";
      } else if (this.depaSiniestro === "USULUTAN") {
        this.list_muniSiniestro.push(
          "Usulután",
          "Alegría",
          "Berlín",
          "California",
          "Concepción Batres",
          "El Triunfo",
          "Ereguayquín",
          "Estanzuelas",
          "Jiquilisco",
          "Jucuapa",
          "Jucuarán",
          "Mercedes Umaña",
          "Nueva Granada",
          "Ozatlán",
          "Puerto El Triunfo",
          "San Agustín",
          "San Buenaventura",
          "San Dionisio",
          "San Francisco Javier",
          "Santa Elena",
          "Santa María",
          "Santiago de María",
          "Tecapán"
        );
        this.colorSiniestro = "#FFD54F";
      } else if (this.depaSiniestro === "NO REQUERIDO") {
        this.list_muniSiniestro.push("NO REQUERIDO");
      }
    },
    listaMunicipioOrigen() {
      this.list_muniOrigen = [];
      if (this.depaOrigen === "AHUACHAPAN") {
        this.list_muniOrigen.push(
          "Ahuachapán",
          "Apaneca",
          "Atiquizaya",
          "Concepción de Ataco",
          "El Refugio",
          "Guaymango",
          "Jujutla",
          "San Francisco Menéndez",
          "San Lorenzo",
          "San Pedro Puxtla",
          "Tacuba",
          "Turín"
        );
        this.colorOrigen = "#E57373";
      } else if (this.depaOrigen === "CABAÑAS") {
        this.list_muniOrigen.push(
          "Sensuntepeque",
          "Cinquera",
          "Dolores",
          "Guacotecti",
          "Ilobasco",
          "Jutiapa",
          "San Isidro",
          "Tejutepeque",
          "Victoria"
        );
        this.colorOrigen = "#F06292";
      } else if (this.depaOrigen === "CHALATENANGO") {
        this.list_muniOrigen.push(
          "Chalatenango",
          "Agua Caliente",
          "Arcatao",
          "Azacualpa",
          "Citalá",
          "Comalapa",
          "Concepción Quezaltepeque",
          "Dulce Nombre de María",
          "El Carrizal",
          "El Paraíso",
          "La Laguna",
          "La Palma",
          "La Reina",
          "Las Vueltas",
          "Nombre de Jesús",
          "Nueva Concepción",
          "Nueva Trinidad",
          "Ojos de Agua",
          "Potonico",
          "San Antonio de La Cruz",
          "San Antonio Los Ranchos",
          "San Fernando",
          "San Francisco Lempa",
          "San Francisco Morazán",
          "San Ignacio",
          "San Isidro Labrador",
          "San José Cancasque",
          "San José Las Flores",
          "San Luis del Carmen",
          "San Miguel de Mercedes",
          "San Rafael",
          "Santa Rita",
          "Tejutla"
        );
        this.colorOrigen = "#BA68C8";
      } else if (this.depaOrigen === "CUSCATLAN") {
        this.list_muniOrigen.push(
          "Cojutepeque",
          "Candelaria",
          "El Carmen",
          "El Rosario",
          "Monte San Juan",
          "Oratorio de Concepción",
          "San Bartolomé Perulapía",
          "San Cristóbal",
          "San José Guayabal",
          "San Pedro Perulapán",
          "San Rafael Cedros",
          "San Ramón",
          "Santa Cruz Analquito",
          "Santa Cruz Michapa",
          "Suchitoto",
          "Tenancingo"
        );
        this.colorOrigen = "#9575CD";
      } else if (this.depaOrigen === "LA LIBERTAD") {
        this.list_muniOrigen.push(
          "Santa Tecla",
          "Antiguo Cuscatlán",
          "Chiltiupán",
          "Ciudad Arce",
          "Colón",
          "Comasagua",
          "Huizúcar",
          "Jayaque",
          "Jicalapa",
          "Nuevo Cuscatlán",
          "Puerto de la Libertad",
          "Quezaltepeque",
          "Sacacoyo",
          "San José Villanueva",
          "San Juan Opico",
          "San Matías",
          "San Pablo Tacachico",
          "Talnique",
          "Tamanique",
          "Teotepeque",
          "Tepecoyo",
          "Zaragoza"
        );
        this.colorOrigen = "#7986CB";
      } else if (this.depaOrigen === "LA PAZ") {
        this.list_muniOrigen.push(
          "Zacatecoluca",
          "Cuyultitán",
          "El Rosario",
          "Jerusalén",
          "Mercedes La Ceiba",
          "Olocuilta",
          "Paraíso de Osorio",
          "San Antonio Masahuat",
          "San Emigdio",
          "San Francisco Chinameca",
          "San Juan Nonualco",
          "San Juan Talpa",
          "San Juan Tepezontes",
          "San Luis La Herradura",
          "San Luis Talpa",
          "San Miguel Tepezontes",
          "San Pedro Masahuat",
          "San Pedro Nonualco",
          "San Rafael Obrajuelo",
          "Santa María Ostuma",
          "Santiago Nonualco",
          "Tapalhauca"
        );
        this.colorOrigen = "#64B5F6";
      } else if (this.depaOrigen === "LA UNION") {
        this.list_muniOrigen.push(
          "La Unión",
          "Anamorós",
          "Bolívar",
          "Concepción de Oriente",
          "Conchagua",
          "El Carmen",
          "El Sauce",
          "Intipucá",
          "Lislique",
          "Meanguera del Golfo",
          "Nueva Esparta",
          "Pasaquina",
          "Polorós",
          "San Alejo",
          "San José La Fuente",
          "Santa Rosa de Lima",
          "Yayantique",
          "Yucuaiquín"
        );
        this.colorOrigen = "#4FC3F7";
      } else if (this.depaOrigen === "MORAZAN") {
        this.list_muniOrigen.push(
          "San Francisco Gotera",
          "Arambala",
          "Cacaopera",
          "Chilanga",
          "Corinto",
          "Delicias de Concepción",
          "El Divisadero",
          "El Rosario",
          "Gualococti",
          "Guatajiagua",
          "Joateca",
          "Jocoaitique",
          "Jocoro",
          "Lolotiquillo",
          "Meanguera",
          "Osicala",
          "Perquín",
          "San Carlos",
          "San Fernando",
          "San Isidro",
          "San Simón",
          "Sensembra",
          "Sociedad",
          "Torola",
          "Yamabal",
          "Yoloaiquín"
        );
        this.colorOrigen = "#4DD0E1";
      } else if (this.depaOrigen === "SAN MIGUEL") {
        this.list_muniOrigen.push(
          "San Miguel",
          "Carolina",
          "Chapeltique",
          "Chinameca",
          "Chirilagua",
          "Ciudad Barrios",
          "Comacarán",
          "El Tránsito",
          "Lolotique",
          "Moncagua",
          "Nueva Guadalupe",
          "Nuevo Edén de San Juan",
          "Quelepa",
          "San Antonio del Mosco",
          "San Gerardo",
          "San Jorge",
          "San Luis de La Reina",
          "San Rafael Oriente",
          "Sesori",
          "Uluazapa"
        );
        this.colorOrigen = "#4DB6AC";
      } else if (this.depaOrigen === "SAN SALVADOR") {
        this.list_muniOrigen.push(
          "San Salvador",
          "Aguilares",
          "Apopa",
          "Ayutuxtepeque",
          "Ciudad Delgado",
          "Cuscatancingo",
          "El Paisnal",
          "Guazapa",
          "Ilopango",
          "Mejicanos",
          "Nejapa",
          "Panchimalco",
          "Rosario de Mora",
          "San Marcos",
          "San Martín",
          "Santiago Texacuangos",
          "Santo Tomás",
          "Soyapango",
          "Tonacatepeque"
        );
        this.colorOrigen = "#81C784";
      } else if (this.depaOrigen === "SAN VICENTE") {
        this.list_muniOrigen.push(
          "San Vicente",
          "Apastepeque",
          "Guadalupe",
          "San Cayetano Istepeque",
          "San Esteban Catarina",
          "San Ildefonso",
          "San Lorenzo",
          "San Sebastián",
          "Santa Clara",
          "Santo Domingo",
          "Tecoluca",
          "Tepetitán",
          "Verapaz"
        );
        this.colorOrigen = "#AED581";
      } else if (this.depaOrigen === "SANTA ANA") {
        this.list_muniOrigen.push(
          "Santa Ana",
          "Candelaria de la Frontera",
          "Chalchuapa",
          "Coatepeque",
          "El Congo",
          "El Porvenir",
          "Masahuat",
          "Metapán",
          "San Antonio Pajonal",
          "San Sebastián Salitrillo",
          "Santa Rosa Guachipilín",
          "Santiago de la Frontera",
          "Texistepeque"
        );
        this.colorOrigen = "#DCE775";
      } else if (this.depaOrigen === "SONSONATE") {
        this.list_muniOrigen.push(
          "Sonsonate",
          "Acajutla",
          "Armenia",
          "Caluco",
          "Cuisnahuat",
          "Izalco",
          "Juayúa",
          "Nahulingo",
          "Nahuizalco",
          "Salcoatitán",
          "San Antonio del Monte",
          "San Julián",
          "Santa Catarina Masahuat",
          "Santa Isabel Ishuatán",
          "Santo Domingo de Guzmán",
          "Sonzacate"
        );
        this.colorOrigen = "#FFF176";
      } else if (this.depaOrigen === "USULUTAN") {
        this.list_muniOrigen.push(
          "Usulután",
          "Alegría",
          "Berlín",
          "California",
          "Concepción Batres",
          "El Triunfo",
          "Ereguayquín",
          "Estanzuelas",
          "Jiquilisco",
          "Jucuapa",
          "Jucuarán",
          "Mercedes Umaña",
          "Nueva Granada",
          "Ozatlán",
          "Puerto El Triunfo",
          "San Agustín",
          "San Buenaventura",
          "San Dionisio",
          "San Francisco Javier",
          "Santa Elena",
          "Santa María",
          "Santiago de María",
          "Tecapán"
        );
        this.colorOrigen = "#FFD54F";
      } else if (this.depaOrigen == "NO REQUERIDO") {
        this.list_muniOrigen.push("NO REQUERIDO");
      }
    },
    listaMunicipioDestino() {
      this.list_muniDestino = [];
      if (this.depaDestino === "AHUACHAPAN") {
        this.list_muniDestino.push(
          "Ahuachapán",
          "Apaneca",
          "Atiquizaya",
          "Concepción de Ataco",
          "El Refugio",
          "Guaymango",
          "Jujutla",
          "San Francisco Menéndez",
          "San Lorenzo",
          "San Pedro Puxtla",
          "Tacuba",
          "Turín"
        );
        this.colorDestino = "#E57373";
      } else if (this.depaDestino === "CABAÑAS") {
        this.list_muniDestino.push(
          "Sensuntepeque",
          "Cinquera",
          "Dolores",
          "Guacotecti",
          "Ilobasco",
          "Jutiapa",
          "San Isidro",
          "Tejutepeque",
          "Victoria"
        );
        this.colorDestino = "#F06292";
      } else if (this.depaDestino === "CHALATENANGO") {
        this.list_muniDestino.push(
          "Chalatenango",
          "Agua Caliente",
          "Arcatao",
          "Azacualpa",
          "Citalá",
          "Comalapa",
          "Concepción Quezaltepeque",
          "Dulce Nombre de María",
          "El Carrizal",
          "El Paraíso",
          "La Laguna",
          "La Palma",
          "La Reina",
          "Las Vueltas",
          "Nombre de Jesús",
          "Nueva Concepción",
          "Nueva Trinidad",
          "Ojos de Agua",
          "Potonico",
          "San Antonio de La Cruz",
          "San Antonio Los Ranchos",
          "San Fernando",
          "San Francisco Lempa",
          "San Francisco Morazán",
          "San Ignacio",
          "San Isidro Labrador",
          "San José Cancasque",
          "San José Las Flores",
          "San Luis del Carmen",
          "San Miguel de Mercedes",
          "San Rafael",
          "Santa Rita",
          "Tejutla"
        );
        this.colorDestino = "#BA68C8";
      } else if (this.depaDestino === "CUSCATLAN") {
        this.list_muniDestino.push(
          "Cojutepeque",
          "Candelaria",
          "El Carmen",
          "El Rosario",
          "Monte San Juan",
          "Oratorio de Concepción",
          "San Bartolomé Perulapía",
          "San Cristóbal",
          "San José Guayabal",
          "San Pedro Perulapán",
          "San Rafael Cedros",
          "San Ramón",
          "Santa Cruz Analquito",
          "Santa Cruz Michapa",
          "Suchitoto",
          "Tenancingo"
        );
        this.colorDestino = "#9575CD";
      } else if (this.depaDestino === "LA LIBERTAD") {
        this.list_muniDestino.push(
          "Santa Tecla",
          "Antiguo Cuscatlán",
          "Chiltiupán",
          "Ciudad Arce",
          "Colón",
          "Comasagua",
          "Huizúcar",
          "Jayaque",
          "Jicalapa",
          "Nuevo Cuscatlán",
          "Puerto de la Libertad",
          "Quezaltepeque",
          "Sacacoyo",
          "San José Villanueva",
          "San Juan Opico",
          "San Matías",
          "San Pablo Tacachico",
          "Talnique",
          "Tamanique",
          "Teotepeque",
          "Tepecoyo",
          "Zaragoza"
        );
        this.colorDestino = "#7986CB";
      } else if (this.depaDestino === "LA PAZ") {
        this.list_muniDestino.push(
          "Zacatecoluca",
          "Cuyultitán",
          "El Rosario",
          "Jerusalén",
          "Mercedes La Ceiba",
          "Olocuilta",
          "Paraíso de Osorio",
          "San Antonio Masahuat",
          "San Emigdio",
          "San Francisco Chinameca",
          "San Juan Nonualco",
          "San Juan Talpa",
          "San Juan Tepezontes",
          "San Luis La Herradura",
          "San Luis Talpa",
          "San Miguel Tepezontes",
          "San Pedro Masahuat",
          "San Pedro Nonualco",
          "San Rafael Obrajuelo",
          "Santa María Ostuma",
          "Santiago Nonualco",
          "Tapalhauca"
        );
        this.colorDestino = "#64B5F6";
      } else if (this.depaDestino === "LA UNION") {
        this.list_muniDestino.push(
          "La Unión",
          "Anamorós",
          "Bolívar",
          "Concepción de Oriente",
          "Conchagua",
          "El Carmen",
          "El Sauce",
          "Intipucá",
          "Lislique",
          "Meanguera del Golfo",
          "Nueva Esparta",
          "Pasaquina",
          "Polorós",
          "San Alejo",
          "San José La Fuente",
          "Santa Rosa de Lima",
          "Yayantique",
          "Yucuaiquín"
        );
        this.colorDestino = "#4FC3F7";
      } else if (this.depaDestino === "MORAZAN") {
        this.list_muniDestino.push(
          "San Francisco Gotera",
          "Arambala",
          "Cacaopera",
          "Chilanga",
          "Corinto",
          "Delicias de Concepción",
          "El Divisadero",
          "El Rosario",
          "Gualococti",
          "Guatajiagua",
          "Joateca",
          "Jocoaitique",
          "Jocoro",
          "Lolotiquillo",
          "Meanguera",
          "Osicala",
          "Perquín",
          "San Carlos",
          "San Fernando",
          "San Isidro",
          "San Simón",
          "Sensembra",
          "Sociedad",
          "Torola",
          "Yamabal",
          "Yoloaiquín"
        );
        this.colorDestino = "#4DD0E1";
      } else if (this.depaDestino === "SAN MIGUEL") {
        this.list_muniDestino.push(
          "San Miguel",
          "Carolina",
          "Chapeltique",
          "Chinameca",
          "Chirilagua",
          "Ciudad Barrios",
          "Comacarán",
          "El Tránsito",
          "Lolotique",
          "Moncagua",
          "Nueva Guadalupe",
          "Nuevo Edén de San Juan",
          "Quelepa",
          "San Antonio del Mosco",
          "San Gerardo",
          "San Jorge",
          "San Luis de La Reina",
          "San Rafael Oriente",
          "Sesori",
          "Uluazapa"
        );
        this.colorDestino = "#4DB6AC";
      } else if (this.depaDestino === "SAN SALVADOR") {
        this.list_muniDestino.push(
          "San Salvador",
          "Aguilares",
          "Apopa",
          "Ayutuxtepeque",
          "Ciudad Delgado",
          "Cuscatancingo",
          "El Paisnal",
          "Guazapa",
          "Ilopango",
          "Mejicanos",
          "Nejapa",
          "Panchimalco",
          "Rosario de Mora",
          "San Marcos",
          "San Martín",
          "Santiago Texacuangos",
          "Santo Tomás",
          "Soyapango",
          "Tonacatepeque"
        );
        this.colorDestino = "#81C784";
      } else if (this.depaDestino === "SAN VICENTE") {
        this.list_muniDestino.push(
          "San Vicente",
          "Apastepeque",
          "Guadalupe",
          "San Cayetano Istepeque",
          "San Esteban Catarina",
          "San Ildefonso",
          "San Lorenzo",
          "San Sebastián",
          "Santa Clara",
          "Santo Domingo",
          "Tecoluca",
          "Tepetitán",
          "Verapaz"
        );
        this.colorDestino = "#AED581";
      } else if (this.depaDestino === "SANTA ANA") {
        this.list_muniDestino.push(
          "Santa Ana",
          "Candelaria de la Frontera",
          "Chalchuapa",
          "Coatepeque",
          "El Congo",
          "El Porvenir",
          "Masahuat",
          "Metapán",
          "San Antonio Pajonal",
          "San Sebastián Salitrillo",
          "Santa Rosa Guachipilín",
          "Santiago de la Frontera",
          "Texistepeque"
        );
        this.colorDestino = "#DCE775";
      } else if (this.depaDestino === "SONSONATE") {
        this.list_muniDestino.push(
          "Sonsonate",
          "Acajutla",
          "Armenia",
          "Caluco",
          "Cuisnahuat",
          "Izalco",
          "Juayúa",
          "Nahulingo",
          "Nahuizalco",
          "Salcoatitán",
          "San Antonio del Monte",
          "San Julián",
          "Santa Catarina Masahuat",
          "Santa Isabel Ishuatán",
          "Santo Domingo de Guzmán",
          "Sonzacate"
        );
        this.colorDestino = "#FFF176";
      } else if (this.depaDestino === "USULUTAN") {
        this.list_muniDestino.push(
          "Usulután",
          "Alegría",
          "Berlín",
          "California",
          "Concepción Batres",
          "El Triunfo",
          "Ereguayquín",
          "Estanzuelas",
          "Jiquilisco",
          "Jucuapa",
          "Jucuarán",
          "Mercedes Umaña",
          "Nueva Granada",
          "Ozatlán",
          "Puerto El Triunfo",
          "San Agustín",
          "San Buenaventura",
          "San Dionisio",
          "San Francisco Javier",
          "Santa Elena",
          "Santa María",
          "Santiago de María",
          "Tecapán"
        );
        this.colorDestino = "#FFD54F";
      } else if (this.depaDestino === "NO REQUERIDO") {
        this.list_muniDestino.push("NO REQUERIDO");
      }
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    //Se verifica que si ya contiene fecha de contacto el boton este deshabilitado
    verificarFechaAsignacion() {
      if (
        this.fechaHoraAsignacion != null &&
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "Iris Regina Hernandez" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "Milton Vladimir Maldonado" &&
        this.$store.state.usuario.nombre != "Andrea Zaldivar" &&
        this.$store.state.usuario.nombre !=
          "JAZMIN ELIZABETH FLORES MENENDEZ" &&
        this.$store.state.usuario.nombre != "Wendy Escalante" &&
        this.$store.state.usuario.nombre != "Manuel Antonio Alonso" &&
        this.$store.state.usuario.nombre != "GLADYS ISABEL AVALOS" &&
        this.$store.state.usuario.rol != "Team Leader Cabina"
      ) {
        this.textFieldAsignacionDisabled = true;
      } else {
        this.textFieldAsignacionDisabled = false;
      }
    },
    verificarFechaContacto() {
      if (this.$store.state.usuario.rol == "Inspector") {
        this.btnContacto = this.fechaHoraContacto != null ? true : false;
        this.textFieldContactoDisabled = false;
      } else if (
        this.fechaHoraContacto != null &&
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "Iris Regina Hernandez" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "Milton Vladimir Maldonado" &&
        this.$store.state.usuario.nombre != "Andrea Zaldivar" &&
        this.$store.state.usuario.nombre !=
          "JAZMIN ELIZABETH FLORES MENENDEZ" &&
        this.$store.state.usuario.nombre != "Wendy Escalante" &&
        this.$store.state.usuario.nombre != "Manuel Antonio Alonso" &&
        this.$store.state.usuario.nombre != "GLADYS ISABEL AVALOS" &&
        this.$store.state.usuario.rol != "Team Leader Cabina"
      ) {
        this.btnContacto = true;
        this.textFieldContactoDisabled = true;
      } else {
        this.btnContacto = false;
        this.textFieldContactoDisabled = false;
      }
    },
    verificarFinalizado() {
      if (
        this.termino != null &&
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "Iris Regina Hernandez" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "Milton Vladimir Maldonado" &&
        this.$store.state.usuario.nombre != "Andrea Zaldivar" &&
        this.$store.state.usuario.nombre !=
          "JAZMIN ELIZABETH FLORES MENENDEZ" &&
        this.$store.state.usuario.nombre != "Wendy Escalante" &&
        this.$store.state.usuario.nombre != "Manuel Antonio Alonso" &&
        this.$store.state.usuario.nombre != "GLADYS ISABEL AVALOS" &&
        this.$store.state.usuario.rol != "Team Leader Cabina"
      ) {
        this.btnFinalizado = true;
        this.textFieldTerminoDisabled = true;
      } else {
        this.btnFinalizado = false;
        this.textFieldTerminoDisabled = false;
      }
    },
    verificarCierreFinalizado() {
      if (
        this.fechaHoraCierreAsistencia != null &&
        this.$store.state.usuario.nombre != "IVAN GRACIAS" &&
        this.$store.state.usuario.nombre != "Iris Regina Hernandez" &&
        this.$store.state.usuario.nombre != "JOSE ATILIO HERNANDEZ" &&
        this.$store.state.usuario.nombre != "Milton Vladimir Maldonado" &&
        this.$store.state.usuario.nombre != "Andrea Zaldivar" &&
        this.$store.state.usuario.nombre !=
          "JAZMIN ELIZABETH FLORES MENENDEZ" &&
        this.$store.state.usuario.nombre != "Wendy Escalante" &&
        this.$store.state.usuario.nombre != "Manuel Antonio Alonso" &&
        this.$store.state.usuario.nombre != "GLADYS ISABEL AVALOS" &&
        this.$store.state.usuario.rol != "Team Leader Cabina"
      ) {
        this.btnCierreFinalizado = true;
        this.textFieldCierreDisabled = true;
      } else {
        this.btnCierreFinalizado = false;
        this.textFieldCierreDisabled = false;
      }
    },
    verificaCostoServicio() {
      if (this.costoServicio > 0 || this.costoServicio < 0) {
        this.costoValid = true;
      } else if (this.costoServicio == 0) {
        this.costoValid = false;
      }
    },
    //Cada vez que se haga una nueva asistencia de FUTURO se enviara un correo, haciendo una peticion al servidor
    //se enviara la cartera, correos, cuerpo del mesaje(datos)
    enviarCorreo() {
      let me = this;
      if (me.tipoServicio != "CONEXION" && me.tipoAsistencia != "INFORMATIVO") {
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };

        axios.put(
          "api/Cabinas/sendEmail/",
          {
            cartera: me.cartera,
            titularPoliza: me.titularPoliza,
            nombreConductor: me.nombreConductor,
            placa: me.placa,
            poliza: me.poliza,
            marca: me.marca,
            modelo: me.modelo,
            color: me.color,
            año: me.año,
            tipoAsistencia: me.tipoAsistencia,
            comDireccionSiniestro: me.comDireccionSiniestro,
          },
          configuracion
        );
      }
    },
    //Lisar reincidencia de placa
    listarReincidencia() {
      this.btnSheetReincidencia = false;
      this.sheetReincidencia = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .get(
          "api/Cabinas/ReincidenciaxPlacaViewModel/" + this.placa,
          configuracion
        )
        .then(function (response) {
          me.reincidencias = response.data;
          me.contadorReincidencias = 0;
          for (var i = 0; i < me.reincidencias.length; i++) {
            me.contadorReincidencias++;
          }
          if (me.contadorReincidencias == 0) {
            me.mensajeReincidencia =
              "No hay más asistestencias de la placa: " + me.placa;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    asignarUsuarioEnviadoPor() {
      this.enviadoPor = this.$store.state.usuario.nombre;
    },
    asignarNombreAjustadorCargo() {
      this.ajustador_cargo = this.$store.state.usuario.nombre;
    },
    //////////////////////////// ALMACENAMIENTO DE IMAGENES
    cargarArchivos() {
      this.imagenesPreview = [];
      this.filesDescargadasAudios = [];
      this.filesPDF = [];
      this.bandera = 1;
      this.mostrarBotonDescargar = false;
      if (this.filesCargadas.length > 0) {
        this.disabledCargarArchivos = false;
        for (var i = 0; i < this.filesCargadas.length; i++) {
          if (this.filesCargadas[i].type == "audio/mpeg") {
            this.filesDescargadasAudios.push({
              url: URL.createObjectURL(this.filesCargadas[i]),
            });
          } else {
            if (this.filesCargadas[i].type == "application/pdf") {
              this.filesPDF.push({
                url: URL.createObjectURL(this.filesCargadas[i]),
              });
            } else {
              this.imagenesPreview.push({
                url: URL.createObjectURL(this.filesCargadas[i]),
              });
            }
          }
        }
      } else {
        this.disabledCargarArchivos = true;
      }
    },
    subirArchivos() {
      let me = this;
      me.overlayArchivos = true;
      for (var i = 0; i < me.filesCargadas.length; i++) {
        const storeRef = storage.child(
          me.numeroAsistencia + "/" + me.filesCargadas[i].name
        );
        const subir = storeRef
          .put(me.filesCargadas[i])
          .then(function (snapshot) {
            me.filesCargadas = [];
            me.imagenesPreview = [];
            me.filesDescargadasAudios = [];
            me.filesPDF = [];
            if (i + 1 == me.filesCargadas.length) {
            } else {
              me.snackArchivoSubido = true;
              me.overlayArchivos = false;
              me.cargarArchivos();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    contarArchivosDescarga() {
      let me = this;
      if (me.numeroAsistencia == "") {
        return;
      }
      me.overlayArchivos = true;
      const contador = storage
        .child(me.numeroAsistencia)
        .listAll()
        .then(function (listAll) {
          var tamañoLista = listAll.items.length;
          for (var i = 0; i < tamañoLista; i++) {
            var auxPath = listAll.items[i].location.path;
            var splitPath = auxPath.split("/");
            me.listaArchivos[i] = splitPath[2];
          }
          tamañoLista = 0;
          auxPath = null;
          splitPath = [];
          me.descargarArchivos();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargarArchivos() {
      let me = this;
      me.imagenesPreview = [];
      me.filesDescargadasAudios = [];
      me.filesPDF = [];
      me.bandera = 0;
      me.mostrarBotonDescargar = true;
      for (let i = 0; i < me.listaArchivos.length; i++) {
        var auxListaArchivos = me.listaArchivos[i];
        let splitListaArchivos = auxListaArchivos.split(".");
        //let lengthSplitListArchivos = splitListaArchivos.length;
        const storeRefUrl = storage
          .child(me.numeroAsistencia + "/" + me.listaArchivos[i])
          .getDownloadURL()
          .then(function (url) {
            switch (splitListaArchivos[splitListaArchivos.length - 1]) {
              case "jpg":
              case "JPG":
              case "png":
              case "PNG":
              case "jpeg":
              case "JPEG":
              case "tiff":
              case "TIFF":
              case "bmp":
              case "BMP":
                me.imagenesPreview.push({
                  name: me.listaArchivos[i],
                  url: url,
                });
                break;
              case "mp3":
              case "wav":
                me.filesDescargadasAudios.push({
                  name: me.listaArchivos[i],
                  url: url,
                });
                break;
              case "pdf":
                me.filesPDF.push({
                  name: me.listaArchivos[i],
                  url: url,
                });
                break;
              default:
                break;
            }
          })
          .catch(function (error) {
            console.log("ERROR URL", error);
          });
      }
      me.overlayArchivos = false;
    },
    verImagen(item) {
      this.dialogVerImagen = true;
      //mostrarlo en el dialog
      this.imagenDialog = item.url;
      this.nombreImagen = item.name;
      if (this.bandera == 1) {
        this.banderaEliminar = false;
      } else {
        this.banderaEliminar = true;
      }
    },
    eliminarImagen() {
      let me = this;
      me.dialogVerImagen = false;
      me.dialogBorrarImagen = false;
      me.overlayArchivos = true;
      const borrar = storage
        .child(me.numeroAsistencia + "/" + me.nombreImagen)
        .delete()
        .then(function () {
          me.overlayArchivos = false;
          me.snackArchivoEliminado = true;
          me.listaArchivos = [];
          me.contarArchivosDescarga();
        })
        .catch(function (error) {
          console.log(error);
          me.overlayArchivos = false;
        });
    },
    descargarZIP() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let imagenes = zip.folder("imagenes");
      me.overlayArchivos = true;

      for (var i = 0; i < me.imagenesPreview.length; i++) {
        let nombre = me.imagenesPreview[i].name;
        let url = me.imagenesPreview[i].url;
        let contentP = me.downloadURLPromise(url);
        imagenes.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, me.numeroAsistencia + "_imagenes" + ".zip");
        me.overlayArchivos = false;
      });
    },
    descargarZipAudios() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let audios = zip.folder("audios");
      me.overlayArchivos = true;

      for (var i = 0; i < me.filesDescargadasAudios.length; i++) {
        let nombre = me.filesDescargadasAudios[i].name;
        let url = me.filesDescargadasAudios[i].url;
        let contentP = me.downloadURLPromise(url);
        audios.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, me.numeroAsistencia + "_audios" + ".zip");
        me.overlayArchivos = false;
      });
    },
    descargarPDF() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let audios = zip.folder("pdfs");
      me.overlayArchivos = true;

      for (var i = 0; i < me.filesPDF.length; i++) {
        let nombre = me.filesPDF[i].name;
        let url = me.filesPDF[i].url;
        let contentP = me.downloadURLPromise(url);
        audios.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        FileSaver.saveAs(content, me.numeroAsistencia + "_file" + ".zip");
        me.overlayArchivos = false;
      });
    },
    downloadURLPromise(url) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.onreadystatechange = function (evt) {
          if (xhr.readyState === 4) {
            if (xhr.status == 200) {
              resolve(xhr.response);
            } else {
              reject(new Error("Error" + ":" + xhr.status));
            }
          }
        };
        xhr.send();
      });
    },
    async notificacionTelegram(item) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      await axios
        .get("api/DetallexProveedores/Listar", configuracion)
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            if (item.proveedor == response.data[i].nombre) {
              me.chatIdproveedor = response.data[i].chatIdTelegram;
              break;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      var mensaje =
        "Numero Asistencia: " +
        item.numeroAsistencia +
        "%0A" +
        "Fecha: " +
        item.fechaHoraActual +
        "%0A" +
        "Cuenta: " +
        "**" +
        item.cartera +
        "**" +
        "%0A" +
        "Conductor: " +
        item.nombreConductor +
        "%0A" +
        "Asegurado: " +
        "**" +
        item.titularPoliza +
        "**" +
        "%0A" +
        "Poliza: " +
        item.poliza +
        "%0A" +
        "Placa: " +
        "**" +
        item.placa +
        "**" +
        "%0A" +
        "Marca: " +
        item.marca +
        "%0A" +
        "Modelo: " +
        item.modelo +
        "%0A" +
        "Color: " +
        item.color +
        "%0A" +
        "Uso: " +
        item.uso +
        "%0A" +
        "Año: " +
        item.año +
        "%0A" +
        "Departamento: " +
        item.depaSiniestro +
        "%0A" +
        "Municipio: " +
        item.muniSiniestro +
        "%0A" +
        "Dirección: " +
        item.comDireccionSiniestro +
        "%0A" +
        "Dirección Destino: " +
        item.comDireccionDestino +
        "%0A" +
        "Tipo De Asistencia: " +
        "**" +
        item.tipoAsistencia +
        "**" +
        "%0A" +
        "Técnico Asignado: " +
        "**" +
        item.proveedor +
        "**" +
        "%0A" +
        "Causa: " +
        item.causa;

      //ENVIO DE NOTIFICACION AL GRUPO
      await axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatId +
            "&text=" +
            mensaje
        )
        .then((response) => {
          console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });

      await axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatIdproveedor +
            "&text=" +
            mensaje
        )
        .then((response) => {
          console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    autoCompleteDatosAjustador() {
      if (
        this.tipoAsistencia != "AJUSTE" &&
        this.tipoAsistencia != "INSPECCION ON LINE"
      ) {
        this.expedienteAssa = "NO APLICA";
        this.inspeccionInSituVirtual = "NO APLICA";
        this.rapiAssaAsegurado = "NO APLICA";
        this.rapiAssaTercero = "NO APLICA";
        this.motivoNoUsoRapiassa = "NO APLICA";
        this.usoGruaAsegurado = "NO APLICA";
        this.usoGruaTercero = "NO APLICA";
        this.tallerAsegurado = "NO APLICA";
        this.tallerTercero = "NO APLICA";
        this.estadoVirtual = "NO APLICA";
      } else {
        this.expedienteAssa = "";
        this.inspeccionInSituVirtual = "";
        this.rapiAssaAsegurado = "";
        this.rapiAssaTercero = "";
        this.motivoNoUsoRapiassa = "";
        this.usoGruaAsegurado = "";
        this.usoGruaTercero = "";
        this.tallerAsegurado = "";
        this.tallerTercero = "";
        this.estadoVirtual = "";
      }
    },
    activarNotificacionPlaca() {
      this.$toast.info(
        "Año del vehículo es menor a 2007 se solicita autorización",
        {
          position: "top-left",
          closeOnClick: false,
          draggable: false,
          timeout: 10000,
        }
      );
    },
    //FORMATOS
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.highlight-row {
  background-color: rgba(255, 166, 0, 0.35);
  color: #333;
}
.highlight-row-programada {
  background-color: #ff7272;
  color: #333;
}
.default-row {
  box-shadow: 0 -1px 0.5px -1px rgba(0, 0, 0, 1),
    0 1px 0.5px -1px rgba(0, 0, 0, 1);
}
.default-row:hover {
  background-color: rgb(237, 237, 237);
}

.buttons {
  margin: 10%;
  text-align: center;
}

.btn-hover {
  width: 150px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  margin: 20px;
  height: 36px;
  text-align: center;
  border: none;
  background-size: 300% 100%;

  border-radius: 5px;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:hover {
  background-position: 100% 0;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:focus {
  outline: none;
}

.btn-hover.color-4 {
  background-image: linear-gradient(
    to right,
    #fc6076,
    #ff9a44,
    #ef9d43,
    #e75516
  );
  box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);
}
.scrollable {
  overflow: hidden;
  overflow-y: scroll;
  height: calc(100vh - 20px);
}

.no-padding-and-margin {
  margin: 0 auto;
  padding: 0;
}
</style>
